import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
  Box, Container, Grid, Paper, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Chip, Button, TextField,
  CircularProgress, Alert, Dialog, DialogTitle, DialogContent,
  DialogActions, IconButton, Select, MenuItem, FormControl, InputLabel,
  Tooltip, Snackbar, Avatar, Tab, Tabs, Badge, Divider, InputAdornment, Collapse, List, ListItem, ListItemText, LinearProgress, Popover, Switch, FormControlLabel, Menu, ListItemIcon,
} from '@mui/material';
import CheckCircleIcon   from '@mui/icons-material/CheckCircle';
import CancelIcon        from '@mui/icons-material/Cancel';
import ReplayIcon        from '@mui/icons-material/Replay';
import EventBusyIcon     from '@mui/icons-material/EventBusy';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import RefreshIcon       from '@mui/icons-material/Refresh';
import EditIcon          from '@mui/icons-material/Edit';
import LockResetIcon     from '@mui/icons-material/LockReset';
import PeopleIcon        from '@mui/icons-material/People';
import PersonAddIcon     from '@mui/icons-material/PersonAdd';
import VerifiedIcon      from '@mui/icons-material/Verified';
import MapIcon           from '@mui/icons-material/Map';
import DashboardIcon     from '@mui/icons-material/Dashboard';
import AssignmentIcon    from '@mui/icons-material/Assignment';
import LogoutIcon        from '@mui/icons-material/Logout';
import HomeOutlinedIcon          from '@mui/icons-material/HomeOutlined';
import AppsOutlinedIcon          from '@mui/icons-material/AppsOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import KeyboardArrowDownIcon     from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon        from '@mui/icons-material/Search';
import ToggleOnIcon      from '@mui/icons-material/ToggleOn';
import ToggleOffIcon     from '@mui/icons-material/ToggleOff';
import VisibilityIcon    from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PictureAsPdfIcon  from '@mui/icons-material/PictureAsPdf';
import FingerprintIcon   from '@mui/icons-material/Fingerprint';
import LocationOnIcon    from '@mui/icons-material/LocationOn';
import ContactPhoneIcon  from '@mui/icons-material/ContactPhone';
import SaveIcon          from '@mui/icons-material/Save';
import HistoryIcon       from '@mui/icons-material/History';
import BlockIcon         from '@mui/icons-material/Block';
import PaymentIcon       from '@mui/icons-material/Payment';
import BusinessIcon      from '@mui/icons-material/Business';
import AddCircleIcon     from '@mui/icons-material/AddCircle';
import SwapHorizIcon     from '@mui/icons-material/SwapHoriz';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import SettingsIcon      from '@mui/icons-material/Settings';
import VpnKeyIcon        from '@mui/icons-material/VpnKey';
import PendingIcon       from '@mui/icons-material/HourglassEmpty';
import ErrorIcon         from '@mui/icons-material/ErrorOutline';
import PersonOffIcon     from '@mui/icons-material/PersonOff';
import BadgeIcon         from '@mui/icons-material/Badge';
import PhotoCameraIcon   from '@mui/icons-material/PhotoCamera';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PrintIcon         from '@mui/icons-material/Print';
import DownloadIcon      from '@mui/icons-material/Download';
import StorefrontIcon    from '@mui/icons-material/Storefront';
import RedeemIcon        from '@mui/icons-material/Redeem';
import SettingsInputAntennaIcon from '@mui/icons-material/SettingsInputAntenna';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import NotificationsIcon    from '@mui/icons-material/Notifications';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import LockOutlinedIcon     from '@mui/icons-material/LockOutlined';
import LockOpenIcon         from '@mui/icons-material/LockOpen';
import RestoreIcon          from '@mui/icons-material/Restore';
import CalculateIcon        from '@mui/icons-material/Calculate';
import MarkEmailReadIcon    from '@mui/icons-material/MarkEmailRead';
import ForwardToInboxIcon   from '@mui/icons-material/ForwardToInbox';
import TabAliados        from '../components/admin/TabAliados';
import TabIntegraciones  from '../components/admin/TabIntegraciones';
import CooperativaWizardModal from '../components/admin/CooperativaWizardModal';
import VerificadorDocumento from '../components/VerificadorDocumento';
import TabCodigosCanje       from '../components/admin/TabCodigosCanje';
import EditarAfiliadoDialog  from '../components/EditarAfiliadoDialog';
import { emitirCodigoParaSolicitud } from '../services/codigosCanjeApi';
import { esCedulaTest } from '../services/testAfiliadosApi';

import {
  PieChart, Pie, Cell, Tooltip as RTooltip, Legend, ResponsiveContainer,
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
} from 'recharts';
import {
  logout, getUser, isLogged, isAdmin,
  puedeVerTab, esOrientador, puedeAprobarRechazar, puedeEliminarCompleto, esSuperAdmin,
  getUsuarios, getUsuarioById, getKpis, getRolesDisponibles,
  getAfiliacionesPendientes, aprobarAfiliacion, rechazarAfiliacion,
  reevaluarAfiliacion, eliminarSesionOrientacion, eliminarAfiliacionCompleta, reasignarCooperativa,
  activarAccesoAfiliado,
  getInfoReactivacion, reactivarSolicitudAbandonada, recalcularEstadoSolicitud, reenviarConfirmacionUsuario, confirmarEmailUsuario,
  cambiarEstadoUsuario, cambiarRolUsuario, actualizarRolesUsuario, cambiarPasswordUsuario,
  getDetalleAfiliado, editarUsuario, getUrlFirmadaDocumento,
  getDocumentosAfiliado, revisarDocumento, getSesionesAfiliado, registrarSesionOrientacion, gestionarSesion,
  getAuditoriaAfiliados, getAuditoriaUsuarios, getAccionesAuditoria,
  getListaExclusion, agregarExclusion, desactivarExclusion,
  getConfigPasarela, updateConfigPasarela,
  getCooperativasAdmin, crearCooperativa, actualizarCooperativa, cambiarEstadoCooperativa,
  aprobarDocumentosCooperativa,
  getNotificaciones, getNotificacionesCount,
  marcarNotificacionLeida, marcarTodasNotificacionesLeidas,
  getCatalogoAplicaciones, getAppsUsuarioAdmin, otorgarAppUsuario, revocarAppUsuario,
  getListaPagosInscripcion, confirmarPagoManual,
} from '../services/authApi';
import { getDepartamentos, getMunicipios } from '../services/ecolabApi';
import {
  generarCarnetUsuario, subirFotoUsuario, eliminarFotoUsuario,
  getCarnetActivoUsuario,
} from '../services/perfilApi';
import DialogCarnet, {
  CarnetCardConSelector, descargarCarnetPng, imprimirCarnet,
} from '../components/DialogCarnet';
import { urlContratoPDF } from '../utils/generarContratoPDF';
import { descargarContratoCapellanesPDF } from '../utils/generarContratoCapellanesPDF';
import MapaColombiaAdmin from './MapaColombiaAdmin';
import VisorDocumentoSeguro  from '../components/VisorDocumentoSeguro';
import AgendarSesionDialog   from '../components/AgendarSesionDialog';
import CrearUsuarioDialog    from '../components/CrearUsuarioDialog';
import VistaOrientador       from '../components/VistaOrientador';

// ── Helpers ──────────────────────────────────────────────────────────────
const fmt = d => d ? new Date(d).toLocaleDateString('es-CO', { day:'2-digit', month:'2-digit', year:'numeric' }) : '—';
const fmtHora = d => d ? new Date(d).toLocaleString('es-CO', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }) : 'Nunca';

const ROLE_COLORS = {
  SuperAdmin: 'error', AdminConfederacion:'warning', AdminFederacion:'warning',
  AdminCooperativa:'info', Auditor:'error', Validador:'warning',
  Orientador:'secondary', Afiliado:'success', Capellan:'secondary',
  Directivo:'primary', Visitante:'default',
};

// Tabs con permisos requeridos — se filtran dinámicamente según roles del usuario
const TABS_CONFIG = [
  { id:'dashboard',    label:'Dashboard',   icon:<DashboardIcon fontSize="small"/>,  roles:['SuperAdmin','AdminConfederacion','AdminFederacion','AdminCooperativa','Auditor','Validador'] },
  { id:'usuarios',     label:'Usuarios',    icon:<PeopleIcon fontSize="small"/>,     roles:['SuperAdmin','AdminConfederacion'] },
  { id:'afiliaciones', label:'Solicitudes', icon:<AssignmentIcon fontSize="small"/>, roles:['SuperAdmin','AdminConfederacion','AdminFederacion','AdminCooperativa','Auditor','Validador','Orientador'] },
  { id:'aliados',      label:'Aliados',     icon:<StorefrontIcon fontSize="small"/>, roles:['SuperAdmin','AdminConfederacion','AdminFederacion','Auditor'] },
  { id:'canje',        label:'Códigos canje', icon:<RedeemIcon fontSize="small"/>,   roles:['SuperAdmin','AdminConfederacion','AdminFederacion','AdminCooperativa','Auditor','Validador'] },
  { id:'mapa',         label:'Mapa',        icon:<MapIcon fontSize="small"/>,        roles:['SuperAdmin','AdminConfederacion','AdminFederacion','AdminCooperativa','Auditor'] },
  { id:'auditoria',    label:'Auditoría',   icon:<HistoryIcon fontSize="small"/>,    roles:['SuperAdmin','AdminConfederacion','AdminFederacion','AdminCooperativa','Auditor'] },
  { id:'exclusion',    label:'Lista Exclusión', icon:<BlockIcon fontSize="small"/>,   roles:['SuperAdmin','AdminConfederacion'] },
  { id:'pagos',        label:'Pagos',           icon:<PaymentIcon fontSize="small"/>,  roles:['SuperAdmin','AdminConfederacion','AdminFederacion','AdminCooperativa','Auditor'] },
  { id:'cooperativas', label:'Cooperativas',    icon:<BusinessIcon fontSize="small"/>, roles:['SuperAdmin','AdminConfederacion','AdminFederacion'] },
  { id:'accesos',      label:'Accesos apps',    icon:<LockOutlinedIcon fontSize="small"/>, roles:['SuperAdmin','AdminConfederacion','AdminFederacion'] },
  { id:'pasarela',     label:'Pasarela Pagos', icon:<SettingsIcon fontSize="small"/>,  roles:['SuperAdmin','AdminConfederacion'] },
  { id:'integraciones',label:'Integraciones', icon:<SettingsInputAntennaIcon fontSize="small"/>, roles:['SuperAdmin'] },
];

const KpiCard = ({ icon, label, value, sub, color = '#2e7d32', bg = '#e8f5e9' }) => (
  <Paper elevation={0} sx={{ p:2.5, borderRadius:2.5, border:'1px solid #e0e0e0', height:'100%' }}>
    <Box sx={{ display:'flex', alignItems:'flex-start', justifyContent:'space-between' }}>
      <Box>
        <Typography variant="caption" sx={{ color:'#888', fontWeight:600, textTransform:'uppercase', letterSpacing:'0.06em' }}>
          {label}
        </Typography>
        <Typography sx={{ fontWeight:800, fontSize:'2rem', color, lineHeight:1.1, mt:0.5 }}>
          {value ?? <CircularProgress size={24} />}
        </Typography>
        {sub && <Typography variant="caption" sx={{ color:'#aaa' }}>{sub}</Typography>}
      </Box>
      <Box sx={{ p:1.2, borderRadius:2, background:bg }}>
        {React.cloneElement(icon, { sx: { color, fontSize:28 } })}
      </Box>
    </Box>
  </Paper>
);

// ── Sidebar nav ──────────────────────────────────────────────────────────
// ════════════════════════════════════════════════════════════════════════
export default function AdminDashboard() {
  const user = getUser();

  // Filtrar tabs según roles del usuario
  const TABS = TABS_CONFIG.filter(t =>
    (user?.roles || []).some(r => t.roles.includes(r))
  );

  const [tab, setTab] = useState(() => {
    // El orientador puro arranca en solicitudes
    if (esOrientador()) return 'afiliaciones';
    return 'dashboard';
  });
  const [kpis, setKpis]         = useState(null);
  const [usuarios, setUsuarios] = useState([]);
  const [totalUs, setTotalUs]   = useState(0);
  const [pageUs, setPageUs]     = useState(1);
  const [buscar, setBuscar]     = useState('');
  const [filtroRol, setFiltroRol] = useState('');
  const [filtroActivo, setFiltroActivo] = useState('');
  const [filtroCarnet, setFiltroCarnet] = useState('');
  // Valores locales del input — evitan re-render al escribir
  const [buscarInput,   setBuscarInput]   = useState('');
  const [afBuscarInput, setAfBuscarInput] = useState('');
  const buscarTimer    = useRef(null);
  const afBuscarTimer  = useRef(null);
  const buscarRef      = useRef(null);
  const afBuscarRef    = useRef(null);
  const [roles, setRoles]       = useState([]);
  const [afiliaciones, setAfiliaciones] = useState([]);
  const [totalAf, setTotalAf]   = useState(0);
  const [loading, setLoading]   = useState(false);
  const [snack, setSnack]       = useState({ open:false, msg:'', sev:'success' });
  // Menú de usuario y notificaciones se anclan por coordenadas: <Header/> se re-monta en cada
  // render y el nodo usado como anchorEl queda desconectado (MUI lo pinta arriba a la izquierda).
  const [userMenuAnchor, setUserMenuAnchor] = useState(null); // { top, left } | null
  const posAncla = (el) => { const r = el.getBoundingClientRect(); return { top: r.bottom + 6, left: r.right }; };

  // Diálogos
  const [dlgEditar,    setDlgEditar]    = useState({ open:false, user:null, tab:'datos' });
  const [dlgDetalle,   setDlgDetalle]   = useState({ open:false, id:null, data:null, loading:false });
  // Edición administrativa del afiliado (solo SuperAdmin). Se abre desde el modal
  // de detalle del afiliado. Al guardar refresca el modal padre para ver los cambios.
  const [dlgEditarAfiliado, setDlgEditarAfiliado] = useState({ open:false, afiliado:null });
  const [dlgCarnet,    setDlgCarnet]    = useState({ open:false, carnet:null, fotoUrl:null });
  const [generandoCarnet, setGenerandoCarnet] = useState(null); // userId actualmente generando
  const [dlgSelectCoopCarnet, setDlgSelectCoopCarnet] = useState({ open: false, user: null, opciones: [] });

  // Filtros de solicitudes de afiliación
  const [afBuscar,     setAfBuscar]     = useState('');
  const [afEstado,     setAfEstado]     = useState('');
  const [afModalidad,  setAfModalidad]  = useState('');
  const [afDepto,      setAfDepto]      = useState('');
  const [afMuniId,     setAfMuniId]     = useState('');
  const [afDeptos,     setAfDeptos]     = useState([]);
  const [afMunis,      setAfMunis]      = useState([]);
  const [afFechaDesde, setAfFechaDesde] = useState('');
  const [afFechaHasta, setAfFechaHasta] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null);
  const [pageAf,       setPageAf]       = useState(1);
  const [totalAf2,     setTotalAf2]     = useState(0);
  const [pdfCapLoading,  setPdfCapLoading]  = useState(false);
  const [docUrlLoading,  setDocUrlLoading]  = useState(false);
  const [visorDoc, setVisorDoc] = useState({ open: false, url: '', titulo: '', nombre: '' });
  const [docsAfiliado,   setDocsAfiliado]   = useState(null);
  const [sesionesAf,     setSesionesAf]     = useState([]);
  const [dlgSesion,      setDlgSesion]      = useState(false);
  const [sesionForm,     setSesionForm]     = useState({ fechaSesion:'', duracionMin:'', medioSesion:'WhatsApp', urlGrabacion:'', notasAdmin:'', estado:'REALIZADA' });
  const [revisandoDoc,   setRevisandoDoc]   = useState(null);
  // Guarda también nombre+email del usuario objetivo para evitar que el admin se
  // confunda y crea que está cambiando su propia contraseña (el navegador autofill
  // con type=password puede sugerir las credenciales guardadas del admin logueado).
  const [dlgPass,   setDlgPass]     = useState({ open:false, id:null, val:'', nombre:'', email:'' });
  const [verPass,   setVerPass]     = useState(false);
  const [dlgRechazar, setDlgRechazar] = useState({ open:false, id:null, motivo:'' });
  const [dlgReevaluar, setDlgReevaluar] = useState({ open:false, id:null, nombre:'', motivo:'' });
  const DLG_REACTIVAR_INIT = { open:false, modo:'reactivar', id:null, nombre:'', motivo:'', info:null, loading:false, enviando:false };
  const [dlgReactivar, setDlgReactivar] = useState(DLG_REACTIVAR_INIT);
  const [correoAccion, setCorreoAccion] = useState(null); // id de usuario con acción de correo en curso
  const [dlgEliminarSesion, setDlgEliminarSesion] = useState({ open:false, id:null, nombre:'', motivo:'' });
  const [dlgActivarAcceso,  setDlgActivarAcceso]  = useState({ open:false, id:null, nombre:'', motivo:'' });
  const [activandoAcceso,   setActivandoAcceso]   = useState(false);
  const [dlgEliminarCompleto, setDlgEliminarCompleto] = useState({ open:false, id:null, nombre:'', motivo:'' });
  const [dlgReasignarCoop, setDlgReasignarCoop] = useState({ open:false, id:null, nombre:'', cooperativaId:'', motivo:'' });

  // Auditoría
  const [auditLogs,       setAuditLogs]       = useState([]);
  const [auditTotal,      setAuditTotal]       = useState(0);
  const [auditPage,       setAuditPage]        = useState(1);
  const [auditLoading,    setAuditLoading]     = useState(false);
  const [auditTipo,       setAuditTipo]        = useState('afiliados'); // afiliados | usuarios
  const [auditAccion,     setAuditAccion]      = useState('');
  const [auditBuscar,     setAuditBuscar]      = useState('');
  const [auditFechaDesde, setAuditFechaDesde]  = useState('');
  const [auditFechaHasta, setAuditFechaHasta]  = useState('');
  const AUDIT_PAGE_SIZE = 25;
  const [auditAcciones, setAuditAcciones] = useState({ afiliado:[], usuario:[] });

  // Lista de exclusión
  const [exclusiones,      setExclusiones]      = useState([]);
  const [exclusionTotal,   setExclusionTotal]   = useState(0);
  const [exclusionPage,    setExclusionPage]    = useState(1);
  const [exclusionLoading, setExclusionLoading] = useState(false);
  const [exclusionBuscar,  setExclusionBuscar]  = useState('');
  const [dlgExclusion,     setDlgExclusion]     = useState({ open:false, doc:'', nombres:'', apellidos:'', motivo:'' });
  const EXCL_PAGE_SIZE = 25;

  // Pagos de inscripción
  const [pagos,          setPagos]          = useState([]);
  const [pagosTotal,     setPagosTotal]     = useState(0);
  const [pagosTotalMonto,setPagosTotalMonto]= useState(0);
  const [pagosPage,      setPagosPage]      = useState(1);
  const [pagosLoading,   setPagosLoading]   = useState(false);
  const [pagosEstado,    setPagosEstado]    = useState('');
  const [pagosBuscar,    setPagosBuscar]    = useState('');
  const [pagosFechaDesde,setPagosFechaDesde]= useState('');
  const [pagosFechaHasta,setPagosFechaHasta]= useState('');
  const [dlgPagoManual,  setDlgPagoManual] = useState({ open:false, id:null, nombre:'', ref:'', monto:150000, notas:'' });
  const PAGOS_PAGE_SIZE = 25;

  // Cooperativas
  const [coops,           setCoops]           = useState([]);
  const [coopsLoading,    setCoopsLoading]     = useState(false);
  const [dlgCoop,         setDlgCoop]         = useState({ open:false, modo:'crear', data:{} });
  const [dlgAprobarCoop,  setDlgAprobarCoop]  = useState({ open:false, cooperativa: null });
  const [urlCedulaAprobar, setUrlCedulaAprobar] = useState(null);
  const [aprobandoDocs,   setAprobandoDocs]    = useState(false);

  // Notificaciones in-app (campanita)
  const [notifs,          setNotifs]           = useState([]);
  const [notifsCount,     setNotifsCount]      = useState(0);
  const [notifAnchor,     setNotifAnchor]      = useState(null);

  // Accesos a apps (SSO cross-app)
  const [accesosSearch,   setAccesosSearch]     = useState('');
  const [accesosUsuario,  setAccesosUsuario]    = useState(null);   // usuario seleccionado
  const [accesosApps,     setAccesosApps]       = useState([]);     // catalogo con estado
  const [accesosLoading,  setAccesosLoading]    = useState(false);
  const [accesosGuardando,setAccesosGuardando]  = useState({});     // { [appCode]: bool }
  // Lista propia de usuarios del tab accesos (separada de la de la tab Usuarios
  // porque esa está paginada a 20). Traemos hasta 500 con búsqueda backend.
  const [accesosUsuarios, setAccesosUsuarios]   = useState([]);
  const [accesosUsuariosLoading, setAccesosUsuariosLoading] = useState(false);
  const [accesosTotal,    setAccesosTotal]      = useState(0);
  const [mostrarTest,     setMostrarTest]       = useState(false);

  // Configuración pasarela
  const [cfgPasarela,    setCfgPasarela]    = useState({});
  const [cfgLoading,     setCfgLoading]     = useState(false);
  const [cfgGuardando,   setCfgGuardando]   = useState(false);
  const [cfgEdit,        setCfgEdit]        = useState({});
  // Filtro global por cooperativa (afecta todos los tabs)
  const [filtroCoop,      setFiltroCoop]       = useState('');
  const [dlgCrearUser, setDlgCrearUser] = useState(false);

  const [editDeptos, setEditDeptos] = useState([]);
  const [editMunis,  setEditMunis]  = useState([]);
  const [editForm,   setEditForm]   = useState({});
  const [editSaving, setEditSaving] = useState(false);

  const toast = (msg, sev='success') => setSnack({ open:true, msg, sev });

  // ── Generar carnet de un usuario ──────────────────────────────────────
  // Si tiene UNA sola cooperativa elegible → genera directo (con confirmación).
  // Si tiene VARIAS → abre dialog para elegir cuál.
  const generarCarnetDelUsuario = async (u, cooperativaIdEspecifica) => {
    if (!u?.id) return;

    const elegibles = cooperativasElegiblesCarnet(u);
    if (elegibles.length === 0) {
      toast('Solo se generan carnets para usuarios de FENAGRO APL o Capellanías', 'warning');
      return;
    }

    // Si no se pasó cooperativa específica y el usuario tiene varias → abrir selector
    if (!cooperativaIdEspecifica && elegibles.length > 1) {
      setDlgSelectCoopCarnet({ open: true, user: u, opciones: elegibles });
      return;
    }

    // Cooperativa a usar
    const coopId = cooperativaIdEspecifica || elegibles[0].cooperativaID;
    const coopElegida = elegibles.find(c => c.cooperativaID === coopId);

    if (!window.confirm(
      `¿Generar carnet de ${coopElegida?.siglas || coopElegida?.nombre} para ${u.nombre} ${u.apellido}?\n\n` +
      (u.imagen ? '' : '⚠ Este usuario no tiene foto cargada. El carnet se generará con un placeholder.\n\n') +
      'Si ya existe un carnet activo para esa cooperativa, será revocado y reemplazado.'
    )) return;

    setGenerandoCarnet(u.id);
    try {
      const r = await generarCarnetUsuario(u.id, { CooperativaID: coopId });
      setDlgCarnet({
        open: true,
        carnet: r.carnet,
        fotoUrl: r.carnet?.titular?.fotoUrl || u.fotoUrl || null,
      });
      toast('Carnet generado correctamente');
      cargarUsuarios();
    } catch (err) {
      toast(err?.data?.mensaje || 'No se pudo generar el carnet', 'error');
    } finally { setGenerandoCarnet(null); }
  };

  /** Cooperativas elegibles para carnet del usuario (puede ser más de una si está afiliado a varias). */
  const cooperativasElegiblesCarnet = (u) => {
    const SIGLAS_VALIDAS = ['FENAGRO APL', 'CAPELLANES'];
    // Si vienen las cooperativas en el user (campo nuevo del backend), usar esa lista
    if (u?.cooperativas && u.cooperativas.length > 0) {
      return u.cooperativas.filter(c => SIGLAS_VALIDAS.includes(c.siglas));
    }
    // Fallback legacy: usar u.cooperativaID
    if (u?.cooperativaID) {
      const coop = coops.find(c => c.cooperativaID === u.cooperativaID);
      if (coop && SIGLAS_VALIDAS.includes(coop.siglas)) {
        return [{ cooperativaID: coop.cooperativaID, nombre: coop.nombre, siglas: coop.siglas, esPrincipal: true }];
      }
    }
    return [];
  };

  const tieneCarnetHabilitado = (u) => cooperativasElegiblesCarnet(u).length > 0;

  // Cerrar el date picker al hacer click fuera
  useEffect(() => {
    const handler = (e) => {
      if (datePickerRef.current && !datePickerRef.current.contains(e.target)) {
        setShowDatePicker(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  // Redirigir si no está autenticado
  useEffect(() => {
    if (!isLogged() || !isAdmin()) window.location.href = '/login';
  }, []);

  // Cargar KPIs y roles al montar
  useEffect(() => {
    getKpis().then(setKpis).catch(() => {});
    getRolesDisponibles().then(setRoles).catch(() => {});
    getDepartamentos(1045).then(setAfDeptos).catch(() => {});
  }, []);

  const cargarUsuarios = useCallback(async () => {
    setLoading(true);
    try {
      const params = { page: pageUs, pageSize: 20 };
      if (buscar)       params.buscar        = buscar;
      if (filtroRol)    params.rol           = filtroRol;
      if (filtroCoop)   params.cooperativaId = filtroCoop;
      if (filtroActivo !== '') params.activo = filtroActivo;
      if (filtroCarnet !== '') params.tieneCarnet = filtroCarnet;
      const d = await getUsuarios(params);
      setUsuarios(d.data || []); setTotalUs(d.total || 0);
    } catch { toast('Error cargando usuarios', 'error'); }
    finally { setLoading(false); }
  }, [pageUs, buscar, filtroRol, filtroActivo, filtroCarnet, filtroCoop]);

  const cargarAfiliaciones = useCallback(async () => {
    setLoading(true);
    try {
      const params = {};
      if (afBuscar)    params.buscar     = afBuscar;
      if (afEstado)    params.estado     = afEstado;
      if (afModalidad) params.modalidad  = afModalidad;
      if (afMuniId)    params.municipio  = afMunis.find(m=>(m.municipioID||m.MunicipioID)===afMuniId)?.nombre || afMunis.find(m=>(m.municipioID||m.MunicipioID)===afMuniId)?.Nombre || '';
      if (afFechaDesde)params.fechaDesde = afFechaDesde;
      if (afFechaHasta)params.fechaHasta = afFechaHasta;
      if (filtroCoop)  params.cooperativaId = filtroCoop;
      const d = await getAfiliacionesPendientes(params, pageAf, 25);
      setAfiliaciones(d.data || []);
      setTotalAf2(d.total || 0);
    } catch { toast('Error cargando solicitudes', 'error'); }
    finally { setLoading(false); }
  }, [afBuscar, afEstado, afModalidad, afMuniId, afMunis, afFechaDesde, afFechaHasta, filtroCoop, pageAf]);

  useEffect(() => { if (tab==='usuarios')     cargarUsuarios(); },    [tab, cargarUsuarios]);
  useEffect(() => { if (tab==='afiliaciones') cargarAfiliaciones(); }, [tab, cargarAfiliaciones]);

  // Acciones
  // ── Abrir modal edición con carga de geo ──
  const abrirEditar = async (u) => {
    const form = {
      Nombre: u.nombre||'', Apellido: u.apellido||'', Email: u.email||'',
      Celular: u.celular||'', Documento: u.documento||'', TipoDocumento: u.tipoDocumento||'CC',
      DireccionTexto: u.direccionTexto||'',
      departamentoId: u.departamentoID||'', municipioId: u.municipioID||'',
      roles: u.roles || [],
      googleCalendarId: u.googleCalendarId || '',
      newPassword: '',
    };
    setEditForm(form);
    // Normalizar: el backend devuelve 'id' (minúscula), guardar siempre como Id
    setDlgEditar({ open:true, user:{ ...u, Id: u.Id || u.id }, tab:'datos' });

    // Cargar URL firmada de la foto si tiene imagen
    if (u.imagen) {
      try {
        const det = await getUsuarioById(u.Id || u.id);
        if (det?.fotoUrl) {
          setDlgEditar(p => ({ ...p, user: { ...p.user, fotoUrl: det.fotoUrl } }));
        }
      } catch {}
    }

    if (u.departamentoID) {
      getDepartamentos(u.PaisID||1045).then(setEditDeptos).catch(()=>{});
      getMunicipios(u.departamentoID).then(setEditMunis).catch(()=>{});
    } else {
      getDepartamentos(1045).then(setEditDeptos).catch(()=>{});
    }
  };

  const handleGuardarEdicion = async () => {
    setEditSaving(true);
    try {
      await editarUsuario(dlgEditar.user.Id, {
        nombre: editForm.Nombre, apellido: editForm.Apellido, email: editForm.Email,
        celular: editForm.Celular, documento: editForm.Documento, tipoDocumento: editForm.TipoDocumento,
        direccionTexto: editForm.DireccionTexto,
        departamentoId: editForm.departamentoId || null,
        municipioId: editForm.municipioId || null,
        googleCalendarId: editForm.googleCalendarId !== undefined ? (editForm.googleCalendarId || '') : undefined,
      });
      if (editForm.roles !== undefined) {
        const rolesOriginales = dlgEditar.user.roles || [];
        const rolesNuevos     = editForm.roles || [];
        const rolesAgregar    = rolesNuevos.filter(r => !rolesOriginales.includes(r));
        const rolesQuitar     = rolesOriginales.filter(r => !rolesNuevos.includes(r));
        if (rolesAgregar.length > 0 || rolesQuitar.length > 0) {
          await actualizarRolesUsuario(dlgEditar.user.Id, rolesAgregar, rolesQuitar);
        }
      }
      if (editForm.newPassword && editForm.newPassword.length >= 6) {
        await cambiarPasswordUsuario(dlgEditar.user.Id, editForm.newPassword);
      }
      toast('✅ Usuario actualizado correctamente');
      setDlgEditar({ open:false, user:null, tab:'datos' });
      cargarUsuarios();
    } catch(e) { toast(e?.data?.mensaje || 'Error al guardar', 'error'); }
    finally { setEditSaving(false); }
  };

  // ── Abrir detalle de solicitud ──
  const abrirDetalle = async (id) => {
    setDlgDetalle({ open:true, id, data:null, loading:true });
    setDocsAfiliado(null); setSesionesAf([]);
    try {
      const [data, docsResp, sesResp] = await Promise.all([
        getDetalleAfiliado(id),
        getDocumentosAfiliado(id).catch(()=>null),
        getSesionesAfiliado(id).catch(()=>[]),
      ]);
      setDlgDetalle({ open:true, id, data, loading:false });
      setDocsAfiliado(docsResp);
      setSesionesAf(Array.isArray(sesResp) ? sesResp : []);
    } catch { setDlgDetalle({ open:true, id, data:null, loading:false }); }
  };

  const toggleEstado = async (u) => {
    try {
      await cambiarEstadoUsuario(u.id, !u.activo);
      toast(`Usuario ${!u.activo ? 'activado' : 'desactivado'}`);
      cargarUsuarios();
    } catch (e) { toast(e?.data?.mensaje || 'Error', 'error'); }
  };

  const handleCambiarPass = async () => {
    if (dlgPass.val.length < 6) { toast('Mínimo 6 caracteres', 'error'); return; }
    if (!dlgPass.id) { toast('Usuario no identificado', 'error'); return; }
    try {
      await cambiarPasswordUsuario(dlgPass.id, dlgPass.val);
      toast(`Contraseña de ${dlgPass.nombre || dlgPass.email || 'usuario'} actualizada`);
      setDlgPass({ open:false, id:null, val:'', nombre:'', email:'' });
      setVerPass(false);
    } catch (e) { toast(e?.data?.mensaje || 'Error', 'error'); }
  };

  const handleAprobar = async (id, nombre) => {
    try { await aprobarAfiliacion(id); toast(`✅ Evaluación de ${nombre} aprobada — puede pagar y agendar sesión`); cargarAfiliaciones(); getKpis().then(setKpis); }
    catch (e) { toast(e?.data?.mensaje || 'Error', 'error'); }
  };

  const handleRechazar = async () => {
    try {
      await rechazarAfiliacion(dlgRechazar.id, dlgRechazar.motivo);
      toast('Solicitud rechazada'); setDlgRechazar({open:false,id:null,motivo:''});
      cargarAfiliaciones();
    } catch (e) { toast(e?.data?.mensaje || 'Error', 'error'); }
  };

  // ── Correo de usuarios: reenviar confirmación / marcar confirmado (SuperAdmin) ──
  const handleReenviarConfirmacion = async (u) => {
    setCorreoAccion(u.id);
    try {
      const r = await reenviarConfirmacionUsuario(u.id);
      toast(r?.mensaje || `Correo de confirmación enviado a ${u.email}`);
    } catch (e) { toast(e?.data?.mensaje || 'No se pudo reenviar el correo', 'error'); }
    finally { setCorreoAccion(null); }
  };

  const handleConfirmarEmail = async (u) => {
    if (!window.confirm(
      `¿Marcar como confirmado el correo ${u.email}?\n\n` +
      `Si el usuario tiene una solicitud ABANDONADA, se reactivará con el estado que corresponda a su avance.`
    )) return;
    setCorreoAccion(u.id);
    try {
      const r = await confirmarEmailUsuario(u.id);
      toast(r?.mensaje || 'Correo marcado como confirmado');
      cargarUsuarios();
      cargarAfiliaciones();
    } catch (e) { toast(e?.data?.mensaje || 'No se pudo confirmar el correo', 'error'); }
    finally { setCorreoAccion(null); }
  };

  // ── Reactivar solicitud ABANDONADA (SuperAdmin) ──
  // modo: 'reactivar' (ABANDONADA) | 'recalcular' (solicitud atascada en estado intermedio)
  const abrirReactivar = async (a, modo = 'reactivar') => {
    const nombre = `${a.nombres} ${a.apellidos}`;
    setDlgReactivar({ ...DLG_REACTIVAR_INIT, modo, open:true, id:a.afiliadoID, nombre, loading:true });
    try {
      const info = await getInfoReactivacion(a.afiliadoID);
      setDlgReactivar(p => ({ ...p, info, loading:false }));
    } catch (e) {
      toast(e?.data?.mensaje || 'No se pudo consultar el estado de la solicitud', 'error');
      setDlgReactivar(DLG_REACTIVAR_INIT);
    }
  };

  const handleReactivar = async () => {
    setDlgReactivar(p => ({ ...p, enviando:true }));
    try {
      const r = dlgReactivar.modo === 'recalcular'
        ? await recalcularEstadoSolicitud(dlgReactivar.id, dlgReactivar.motivo)
        : await reactivarSolicitudAbandonada(dlgReactivar.id, dlgReactivar.motivo);
      toast(r?.mensaje || 'Listo', r?.estado === 'ACTIVO' ? 'success' : 'warning');
      setDlgReactivar(DLG_REACTIVAR_INIT);
      cargarAfiliaciones();
    } catch (e) {
      toast(e?.data?.mensaje || 'Error al procesar la solicitud', 'error');
      setDlgReactivar(p => ({ ...p, enviando:false }));
    }
  };

  const handleReevaluar = async () => {
    try {
      await reevaluarAfiliacion(dlgReevaluar.id, dlgReevaluar.motivo);
      toast(`Solicitud de ${dlgReevaluar.nombre} reactivada para evaluacion`);
      setDlgReevaluar({open:false,id:null,nombre:'',motivo:''});
      cargarAfiliaciones();
    } catch (e) { toast(e?.data?.mensaje || 'Error al reactivar', 'error'); }
  };

  const cargarConfigPasarela = useCallback(async () => {
    setCfgLoading(true);
    try {
      const data = await getConfigPasarela();
      setCfgPasarela(data);
      setCfgEdit({
        ambiente:         data.ambiente         || 'sandbox',
        publicKey:        '',
        privateKey:       '',
        integritySecret:  '',
        eventsSecret:     '',
        montoInscripcion: data.montoInscripcion ? String(Math.round(Number(data.montoInscripcion))) : '150000',
        redirectUrl:      data.redirectUrl      || '',
        // keep booleans to show placeholder indicators
        _tienePublicKey:       data.tienePublicKey       || false,
        _tienePrivateKey:      data.tienePrivateKey      || false,
        _tieneIntegritySecret: data.tieneIntegritySecret || false,
        _tieneEventsSecret:    data.tieneEventsSecret    || false,
      });
    } catch(e) { toast('Error cargando configuración', 'error'); }
    finally { setCfgLoading(false); }
  }, []);

  useEffect(() => { if (tab === 'pasarela') cargarConfigPasarela(); }, [tab, cargarConfigPasarela]);

  const handleGuardarPasarela = async () => {
    setCfgGuardando(true);
    try {
      // Solo enviar campos no vacíos (no sobreescribir claves con vacío)
      const dto = {};
      if (cfgEdit.ambiente)         dto.ambiente         = cfgEdit.ambiente;
      if (cfgEdit.publicKey)        dto.publicKey        = cfgEdit.publicKey;
      if (cfgEdit.privateKey)       dto.privateKey       = cfgEdit.privateKey;
      if (cfgEdit.integritySecret)  dto.integritySecret  = cfgEdit.integritySecret;
      if (cfgEdit.eventsSecret)     dto.eventsSecret     = cfgEdit.eventsSecret;
      if (cfgEdit.montoInscripcion) dto.montoInscripcion = cfgEdit.montoInscripcion;
      if (cfgEdit.redirectUrl)      dto.redirectUrl      = cfgEdit.redirectUrl;
      await updateConfigPasarela(dto);
      toast('Configuración de pasarela guardada');
      cargarConfigPasarela();
    } catch(e) { toast(e?.data?.mensaje || 'Error al guardar', 'error'); }
    finally { setCfgGuardando(false); }
  };

  const cargarCoops = useCallback(async () => {
    setCoopsLoading(true);
    try {
      const data = await getCooperativasAdmin();
      setCoops(Array.isArray(data) ? data : []);
    } catch(e) { toast('Error cargando cooperativas', 'error'); }
    finally { setCoopsLoading(false); }
  }, []);

  useEffect(() => { if (tab === 'cooperativas') cargarCoops(); }, [tab, cargarCoops]);

  // Cargar cooperativas para selectores de filtro al montar
  useEffect(() => {
    getCooperativasAdmin().then(d => setCoops(Array.isArray(d) ? d : [])).catch(()=>{});
  }, []);

  // Notificaciones: fetch inicial + poll cada 60s del contador
  const cargarConteoNotifs = useCallback(async () => {
    try {
      const r = await getNotificacionesCount();
      setNotifsCount(r?.noLeidas || 0);
    } catch { /* silent */ }
  }, []);
  useEffect(() => {
    cargarConteoNotifs();
    const id = setInterval(cargarConteoNotifs, 60000);
    return () => clearInterval(id);
  }, [cargarConteoNotifs]);
  const abrirNotifs = useCallback(async (ev) => {
    setNotifAnchor(posAncla(ev.currentTarget));
    try {
      const list = await getNotificaciones({ limite: 30 });
      setNotifs(Array.isArray(list) ? list : []);
    } catch { setNotifs([]); }
  }, []);
  const cerrarNotifs = () => setNotifAnchor(null);
  const onClickNotif = async (n) => {
    // marcar leída silenciosamente y navegar si tiene url
    if (!n.leida) {
      try {
        await marcarNotificacionLeida(n.notificacionID);
        setNotifs(prev => prev.map(x => x.notificacionID === n.notificacionID ? { ...x, leida: true } : x));
        setNotifsCount(c => Math.max(0, c - 1));
      } catch {}
    }
    cerrarNotifs();
    if (n.url) window.location.hash = n.url; // ruta hash — el router del panel la interpreta
  };
  const marcarTodas = async () => {
    try {
      await marcarTodasNotificacionesLeidas();
      setNotifs(prev => prev.map(x => ({ ...x, leida: true })));
      setNotifsCount(0);
    } catch {}
  };

  // ── Accesos apps (SSO) ─────────────────────────────────────────────
  // Helper: detectar si un email/usuario es de test (fenagro-test.local o cédula/NIT en rango test).
  const esUsuarioTest = useCallback((u) => {
    if (!u) return false;
    if ((u.email || '').toLowerCase().endsWith('@fenagro-test.local')) return true;
    // Rango cédula test afiliados: 2100000000-2100000099
    // Rango NIT test aliados: 999000000-999000099
    const num = String(u.documento || u.cedula || u.nit || '').replace(/\D/g, '');
    if (num) {
      const n = parseInt(num, 10);
      if (!Number.isNaN(n)) {
        if (n >= 2100000000 && n <= 2100000099) return true;
        if (n >= 999000000  && n <= 999000099)  return true;
      }
    }
    return false;
  }, []);

  // Cargar usuarios para el tab accesos (pageSize alto + search backend)
  const cargarUsuariosAccesos = useCallback(async (search = '') => {
    setAccesosUsuariosLoading(true);
    try {
      const params = { page: 1, pageSize: 500 };
      if (search) params.buscar = search;
      const d = await getUsuarios(params);
      setAccesosUsuarios(d.data || []);
      setAccesosTotal(d.total || 0);
    } catch (e) {
      toast(e?.message || 'Error cargando usuarios', 'error');
      setAccesosUsuarios([]);
    } finally {
      setAccesosUsuariosLoading(false);
    }
  }, []);

  // Cargar al entrar al tab
  useEffect(() => {
    if (tab === 'accesos' && accesosUsuarios.length === 0) cargarUsuariosAccesos();
  }, [tab, accesosUsuarios.length, cargarUsuariosAccesos]);

  // Debounce del buscador — 400ms tras dejar de tipear
  useEffect(() => {
    if (tab !== 'accesos') return;
    const q = accesosSearch.trim();
    // Si el resultado ya está en la lista actual (menos de pageSize), no recargar backend.
    // Buscamos siempre en backend para asegurar cobertura de usuarios no cargados.
    const t = setTimeout(() => { cargarUsuariosAccesos(q); }, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accesosSearch, tab]);

  const cargarAccesosUsuario = useCallback(async (userId) => {
    if (!userId) return;
    setAccesosLoading(true);
    try {
      const apps = await getAppsUsuarioAdmin(userId);
      setAccesosApps(Array.isArray(apps) ? apps : []);
    } catch (e) {
      toast(e?.message || 'No se pudieron cargar los accesos', 'error');
      setAccesosApps([]);
    } finally {
      setAccesosLoading(false);
    }
  }, []);
  const toggleAcceso = async (app) => {
    if (!accesosUsuario) return;
    setAccesosGuardando(g => ({ ...g, [app.appCode]: true }));
    try {
      if (app.tieneAcceso) {
        await revocarAppUsuario(accesosUsuario.id, app.appCode, `Revocado desde panel admin por ${user?.email || 'admin'}`);
        toast(`Acceso a ${app.nombre} revocado`);
      } else {
        await otorgarAppUsuario(accesosUsuario.id, app.appCode, `Otorgado desde panel admin por ${user?.email || 'admin'}`);
        toast(`Acceso a ${app.nombre} otorgado`);
      }
      await cargarAccesosUsuario(accesosUsuario.id);
    } catch (e) {
      toast(e?.message || 'No se pudo actualizar el acceso', 'error');
    } finally {
      setAccesosGuardando(g => ({ ...g, [app.appCode]: false }));
    }
  };

  // Cargar apps del usuario seleccionado al cambiar
  useEffect(() => {
    if (accesosUsuario?.id) cargarAccesosUsuario(accesosUsuario.id);
  }, [accesosUsuario, cargarAccesosUsuario]);

  const handleGuardarCoop = async () => {
    const { modo, data } = dlgCoop;
    try {
      if (modo === 'crear') {
        await crearCooperativa({ ...data, federacionId: 1 });
        toast('Cooperativa creada');
      } else {
        await actualizarCooperativa(data.cooperativaID, data);
        toast('Cooperativa actualizada');
      }
      setDlgCoop({ open:false, modo:'crear', data:{} });
      cargarCoops();
    } catch(e) { toast(e?.data?.mensaje || 'Error al guardar', 'error'); }
  };

  const handleToggleCoop = async (id, activo) => {
    try {
      await cambiarEstadoCooperativa(id, !activo);
      toast(`Cooperativa ${!activo ? 'activada' : 'desactivada'}`);
      cargarCoops();
    } catch(e) { toast('Error al cambiar estado', 'error'); }
  };

  const cargarPagos = useCallback(async () => {
    setPagosLoading(true);
    try {
      const data = await getListaPagosInscripcion({
        estado:     pagosEstado    || undefined,
        cooperativaId: filtroCoop  || undefined,
        buscar:     pagosBuscar    || undefined,
        fechaDesde: pagosFechaDesde || undefined,
        fechaHasta: pagosFechaHasta || undefined,
        page:       pagosPage,
        pageSize:   PAGOS_PAGE_SIZE,
      });
      setPagos(data.data || []);
      setPagosTotal(data.total || 0);
      setPagosTotalMonto(data.totalMonto || 0);
    } catch(e) { toast('Error cargando pagos', 'error'); }
    finally { setPagosLoading(false); }
  }, [pagosEstado, pagosBuscar, pagosFechaDesde, pagosFechaHasta, pagosPage]);

  useEffect(() => { if (tab === 'pagos') cargarPagos(); }, [tab, cargarPagos]);

  const handleConfirmarManual = async () => {
    try {
      await confirmarPagoManual(dlgPagoManual.id, {
        referencia: dlgPagoManual.ref,
        monto:      dlgPagoManual.monto,
        notas:      dlgPagoManual.notas,
      });
      toast(`Afiliación de ${dlgPagoManual.nombre} aceptada sin pago — auditada`);
      setDlgPagoManual({ open:false, id:null, nombre:'', ref:'', monto:150000, notas:'' });
      // Refrescar ambas tablas: el botón puede venir desde Pagos o desde Afiliaciones
      try { cargarPagos(); } catch {}
      try { cargarAfiliaciones(); } catch {}
      try { getKpis().then(setKpis); } catch {}
    } catch(e) { toast(e?.data?.mensaje || 'Error al confirmar', 'error'); }
  };

  const cargarExclusiones = useCallback(async () => {
    setExclusionLoading(true);
    try {
      const data = await getListaExclusion({ buscar: exclusionBuscar || undefined, page: exclusionPage, pageSize: EXCL_PAGE_SIZE });
      setExclusiones(data.data || []);
      setExclusionTotal(data.total || 0);
    } catch(e) { toast('Error cargando lista de exclusión', 'error'); }
    finally { setExclusionLoading(false); }
  }, [exclusionBuscar, exclusionPage]);

  useEffect(() => { if (tab === 'exclusion') cargarExclusiones(); }, [tab, cargarExclusiones]);

  const handleAgregarExclusion = async () => {
    if (!dlgExclusion.doc.trim()) return;
    try {
      await agregarExclusion({ documento: dlgExclusion.doc, nombres: dlgExclusion.nombres, apellidos: dlgExclusion.apellidos, motivoInterno: dlgExclusion.motivo });
      toast('Registro agregado a la lista de exclusión');
      setDlgExclusion({ open:false, doc:'', nombres:'', apellidos:'', motivo:'' });
      cargarExclusiones();
    } catch(e) { toast(e?.data?.mensaje || 'Error al agregar', 'error'); }
  };

  const handleDesactivarExclusion = async (id, doc) => {
    if (!window.confirm(`¿Remover el documento ${doc} de la lista de exclusión?`)) return;
    try {
      await desactivarExclusion(id);
      toast('Registro removido de la lista de exclusión');
      cargarExclusiones();
    } catch(e) { toast('Error al remover', 'error'); }
  };

  const cargarAuditoria = useCallback(async () => {
    setAuditLoading(true);
    try {
      const fn = auditTipo === 'afiliados' ? getAuditoriaAfiliados : getAuditoriaUsuarios;
      const data = await fn({
        cooperativaId: auditTipo === 'afiliados' ? (filtroCoop || undefined) : undefined,
        alcance:     auditTipo === 'aliados'   ? 'aliados'
                    : auditTipo === 'usuarios' ? 'sistema'
                    : undefined,
        accion:      auditAccion   || undefined,
        realizadoPor: auditBuscar  || undefined,
        fechaDesde:  auditFechaDesde || undefined,
        fechaHasta:  auditFechaHasta || undefined,
        page:        auditPage,
        pageSize:    AUDIT_PAGE_SIZE,
      });
      setAuditLogs(data.data || []);
      setAuditTotal(data.total || 0);
    } catch(e) { toast('Error cargando auditoría', 'error'); }
    finally { setAuditLoading(false); }
  }, [auditTipo, auditAccion, auditBuscar, auditFechaDesde, auditFechaHasta, auditPage]);

  useEffect(() => {
    if (tab === 'auditoria') {
      cargarAuditoria();
      getAccionesAuditoria().then(data => setAuditAcciones(data || { afiliado:[], usuario:[] })).catch(()=>{});
    }
  }, [tab, cargarAuditoria]);

  const handleReasignarCoop = async () => {
    try {
      await reasignarCooperativa(dlgReasignarCoop.id, dlgReasignarCoop.cooperativaId, dlgReasignarCoop.motivo);
      toast(`Cooperativa de ${dlgReasignarCoop.nombre} actualizada`);
      setDlgReasignarCoop({ open:false, id:null, nombre:'', cooperativaId:'', motivo:'' });
      cargarAfiliaciones();
    } catch(e) { toast(e?.data?.mensaje || 'Error al reasignar', 'error'); }
  };

  const handleEliminarCompleto = async () => {
    try {
      await eliminarAfiliacionCompleta(dlgEliminarCompleto.id, dlgEliminarCompleto.motivo);
      toast(`Afiliado ${dlgEliminarCompleto.nombre} eliminado completamente del sistema`);
      setDlgEliminarCompleto({open:false,id:null,nombre:'',motivo:''});
      cargarAfiliaciones();
    } catch (e) { toast(e?.data?.mensaje || 'Error al eliminar', 'error'); }
  };

  const handleEliminarSesion = async () => {
    try {
      await eliminarSesionOrientacion(dlgEliminarSesion.id, dlgEliminarSesion.motivo);
      toast(`Sesion de ${dlgEliminarSesion.nombre} eliminada. Puede volver a agendar`);
      setDlgEliminarSesion({open:false,id:null,nombre:'',motivo:''});
      cargarAfiliaciones();
    } catch (e) { toast(e?.data?.mensaje || 'Error al eliminar sesion', 'error'); }
  };

  const PAGE_SIZE = 20;
  const totalPages = Math.ceil(totalUs / PAGE_SIZE);

  // ── HEADER ──────────────────────────────────────────────────────────
  const Header = () => (
    <Box sx={{ background:'linear-gradient(135deg,#1a4d2e,#2e7d32)', px:3, py:1.5, display:'flex', alignItems:'center', justifyContent:'space-between', boxShadow:'0 2px 12px rgba(0,0,0,0.2)' }}>
      <Box sx={{ display:'flex', alignItems:'center', gap:2 }}>
        <Box component="a" href="/" title="Ir al sitio FENAGRO"
          sx={{ background:'rgba(255,255,255,0.15)', borderRadius:2, px:2, py:0.5, textDecoration:'none',
                '&:hover':{ background:'rgba(255,255,255,0.25)' } }}>
          <Typography sx={{ color:'#c8a84b', fontWeight:800, fontSize:'0.9rem', letterSpacing:'0.06em' }}>
            FENAGRO APL
          </Typography>
        </Box>
        <Typography sx={{ color:'rgba(255,255,255,0.5)', fontSize:'0.75rem' }}>Panel de Administración</Typography>
      </Box>
      <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
        <Tooltip title={notifsCount > 0 ? `${notifsCount} notificación(es) sin leer` : 'Notificaciones'}>
          <IconButton size="small" onClick={abrirNotifs} sx={{ color:'rgba(255,255,255,0.85)' }}>
            <Badge badgeContent={notifsCount} color="warning" max={99}
              sx={{ '& .MuiBadge-badge': { fontSize:'0.6rem', minWidth:16, height:16, fontWeight:700 } }}>
              {notifsCount > 0 ? <NotificationsIcon fontSize="small"/> : <NotificationsNoneIcon fontSize="small"/>}
            </Badge>
          </IconButton>
        </Tooltip>
        <Popover open={Boolean(notifAnchor)} onClose={cerrarNotifs}
          anchorReference="anchorPosition" anchorPosition={notifAnchor || undefined}
          transformOrigin={{ vertical:'top', horizontal:'right' }}
          PaperProps={{ sx: { width: 360, maxHeight: 480, borderRadius: 2 } }}>
          <Box sx={{ p: 1.5, display:'flex', alignItems:'center', justifyContent:'space-between',
            borderBottom:'1px solid #eee', background:'#fafafa' }}>
            <Typography sx={{ fontWeight:700, fontSize:'0.9rem' }}>Notificaciones</Typography>
            {notifs.some(n => !n.leida) && (
              <Button size="small" onClick={marcarTodas} sx={{ fontSize:'0.7rem', textTransform:'none' }}>
                Marcar todas como leídas
              </Button>
            )}
          </Box>
          {notifs.length === 0 ? (
            <Box sx={{ p: 3, textAlign:'center', color:'#888' }}>
              <NotificationsNoneIcon sx={{ fontSize: 40, opacity: 0.4 }}/>
              <Typography variant="caption" sx={{ display:'block', mt: 1 }}>No hay notificaciones</Typography>
            </Box>
          ) : (
            <List dense disablePadding sx={{ overflow:'auto', maxHeight: 420 }}>
              {notifs.map(n => (
                <ListItem key={n.notificacionID} button onClick={() => onClickNotif(n)}
                  sx={{ borderBottom:'1px solid #f0f0f0',
                    background: n.leida ? '#fff' : '#fff8e1',
                    alignItems:'flex-start', py: 1 }}>
                  <Box sx={{ width: 8, height: 8, borderRadius:'50%', mt: 0.9, mr: 1,
                    background: n.leida ? 'transparent' : '#ed6c02', flexShrink: 0 }}/>
                  <ListItemText
                    primary={<Typography sx={{ fontSize:'0.82rem', fontWeight: n.leida ? 500 : 700, color:'#333' }}>
                      {n.titulo}
                    </Typography>}
                    secondary={<>
                      {n.mensaje && <Typography variant="caption" sx={{ display:'block', color:'#666', mt: 0.3 }}>{n.mensaje}</Typography>}
                      <Typography variant="caption" sx={{ color:'#999', fontSize:'0.65rem' }}>
                        {n.fechaCreacion && new Date(n.fechaCreacion).toLocaleString('es-CO', { dateStyle:'short', timeStyle:'short' })}
                        {n.origenUserEmail ? ` · ${n.origenUserEmail}` : ''}
                      </Typography>
                    </>}
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Popover>
        <Box onClick={(e) => setUserMenuAnchor(posAncla(e.currentTarget))}
          sx={{ display:'flex', alignItems:'center', gap:1.2, cursor:'pointer', borderRadius:2, px:1, py:0.5,
                '&:hover':{ background:'rgba(255,255,255,0.12)' } }}>
          <Avatar sx={{ width:32, height:32, background:'rgba(255,255,255,0.2)', fontSize:'0.8rem', fontWeight:700 }}>
            {user?.nombre?.[0]}{user?.apellido?.[0]}
          </Avatar>
          <Box sx={{ display:{ xs:'none', sm:'block' } }}>
            <Typography sx={{ color:'#fff', fontSize:'0.82rem', fontWeight:600 }}>{user?.nombre} {user?.apellido}</Typography>
            <Typography sx={{ color:'rgba(255,255,255,0.5)', fontSize:'0.68rem' }}>{(user?.roles||[]).join(' · ')}</Typography>
          </Box>
          <KeyboardArrowDownIcon sx={{ color:'rgba(255,255,255,0.7)', fontSize:18 }}/>
        </Box>
        <Menu open={Boolean(userMenuAnchor)} onClose={() => setUserMenuAnchor(null)}
          anchorReference="anchorPosition" anchorPosition={userMenuAnchor || undefined}
          transformOrigin={{ vertical:'top', horizontal:'right' }}
          PaperProps={{ sx:{ minWidth:220, borderRadius:2 } }}>
          <MenuItem onClick={() => { setUserMenuAnchor(null); window.location.href = '/'; }}>
            <ListItemIcon><HomeOutlinedIcon sx={{ color:'#2e7d32' }}/></ListItemIcon>
            Ir al sitio FENAGRO
          </MenuItem>
          <MenuItem onClick={() => { setUserMenuAnchor(null); window.location.href = '/mi-portal'; }}>
            <ListItemIcon><AppsOutlinedIcon sx={{ color:'#2e7d32' }}/></ListItemIcon>
            Mi portal de afiliado
          </MenuItem>
          <MenuItem onClick={() => { setUserMenuAnchor(null); window.location.href = '/mi-perfil'; }}>
            <ListItemIcon><AccountCircleOutlinedIcon sx={{ color:'#2e7d32' }}/></ListItemIcon>
            Mi perfil
          </MenuItem>
          <Divider/>
          <MenuItem onClick={() => { setUserMenuAnchor(null); logout(); window.location.href = '/login'; }}>
            <ListItemIcon><LogoutIcon sx={{ color:'#c62828' }}/></ListItemIcon>
            Cerrar sesión
          </MenuItem>
        </Menu>
        <Tooltip title="Cerrar sesión">
          <IconButton size="small" onClick={() => { logout(); window.location.href='/login'; }} sx={{ color:'rgba(255,255,255,0.7)' }}>
            <LogoutIcon fontSize="small"/>
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );

  // ── NAV TABS ─────────────────────────────────────────────────────────
  const NavTabs = () => (
    <Box sx={{ background:'#fff', borderBottom:'1px solid #e0e0e0', px:2 }}>
      <Tabs value={tab} onChange={(_,v) => setTab(v)} textColor="inherit"
        variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
        TabIndicatorProps={{ style:{ background:'#2e7d32', height:3 } }}>
        {TABS.map(t => (
          <Tab key={t.id} value={t.id} label={
            <Box sx={{ display:'flex', alignItems:'center', gap:0.8, py:0.3 }}>
              {t.id === 'afiliaciones'
                ? <Badge badgeContent={afiliaciones.filter(a=>a.estado==='PENDIENTE').length || 0} color="error" max={99}>{t.icon}</Badge>
                : t.icon}
              <Typography variant="caption" sx={{ fontWeight:600 }}>{t.label}</Typography>
            </Box>
          } sx={{ minHeight:48, textTransform:'none' }}/>
        ))}
      </Tabs>
    </Box>
  );

  // ── Selector global de cooperativa ────────────────────────────────────
  const FiltroCoopeSelector = () => !['cooperativas','mapa','dashboard'].includes(tab) && coops.length > 1 ? (
    <Box sx={{ background:'#f8fdf8', borderBottom:'1px solid #e8f5e9', px:3, py:1,
      display:'flex', alignItems:'center', gap:2 }}>
      <BusinessIcon sx={{ fontSize:18, color:'#2e7d32' }}/>
      <Typography variant="caption" sx={{ color:'#555', fontWeight:600 }}>Cooperativa:</Typography>
      <FormControl size="small" sx={{ minWidth:220 }}>
        <Select value={filtroCoop} displayEmpty
          onChange={e => { setFiltroCoop(e.target.value); }}
          sx={{ fontSize:'0.8rem', height:30 }}>
          <MenuItem value="">Todas las cooperativas</MenuItem>
          {coops.map(c => (
            <MenuItem key={c.cooperativaID} value={c.cooperativaID} sx={{ fontSize:'0.8rem' }}>
              {c.nombre} {c.siglas ? `(${c.siglas})` : ''}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {filtroCoop && (
        <Button size="small" variant="text" sx={{ color:'#888', fontSize:'0.72rem' }}
          onClick={()=>setFiltroCoop('')}>
          Ver todas
        </Button>
      )}
    </Box>
  ) : null;

  // ── Paleta de colores para gráficos ───────────────────────────────────
  const PIE_ESTADO_USUARIOS  = ['#2e7d32','#bdbdbd'];
  const PIE_ESTADO_AFILIADOS = { ACTIVO:'#2e7d32', PENDIENTE:'#e65100', RECHAZADO:'#c62828', SUSPENDIDO:'#6a1b9a', INACTIVO:'#bdbdbd' };
  const BAR_COLORS = { activos:'#2e7d32', pendientes:'#e65100', rechazados:'#c62828' };

  // Tooltip personalizado para los quesos
  const PieTooltipCustom = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const { name, value } = payload[0];
    const total = payload[0].payload.total || value;
    return (
      <Paper elevation={3} sx={{ px:1.5, py:1, borderRadius:1.5 }}>
        <Typography sx={{ fontWeight:700, fontSize:'0.8rem', color:'#1a1a1a' }}>{name}</Typography>
        <Typography sx={{ fontSize:'0.75rem', color:'#555' }}>{value} ({total > 0 ? Math.round(value/total*100) : 0}%)</Typography>
      </Paper>
    );
  };

  const ChartTitle = ({ children }) => (
    <Typography sx={{ fontWeight:700, fontSize:'0.75rem', color:'#555', textTransform:'uppercase', letterSpacing:'0.06em', mb:1.5 }}>
      {children}
    </Typography>
  );

  // ── TAB DASHBOARD ─────────────────────────────────────────────────────
  const TabDashboard = () => {
    // Datos para los gráficos
    const estadoUsuariosData = (kpis?.porEstadoUsuario || []).map(e => ({
      name: e.estado, value: e.count, total: kpis?.totalUsuarios || 1,
    }));
    const estadoAfiliados = kpis?.porEstado || [];
    const totalAfil = estadoAfiliados.reduce((s,x) => s + x.count, 0);
    const estadoAfiliadosData = estadoAfiliados.map(e => ({
      name: e.estado, value: e.count, total: totalAfil,
      fill: PIE_ESTADO_AFILIADOS[e.estado] || '#90a4ae',
    }));
    const deptoData = (kpis?.porDepto || []).slice(0, 10).map(d => ({
      name: d.nombre?.length > 12 ? d.nombre.substring(0,12)+'…' : d.nombre,
      nombreFull: d.nombre,
      activos: d.activos || 0, pendientes: d.pendientes || 0, rechazados: d.rechazados || 0,
      total: d.total,
    }));
    const muniData = (kpis?.porMunicipio || []).slice(0, 10).map(m => ({
      name: m.nombre?.length > 14 ? m.nombre.substring(0,14)+'…' : m.nombre,
      nombreFull: m.nombre,
      activos: m.activos || 0, pendientes: m.pendientes || 0, rechazados: m.rechazados || 0,
      total: m.total,
    }));

    const BarTooltipCustom = ({ active, payload, label }) => {
      if (!active || !payload?.length) return null;
      return (
        <Paper elevation={3} sx={{ px:1.5, py:1, borderRadius:1.5, minWidth:150 }}>
          <Typography sx={{ fontWeight:700, fontSize:'0.78rem', color:'#1a1a1a', mb:0.5 }}>
            {payload[0]?.payload?.nombreFull || label}
          </Typography>
          {payload.map(p => (
            <Box key={p.dataKey} sx={{ display:'flex', justifyContent:'space-between', gap:2 }}>
              <Typography sx={{ fontSize:'0.72rem', color: BAR_COLORS[p.dataKey] || '#555' }}>{p.name}</Typography>
              <Typography sx={{ fontSize:'0.72rem', fontWeight:700 }}>{p.value}</Typography>
            </Box>
          ))}
          <Divider sx={{ my:0.5 }}/>
          <Box sx={{ display:'flex', justifyContent:'space-between' }}>
            <Typography sx={{ fontSize:'0.72rem', color:'#888' }}>Total</Typography>
            <Typography sx={{ fontSize:'0.72rem', fontWeight:700 }}>{payload[0]?.payload?.total}</Typography>
          </Box>
        </Paper>
      );
    };

    return (
      <Box sx={{ p:3 }}>
        <Typography variant="h6" sx={{ fontWeight:700, color:'#1a3a1a', mb:2.5 }}>Resumen del ecosistema</Typography>

        {/* ── KPI Cards ── */}
        <Grid container spacing={2} sx={{ mb:3 }}>
          <Grid item xs={6} sm={3}><KpiCard icon={<PeopleIcon/>}    label="Total usuarios"  value={kpis?.totalUsuarios} /></Grid>
          <Grid item xs={6} sm={3}><KpiCard icon={<ToggleOnIcon/>}  label="Activos"         value={kpis?.activos}      color="#2e7d32" bg="#e8f5e9"/></Grid>
          <Grid item xs={6} sm={3}><KpiCard icon={<VerifiedIcon/>}  label="Email confirmado" value={kpis?.confirmados}  color="#1565c0" bg="#e3f2fd"/></Grid>
          <Grid item xs={6} sm={3}><KpiCard icon={<PersonAddIcon/>} label="Nuevos (7 días)"  value={kpis?.ultimos7}    color="#e65100" bg="#fff3e0"/></Grid>
        </Grid>

        {/* ── Fila 1: dos gráficos de queso ── */}
        <Grid container spacing={2.5} sx={{ mb:2.5 }}>

          {/* Queso 1 — Estado de usuarios */}
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p:2.5, border:'1px solid #e0e0e0', borderRadius:2.5, height:280 }}>
              <ChartTitle>Estado de usuarios (activos vs inactivos)</ChartTitle>
              {!kpis ? <Box sx={{ textAlign:'center', pt:4 }}><CircularProgress size={28}/></Box> : (
                <ResponsiveContainer width="100%" height={210}>
                  <PieChart>
                    <Pie data={estadoUsuariosData} cx="50%" cy="50%" outerRadius={80} innerRadius={45}
                      dataKey="value" nameKey="name" paddingAngle={3}
                      label={({ name, percent }) => `${name} ${(percent*100).toFixed(0)}%`}
                      labelLine={false}>
                      {estadoUsuariosData.map((_, i) => <Cell key={i} fill={PIE_ESTADO_USUARIOS[i % PIE_ESTADO_USUARIOS.length]}/>)}
                    </Pie>
                    <RTooltip content={<PieTooltipCustom/>}/>
                    <Legend wrapperStyle={{ fontSize:'0.72rem' }}/>
                  </PieChart>
                </ResponsiveContainer>
              )}
            </Paper>
          </Grid>

          {/* Queso 2 — Estado de solicitudes */}
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p:2.5, border:'1px solid #e0e0e0', borderRadius:2.5, height:280 }}>
              <ChartTitle>Estado de solicitudes de afiliación</ChartTitle>
              {!kpis ? <Box sx={{ textAlign:'center', pt:4 }}><CircularProgress size={28}/></Box> : (
                <ResponsiveContainer width="100%" height={210}>
                  <PieChart>
                    <Pie data={estadoAfiliadosData} cx="50%" cy="50%" outerRadius={80} innerRadius={45}
                      dataKey="value" nameKey="name" paddingAngle={3}
                      label={({ name, percent }) => `${name.charAt(0)+name.slice(1).toLowerCase()} ${(percent*100).toFixed(0)}%`}
                      labelLine={false}>
                      {estadoAfiliadosData.map((entry, i) => <Cell key={i} fill={entry.fill}/>)}
                    </Pie>
                    <RTooltip content={<PieTooltipCustom/>}/>
                    <Legend wrapperStyle={{ fontSize:'0.72rem' }}/>
                  </PieChart>
                </ResponsiveContainer>
              )}
            </Paper>
          </Grid>
        </Grid>

        {/* ── Fila 2: Barras apiladas por departamento ── */}
        <Grid container spacing={2.5} sx={{ mb:2.5 }}>
          <Grid item xs={12}>
            <Paper elevation={0} sx={{ p:2.5, border:'1px solid #e0e0e0', borderRadius:2.5 }}>
              <ChartTitle>Solicitudes por departamento — top 10 (activos / pendientes / rechazados)</ChartTitle>
              {deptoData.length === 0 ? (
                <Box sx={{ textAlign:'center', py:3, color:'#ccc' }}><Typography variant="caption">Sin datos de departamentos</Typography></Box>
              ) : (
                <ResponsiveContainer width="100%" height={260}>
                  <BarChart data={deptoData} margin={{ top:5, right:20, left:0, bottom:40 }}
                    barCategoryGap="30%">
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false}/>
                    <XAxis dataKey="name" tick={{ fontSize:10, fill:'#666' }} angle={-35} textAnchor="end" interval={0}/>
                    <YAxis tick={{ fontSize:10, fill:'#888' }} allowDecimals={false}/>
                    <RTooltip content={<BarTooltipCustom/>}/>
                    <Legend wrapperStyle={{ fontSize:'0.72rem', paddingTop:8 }}/>
                    <Bar dataKey="activos"    name="Activos"    stackId="a" fill="#2e7d32" radius={[0,0,0,0]}/>
                    <Bar dataKey="pendientes" name="Pendientes" stackId="a" fill="#e65100" radius={[0,0,0,0]}/>
                    <Bar dataKey="rechazados" name="Rechazados" stackId="a" fill="#c62828" radius={[3,3,0,0]}/>
                  </BarChart>
                </ResponsiveContainer>
              )}
            </Paper>
          </Grid>
        </Grid>

        {/* ── Fila 3: Barras agrupadas por municipio ── */}
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <Paper elevation={0} sx={{ p:2.5, border:'1px solid #e0e0e0', borderRadius:2.5 }}>
              <ChartTitle>Solicitudes por municipio — top 10 (activos / pendientes / rechazados)</ChartTitle>
              {muniData.length === 0 ? (
                <Box sx={{ textAlign:'center', py:3, color:'#ccc' }}><Typography variant="caption">Sin datos de municipios</Typography></Box>
              ) : (
                <ResponsiveContainer width="100%" height={260}>
                  <BarChart data={muniData} margin={{ top:5, right:20, left:0, bottom:50 }}
                    barCategoryGap="25%" barGap={2}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false}/>
                    <XAxis dataKey="name" tick={{ fontSize:10, fill:'#666' }} angle={-35} textAnchor="end" interval={0}/>
                    <YAxis tick={{ fontSize:10, fill:'#888' }} allowDecimals={false}/>
                    <RTooltip content={<BarTooltipCustom/>}/>
                    <Legend wrapperStyle={{ fontSize:'0.72rem', paddingTop:8 }}/>
                    <Bar dataKey="activos"    name="Activos"    fill="#43a047" radius={[3,3,0,0]}/>
                    <Bar dataKey="pendientes" name="Pendientes" fill="#ef6c00" radius={[3,3,0,0]}/>
                    <Bar dataKey="rechazados" name="Rechazados" fill="#e53935" radius={[3,3,0,0]}/>
                  </BarChart>
                </ResponsiveContainer>
              )}
            </Paper>
          </Grid>
        </Grid>

        {/* ── Gráfico por Cooperativa ── */}
        {(kpis?.porCooperativa || []).length > 0 && (
          <Grid container spacing={2} sx={{ mt:1 }}>
            <Grid item xs={12}>
              <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2, p:2.5 }}>
                <Typography sx={{ fontWeight:700, fontSize:'0.85rem', color:'#1a3a1a', mb:2 }}>
                  Afiliados por Cooperativa
                </Typography>
                <ResponsiveContainer width="100%" height={260}>
                  <BarChart
                    data={(kpis.porCooperativa || []).map(c => ({
                      name: c.siglas || (c.nombre?.length > 14 ? c.nombre.substring(0,14)+'…' : c.nombre),
                      nombreFull: c.nombre,
                      activos: c.activos || 0,
                      pendientes: c.pendientes || 0,
                      rechazados: c.rechazados || 0,
                      total: c.total,
                    }))}
                    margin={{ top:5, right:20, left:0, bottom:40 }}
                    barCategoryGap="25%" barGap={2}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false}/>
                    <XAxis dataKey="name" tick={{ fontSize:11, fill:'#666' }} angle={-25} textAnchor="end" interval={0}/>
                    <YAxis tick={{ fontSize:10, fill:'#888' }} allowDecimals={false}/>
                    <RTooltip content={<BarTooltipCustom/>}/>
                    <Legend wrapperStyle={{ fontSize:'0.75rem', paddingTop:8 }}/>
                    <Bar dataKey="activos"   name="Activos"    fill={BAR_COLORS.activos}    radius={[3,3,0,0]}/>
                    <Bar dataKey="pendientes" name="Pendientes" fill={BAR_COLORS.pendientes} radius={[3,3,0,0]}/>
                    <Bar dataKey="rechazados" name="Rechazados" fill={BAR_COLORS.rechazados} radius={[3,3,0,0]}/>
                  </BarChart>
                </ResponsiveContainer>
              </Paper>
            </Grid>
          </Grid>
        )}
      </Box>
    );
  };

  // ── TAB USUARIOS ──────────────────────────────────────────────────────

  // ── TAB AFILIACIONES ──────────────────────────────────────────────────
  const limpiarFiltrosAf = () => {
    setAfBuscar(''); setAfBuscarInput(''); setAfEstado(''); setAfModalidad('');
    setAfDepto(''); setAfMuniId(''); setAfMunis([]);
    setAfFechaDesde(''); setAfFechaHasta('');
    setShowDatePicker(false); setPageAf(1);
  };
  const filtrosAfActivos = [afBuscar, afEstado, afModalidad, afDepto, afMuniId, afFechaDesde, afFechaHasta].filter(Boolean).length;
  const pagesAf = Math.ceil(totalAf2 / 25);


  // ── RENDER ─────────────────────────────────────────────────────────────
  return (
    <Box sx={{ minHeight:'100vh', background:'#f5f7f5', display:'flex', flexDirection:'column' }}>
      <Header/>
      <NavTabs/>
      <FiltroCoopeSelector/>

      <Box sx={{ flex:1, overflow:'auto' }}>
        {tab === 'dashboard'    && <TabDashboard/>}
        {tab === 'usuarios' && (
      <Box sx={{ p:3 }}>
        {/* Encabezado */}
        <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:2 }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1.2 }}>
            <Typography variant="h6" sx={{ fontWeight:700, color:'#1a3a1a' }}>
              Usuarios registrados
            </Typography>
            {totalUs > 0 && (
              <Chip label={totalUs} size="small"
                sx={{ fontWeight:700, background:'#e8f5e9', color:'#2e7d32' }}/>
            )}
            {kpis?.activos !== undefined && (
              <Chip label={`${kpis.activos} activos`} size="small" color="success"
                sx={{ fontWeight:700 }}/>
            )}
            {kpis && totalUs - kpis.activos > 0 && (
              <Chip label={`${totalUs - kpis.activos} inactivos`} size="small"
                sx={{ fontWeight:700, background:'#f5f5f5', color:'#888' }}/>
            )}
          </Box>
          <Box sx={{ display:'flex', gap:1 }}>
            {[buscar, filtroRol, filtroActivo, filtroCarnet].filter(v => v !== '' && v != null).length > 0 && (
              <Button size="small" color="error" variant="outlined"
                onClick={()=>{ setBuscar(''); setBuscarInput(''); setFiltroRol(''); setFiltroActivo(''); setFiltroCarnet(''); setPageUs(1); }}
                sx={{ borderRadius:2, fontSize:'0.72rem' }}>
                Limpiar {[buscar, filtroRol, filtroActivo, filtroCarnet].filter(v => v !== '' && v != null).length} filtro{[buscar, filtroRol, filtroActivo, filtroCarnet].filter(v => v !== '' && v != null).length>1?'s':''}
              </Button>
            )}
            <Button size="small" startIcon={loading ? <CircularProgress size={14} color="inherit"/> : <RefreshIcon/>}
              onClick={cargarUsuarios} disabled={loading} sx={{ color:'#2e7d32' }}>
              Actualizar
            </Button>
            <Button size="small" variant="contained" startIcon={<PersonAddIcon/>}
              onClick={() => setDlgCrearUser(true)}
              sx={{ background:'linear-gradient(135deg,#1a4d2e,#2e7d32)', borderRadius:2, fontSize:'0.75rem' }}>
              Nuevo usuario
            </Button>
          </Box>
        </Box>
        {/* Filtros */}
        <Box sx={{ display:'flex', gap:1.5, mb:2.5, flexWrap:'wrap', alignItems:'center' }}>
          <Box sx={{ position:'relative', minWidth:220 }}>
            <SearchIcon sx={{ position:'absolute', left:8, top:'50%', transform:'translateY(-50%)', fontSize:18, color:'#aaa', pointerEvents:'none' }}/>
            <input
              ref={buscarRef}
              placeholder="Buscar nombre, email, cédula…"
              value={buscarInput}
              onChange={e => {
                const v = e.target.value;
                setBuscarInput(v);
                clearTimeout(buscarTimer.current);
                buscarTimer.current = setTimeout(() => { setBuscar(v); setPageUs(1); }, 400);
              }}
              style={{ paddingLeft:32, height:40, borderRadius:6, border:'1px solid #c8d8c8',
                outline:'none', fontSize:'0.85rem', width:'100%', boxSizing:'border-box',
                fontFamily:'inherit', color:'#333' }}
            />
          </Box>
          <FormControl size="small" sx={{ minWidth:160 }}>
            <InputLabel>Rol</InputLabel>
            <Select value={filtroRol} label="Rol" onChange={e=>{ setFiltroRol(e.target.value); setPageUs(1); }}>
              <MenuItem value="">Todos</MenuItem>
              {roles.map(r => <MenuItem key={r} value={r}>{r}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth:130 }}>
            <InputLabel>Estado</InputLabel>
            <Select value={filtroActivo} label="Estado" onChange={e=>{ setFiltroActivo(e.target.value); setPageUs(1); }}>
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="true">Activo</MenuItem>
              <MenuItem value="false">Inactivo</MenuItem>
            </Select>
          </FormControl>
          <FormControl size="small" sx={{ minWidth:140 }}>
            <InputLabel>Carnet</InputLabel>
            <Select value={filtroCarnet} label="Carnet" onChange={e=>{ setFiltroCarnet(e.target.value); setPageUs(1); }}>
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="true">Con carnet</MenuItem>
              <MenuItem value="false">Sin carnet</MenuItem>
            </Select>
          </FormControl>
  
        </Box>
  
        <TableContainer component={Paper} elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ background:'#f8fdf8' }}>
                {['Usuario','Documento','Cooperativa','Roles','Último acceso','Estado','Carnet','Acciones'].map(h=>(
                  <TableCell key={h} sx={{ fontWeight:700, fontSize:'0.72rem', color:'#2e7d32', textTransform:'uppercase', letterSpacing:'0.05em', whiteSpace:'nowrap' }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow><TableCell colSpan={8} sx={{ textAlign:'center', py:4 }}><CircularProgress size={28}/></TableCell></TableRow>
              )}
              {!loading && usuarios.length === 0 && (
                <TableRow><TableCell colSpan={8} sx={{ textAlign:'center', py:4, color:'#aaa' }}>Sin resultados</TableCell></TableRow>
              )}
              {usuarios.map(u => (
                <TableRow key={u.id} hover sx={{ '&:last-child td':{borderBottom:0} }}>
                  <TableCell sx={{ py:1 }}>
                    <Box sx={{ display:'flex', alignItems:'center', gap:1.2 }}>
                      <Avatar sx={{ width:30, height:30, background:'linear-gradient(135deg,#1a4d2e,#43a047)', fontSize:'0.7rem', fontWeight:700 }}>
                        {u.nombre?.[0]}{u.apellido?.[0]}
                      </Avatar>
                      <Box>
                        <Typography sx={{ fontWeight:600, fontSize:'0.82rem', color:'#1a1a1a' }}>{u.nombre} {u.apellido}</Typography>
                        <Typography sx={{ fontSize:'0.72rem', color:'#888' }}>{u.email}</Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontSize:'0.76rem', fontFamily:'monospace' }}>{u.documento || '—'}</TableCell>
                  <TableCell sx={{ fontSize:'0.72rem', color:'#1565c0' }}>
                    {(u.cooperativas || []).length > 0 ? (
                      <Box sx={{ display:'flex', flexDirection:'column', gap:0.4 }}>
                        {u.cooperativas.map(c => (
                          <Chip
                            key={c.cooperativaID}
                            label={c.siglas || c.nombre?.substring(0, 20) || `#${c.cooperativaID}`}
                            size="small"
                            sx={{
                              fontSize: '0.68rem', height: 20, fontWeight: 600,
                              background: c.esPrincipal ? '#e3f2fd' : '#f5f5f5',
                              color: c.esPrincipal ? '#1565c0' : '#555',
                              border: c.esPrincipal ? '1px solid #90caf9' : '1px solid #ddd',
                              maxWidth: 180,
                            }}
                          />
                        ))}
                      </Box>
                    ) : u.cooperativaID ? (
                      // Fallback legacy si no hay vínculos en UsuarioCooperativas
                      coops.find(c=>c.cooperativaID===u.cooperativaID)?.siglas
                      || coops.find(c=>c.cooperativaID===u.cooperativaID)?.nombre?.substring(0,15)
                      || `#${u.cooperativaID}`
                    ) : (
                      <span style={{color:'#aaa'}}>Global</span>
                    )}
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display:'flex', gap:0.5, flexWrap:'wrap' }}>
                      {(u.roles||[]).map(r=>(
                        <Chip key={r} label={r} size="small" color={ROLE_COLORS[r]||'default'}
                          sx={{ fontSize:'0.65rem', height:20, fontWeight:600 }}/>
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontSize:'0.72rem', whiteSpace:'nowrap', color:'#888' }}>{fmtHora(u.ultimoAcceso)}</TableCell>
                  <TableCell>
                    <Chip label={u.activo?'Activo':'Inactivo'} size="small"
                      color={u.activo?'success':'default'}
                      sx={{ fontSize:'0.68rem', height:20, fontWeight:700 }}/>
                    {u.emailConfirmed === false && (
                      <Chip label="Correo sin confirmar" size="small"
                        sx={{ mt:0.5, display:'flex', width:'fit-content', fontSize:'0.62rem', height:18, fontWeight:700,
                              background:'#fff3e0', color:'#e65100' }}/>
                    )}
                  </TableCell>
                  <TableCell>
                    {u.tieneCarnet ? (
                      <Chip
                        icon={<BadgeIcon sx={{ fontSize: 14, color: '#2e7d32 !important' }}/>}
                        label="Generado" size="small"
                        sx={{
                          background:'#e8f5e9', color:'#1a4d2e',
                          fontSize:'0.68rem', height:22, fontWeight:700,
                          border:'0.5px solid #2e7d3240',
                          '& .MuiChip-icon': { color:'#2e7d32' },
                        }}
                      />
                    ) : (
                      <Typography sx={{ fontSize:'0.72rem', color:'#aaa' }}>—</Typography>
                    )}
                  </TableCell>
                  <TableCell sx={{ whiteSpace:'nowrap' }}>
                    <Tooltip title={u.activo?'Desactivar':'Activar'}>
                      <IconButton size="small" onClick={()=>toggleEstado(u)}
                        sx={{ color: u.activo?'#43a047':'#bbb' }}>
                        {u.activo ? <ToggleOnIcon/> : <ToggleOffIcon/>}
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Editar usuario">
                      <IconButton size="small" onClick={()=>abrirEditar(u)} sx={{ color:'#1565c0' }}>
                        <EditIcon fontSize="small"/>
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Cambiar contraseña">
                      <IconButton size="small"
                        onClick={()=>setDlgPass({
                          open:true,
                          id:u.id,
                          val:'',
                          nombre: `${u.nombre || ''} ${u.apellido || ''}`.trim() || u.email || '',
                          email: u.email || '',
                        })}
                        sx={{ color:'#e65100' }}>
                        <LockResetIcon fontSize="small"/>
                      </IconButton>
                    </Tooltip>
                    {u.emailConfirmed === false && (
                      <Tooltip title="Reenviar correo de confirmación">
                        <span>
                          <IconButton size="small" onClick={()=>handleReenviarConfirmacion(u)}
                            disabled={correoAccion === u.id} sx={{ color:'#0277bd' }}>
                            <ForwardToInboxIcon fontSize="small"/>
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                    {u.emailConfirmed === false && esSuperAdmin() && (
                      <Tooltip title="Marcar correo como confirmado (SuperAdmin)">
                        <span>
                          <IconButton size="small" onClick={()=>handleConfirmarEmail(u)}
                            disabled={correoAccion === u.id} sx={{ color:'#2e7d32' }}>
                            <MarkEmailReadIcon fontSize="small"/>
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                    <Tooltip title={
                      tieneCarnetHabilitado(u)
                        ? (u.tieneCarnet ? 'Regenerar carnet' : 'Generar carnet')
                        : 'Carnet no disponible — el usuario no pertenece a FENAGRO APL ni a Capellanías'
                    }>
                      <span>
                        <IconButton
                          size="small"
                          onClick={()=>generarCarnetDelUsuario(u)}
                          disabled={!tieneCarnetHabilitado(u) || generandoCarnet === u.id}
                          sx={{ color: tieneCarnetHabilitado(u) ? '#2e7d32' : '#ccc' }}
                        >
                          {generandoCarnet === u.id
                            ? <CircularProgress size={16} sx={{ color:'#2e7d32' }}/>
                            : <BadgeIcon fontSize="small"/>}
                        </IconButton>
                      </span>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
  
        {/* Paginación */}
        {totalPages > 1 && (
          <Box sx={{ display:'flex', justifyContent:'center', gap:1, mt:2 }}>
            <Button size="small" disabled={pageUs===1} onClick={()=>setPageUs(p=>p-1)} variant="outlined">← Anterior</Button>
            <Typography variant="body2" sx={{ alignSelf:'center', color:'#666' }}>Página {pageUs} de {totalPages}</Typography>
            <Button size="small" disabled={pageUs>=totalPages} onClick={()=>setPageUs(p=>p+1)} variant="outlined">Siguiente →</Button>
          </Box>
        )}
      </Box>
        )}

        {tab === 'afiliaciones' && esOrientador() && <VistaOrientador onToast={toast}/>}
        {tab === 'afiliaciones' && !esOrientador() && (
      <Box sx={{ p:3 }}>
        {/* ── Encabezado ── */}
        <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:2 }}>
          <Typography variant="h6" sx={{ fontWeight:700, color:'#1a3a1a' }}>
            Solicitudes de Afiliación
            {totalAf2 > 0 && <Chip label={totalAf2} size="small" sx={{ ml:1.5, fontWeight:700, background:'#e8f5e9', color:'#2e7d32' }}/>}
            {afEstado === 'PENDIENTE' || (!afEstado && afiliaciones.some(a=>a.estado==='PENDIENTE'))
              ? <Chip label={afiliaciones.filter(a=>a.estado==='PENDIENTE').length+' pend.'} color="warning" size="small" sx={{ ml:1, fontWeight:700 }}/>
              : null}
          </Typography>
          <Box sx={{ display:'flex', gap:1 }}>
            {filtrosAfActivos > 0 && (
              <Button size="small" color="error" variant="outlined" onClick={limpiarFiltrosAf}
                sx={{ borderRadius:2, fontSize:'0.72rem' }}>
                Limpiar {filtrosAfActivos} filtro{filtrosAfActivos>1?'s':''}
              </Button>
            )}
            <Button size="small" startIcon={<RefreshIcon/>} onClick={cargarAfiliaciones} disabled={loading}
              sx={{ color:'#2e7d32' }}>
              Actualizar
            </Button>
          </Box>
        </Box>
  
        {/* ── Filtros ── */}
        <Box sx={{ display:'flex', gap:1.5, mb:2, flexWrap:'wrap', alignItems:'center' }}>
            <Box sx={{ position:'relative', width:210 }}>
              <SearchIcon sx={{ position:'absolute', left:8, top:'50%', transform:'translateY(-50%)', fontSize:17, color:'#aaa', pointerEvents:'none' }}/>
              <input
                ref={afBuscarRef}
                placeholder="Nombre, cédula o correo…"
                value={afBuscarInput}
                onChange={e => {
                  const v = e.target.value;
                  setAfBuscarInput(v);
                  clearTimeout(afBuscarTimer.current);
                  afBuscarTimer.current = setTimeout(() => { setAfBuscar(v); setPageAf(1); }, 400);
                }}
                style={{ paddingLeft:32, height:40, borderRadius:6, border:'1px solid #c8d8c8',
                  outline:'none', fontSize:'0.85rem', width:'100%', boxSizing:'border-box',
                  fontFamily:'inherit', color:'#333' }}
              />
            </Box>
            <FormControl size="small" sx={{ width:140 }}>
              <InputLabel>Estado</InputLabel>
              <Select value={afEstado} label="Estado" onChange={e=>{ setAfEstado(e.target.value); setPageAf(1); }}>
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="PENDIENTE">Pendiente</MenuItem>
                <MenuItem value="ACTIVO">Activo</MenuItem>
                <MenuItem value="RECHAZADO">Rechazado</MenuItem>
                <MenuItem value="SUSPENDIDO">Suspendido</MenuItem>
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ width:130 }}>
              <InputLabel>Modalidad</InputLabel>
              <Select value={afModalidad} label="Modalidad" onChange={e=>{ setAfModalidad(e.target.value); setPageAf(1); }}>
                <MenuItem value="">Todas</MenuItem>
                <MenuItem value="DINERO">Dinero</MenuItem>
                <MenuItem value="TRABAJO">Trabajo</MenuItem>
                <MenuItem value="BIENES">Bienes</MenuItem>
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ width:160 }}>
              <InputLabel>Departamento</InputLabel>
              <Select value={afDepto} label="Departamento"
                onChange={e=>{ setAfDepto(e.target.value); setAfMuniId(''); setAfMunis([]); setPageAf(1);
                  if (e.target.value) getMunicipios(e.target.value).then(setAfMunis).catch(()=>{}); }}>
                <MenuItem value=""><em>Todos</em></MenuItem>
                {afDeptos.map(d=>(
                  <MenuItem key={d.departamentoID||d.DepartamentoID} value={d.departamentoID||d.DepartamentoID}>
                    {d.nombre||d.Nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ width:160 }} disabled={!afDepto}>
              <InputLabel>{afDepto ? 'Municipio' : 'Seleccione departamento'}</InputLabel>
              <Select value={afMuniId} label="Municipio" onChange={e=>{ setAfMuniId(e.target.value); setPageAf(1); }}>
                <MenuItem value=""><em>Todos</em></MenuItem>
                {afMunis.map(m=>(
                  <MenuItem key={m.municipioID||m.MunicipioID} value={m.municipioID||m.MunicipioID}>
                    {m.nombre||m.Nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Fecha — icono botón */}
            <Box sx={{ flexShrink:0 }}>
              <Box ref={datePickerRef} sx={{ position:'relative' }}>
                <Tooltip title={afFechaDesde||afFechaHasta ? `${afFechaDesde||'…'} → ${afFechaHasta||'…'}` : 'Rango de fechas'}>
                  <IconButton
                    size="small"
                    onClick={()=>setShowDatePicker(p=>!p)}
                    sx={{
                      width:36, height:36,
                      background: afFechaDesde||afFechaHasta
                        ? 'linear-gradient(135deg,#1a4d2e,#2e7d32)'
                        : 'rgba(0,0,0,0.04)',
                      border: '1px solid',
                      borderColor: afFechaDesde||afFechaHasta ? '#1a4d2e' : '#c8d8c8',
                      borderRadius: 1.5,
                      fontSize: 16,
                      '&:hover':{ background: afFechaDesde||afFechaHasta ? '#143d22' : 'rgba(0,0,0,0.08)' },
                    }}>
                    <span style={{ fontSize:16, lineHeight:1 }}>📅</span>
                  </IconButton>
                </Tooltip>
  
                {/* Popover flotante */}
                {showDatePicker && (
                  <Paper elevation={8} sx={{
                    position:'absolute', top:'calc(100% + 6px)', right:0, zIndex:999,
                    p:2, borderRadius:2, minWidth:280,
                    boxShadow:'0 8px 32px rgba(0,0,0,0.18)',
                    border:'1px solid #e0e0e0',
                  }}>
                    <Typography variant="caption" sx={{ fontWeight:700, color:'#555', display:'block', mb:1.5, textTransform:'uppercase', letterSpacing:'0.06em' }}>
                      Rango de fechas
                    </Typography>
                    <Box sx={{ display:'flex', flexDirection:'column', gap:1.5 }}>
                      <TextField size="small" fullWidth label="Desde" type="date"
                        value={afFechaDesde}
                        onChange={e=>{ setAfFechaDesde(e.target.value); setPageAf(1); }}
                        InputLabelProps={{ shrink:true }}/>
                      <TextField size="small" fullWidth label="Hasta" type="date"
                        value={afFechaHasta}
                        onChange={e=>{ setAfFechaHasta(e.target.value); setPageAf(1); }}
                        InputLabelProps={{ shrink:true }}/>
                    </Box>
                    <Box sx={{ display:'flex', justifyContent:'space-between', mt:1.5, gap:1 }}>
                      <Button size="small" color="error" variant="text"
                        disabled={!afFechaDesde && !afFechaHasta}
                        onClick={()=>{ setAfFechaDesde(''); setAfFechaHasta(''); setPageAf(1); }}>
                        Limpiar fechas
                      </Button>
                      <Button size="small" variant="contained" color="success"
                        onClick={()=>setShowDatePicker(false)}>
                        Aplicar
                      </Button>
                    </Box>
                  </Paper>
                )}
              </Box>
            </Box>
          </Box>
  
        {/* ── Tabla ── */}
        <TableContainer component={Paper} elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ background:'#f8fdf8' }}>
                {['#','Nombre','Cédula','Email','Municipio','Cooperativa','Modalidad','Fecha','Estado','Acciones'].map(h=>(
                  <TableCell key={h} sx={{ fontWeight:700, fontSize:'0.72rem', color:'#2e7d32', textTransform:'uppercase', letterSpacing:'0.05em', whiteSpace:'nowrap' }}>{h}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {afiliaciones.map(a => {
                const chip = { PENDIENTE:{color:'warning'}, ACTIVO:{color:'success'}, RECHAZADO:{color:'error'} }[a.estado] || {color:'default'};
                return (
                  <TableRow key={a.afiliadoID} hover sx={{ '&:last-child td':{borderBottom:0} }}>
                    <TableCell sx={{ fontSize:'0.72rem', color:'#bbb' }}>#{a.afiliadoID}</TableCell>
                    <TableCell sx={{ fontWeight:600, fontSize:'0.82rem', whiteSpace:'nowrap' }}>{a.nombres} {a.apellidos}</TableCell>
                    <TableCell sx={{ fontSize:'0.76rem', fontFamily:'monospace' }}>
                      {a.documento}
                      {esCedulaTest(a.documento) && (
                        <Chip label="TEST" size="small" color="warning"
                          sx={{ ml: 0.5, fontSize:'0.55rem', height:14, '& .MuiChip-label': { px: 0.5 } }} />
                      )}
                    </TableCell>
                    <TableCell sx={{ fontSize:'0.72rem', maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                      <Tooltip title={a.email||''}><span>{a.email||'—'}</span></Tooltip>
                    </TableCell>
                    <TableCell sx={{ fontSize:'0.72rem' }}>{[a.municipio,a.departamento].filter(Boolean).join(', ')||'—'}</TableCell>
                    <TableCell sx={{ fontSize:'0.72rem', color:'#1565c0', whiteSpace:'nowrap' }}>
                      {a.cooperativa || '—'}
                    </TableCell>
                    <TableCell><Chip label={a.modalidadAporte||'—'} size="small" variant="outlined" sx={{ fontSize:'0.65rem', height:20, color:'#2e7d32', borderColor:'#c8e6c9' }}/></TableCell>
                    <TableCell sx={{ fontSize:'0.72rem', whiteSpace:'nowrap' }}>{fmt(a.fechaCreacion)}</TableCell>
                    <TableCell><Chip label={a.estado} color={chip.color} size="small" sx={{ fontSize:'0.68rem', fontWeight:700 }}/></TableCell>
                    <TableCell sx={{ whiteSpace:'nowrap' }}>
                      <Tooltip title="Ver detalle completo">
                        <IconButton size="small" onClick={()=>abrirDetalle(a.afiliadoID)}
                          sx={{ color:'#1565c0' }}>
                          <VisibilityIcon fontSize="small"/>
                        </IconButton>
                      </Tooltip>
                      {a.estado === 'PENDIENTE' && puedeAprobarRechazar() && (<>
                        <Tooltip title="Aprobar">
                          <IconButton size="small" color="success" onClick={()=>handleAprobar(a.afiliadoID,`${a.nombres} ${a.apellidos}`)}>
                            <CheckCircleIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Rechazar">
                          <IconButton size="small" color="error" onClick={()=>setDlgRechazar({open:true,id:a.afiliadoID,motivo:''})}>
                            <CancelIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      </>)}
                      {a.estado === 'RECHAZADO' && puedeAprobarRechazar() && (
                        <Tooltip title="Reevaluar (reactivar solicitud)">
                          <IconButton size="small" sx={{ color:'#e65100' }}
                            onClick={()=>setDlgReevaluar({open:true,id:a.afiliadoID,nombre:`${a.nombres} ${a.apellidos}`,motivo:''})}>
                            <ReplayIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      )}
                      {!['ACTIVO','RECHAZADO','ABANDONADA'].includes(a.estado) && esSuperAdmin() && (
                        <Tooltip title="Recalcular estado (solicitud atascada)">
                          <IconButton size="small" sx={{ color:'#5d4037' }} onClick={()=>abrirReactivar(a, 'recalcular')}>
                            <CalculateIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      )}
                      {a.estado === 'ABANDONADA' && esSuperAdmin() && (
                        <Tooltip title="Reactivar solicitud abandonada (ver causa)">
                          <IconButton size="small" sx={{ color:'#2e7d32' }} onClick={()=>abrirReactivar(a)}>
                            <RestoreIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      )}
                      {a.tieneSesion && puedeAprobarRechazar() && (
                        <Tooltip title="Eliminar sesion de orientacion">
                          <IconButton size="small" sx={{ color:'#6a1b9a' }}
                            onClick={()=>setDlgEliminarSesion({open:true,id:a.afiliadoID,nombre:`${a.nombres} ${a.apellidos}`,motivo:''})}>
                            <EventBusyIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      )}
                      {puedeEliminarCompleto() && (
                        <Tooltip title="Eliminar solicitud completa (sin rastro)">
                          <IconButton size="small" sx={{ color:'#b71c1c' }}
                            onClick={()=>setDlgEliminarCompleto({open:true,id:a.afiliadoID,nombre:`${a.nombres} ${a.apellidos}`,motivo:''})}>
                            <DeleteForeverIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      )}
                      {!a.pagoInscripcionConfirmado && puedeAprobarRechazar() && (
                        <Tooltip title="Aceptar sin pago (pago externo al sistema — queda en auditoría)">
                          <IconButton size="small" sx={{ color:'#00838f' }}
                            onClick={()=>setDlgPagoManual({
                              open:true,
                              id: a.afiliadoID,
                              nombre: `${a.nombres} ${a.apellidos}`,
                              ref: '',
                              monto: 150000,
                              notas: ''
                            })}>
                            <MonetizationOnIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      )}
                      {/* Activar acceso al portal: flujo completo (Estado=ACTIVO) pero login aún deshabilitado */}
                      {a.estado === 'ACTIVO' && a.pagoInscripcionConfirmado && puedeAprobarRechazar() && !a.accesoActivo && (
                        <Tooltip title="Activar acceso al portal (paso final)">
                          <IconButton size="small" sx={{ color:'#2e7d32' }}
                            onClick={()=>setDlgActivarAcceso({ open:true, id:a.afiliadoID, nombre:`${a.nombres} ${a.apellidos}`, motivo:'' })}>
                            <LockOpenIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      )}
                      {puedeAprobarRechazar() && (
                        <Tooltip title="Reasignar cooperativa">
                          <IconButton size="small" sx={{ color:'#0277bd' }}
                            onClick={()=>setDlgReasignarCoop({open:true,id:a.afiliadoID,nombre:`${a.nombres} ${a.apellidos}`,cooperativaId:a.cooperativaID||'',motivo:''})}>
                            <SwapHorizIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
  
        {/* ── Paginación ── */}
        {pagesAf > 1 && (
          <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', gap:1, mt:2 }}>
            <Button size="small" disabled={pageAf===1} onClick={()=>setPageAf(p=>p-1)} variant="outlined">← Anterior</Button>
            <Typography variant="body2" sx={{ color:'#666' }}>Página {pageAf} de {pagesAf} ({totalAf2} registros)</Typography>
            <Button size="small" disabled={pageAf>=pagesAf} onClick={()=>setPageAf(p=>p+1)} variant="outlined">Siguiente →</Button>
          </Box>
        )}
        {totalAf2 === 0 && !loading && (
          <Box sx={{ textAlign:'center', py:4, color:'#bbb' }}>
            <Typography variant="body2">Sin resultados {filtrosAfActivos>0?'con los filtros aplicados':'—'}</Typography>
          </Box>
        )}
      </Box>
        )}

        {tab === 'mapa'         && <MapaColombiaAdmin/>}
        {tab === 'aliados'      && <TabAliados onToast={toast}/>}
        {tab === 'canje'        && <TabCodigosCanje onToast={toast}/>}
        {tab === 'integraciones' && <TabIntegraciones onToast={toast}/>}
        {tab === 'pasarela' && (
          <Box sx={{ p:3, maxWidth:700 }}>
            <Typography variant="h6" sx={{ fontWeight:700, color:'#1a3a1a', mb:1, display:'flex', alignItems:'center', gap:1 }}>
              <SettingsIcon sx={{ color:'#2e7d32' }}/> Configuración de Pasarela de Pagos
            </Typography>
            <Typography variant="body2" sx={{ color:'#888', mb:3 }}>
              Configure las claves de Wompi para los pagos de inscripción ($150.000 COP).
              Las claves privadas nunca se muestran completas por seguridad — déjelas vacías para no modificarlas.
            </Typography>

            {cfgLoading && <CircularProgress size={24}/>}

            {!cfgLoading && (
              <Box sx={{ display:'flex', flexDirection:'column', gap:3 }}>

                {/* Ambiente */}
                <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2, p:3 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight:700, color:'#1a4d2e', mb:2, display:'flex', alignItems:'center', gap:1 }}>
                    <VpnKeyIcon fontSize="small"/> Ambiente activo
                  </Typography>
                  <FormControl size="small" sx={{ minWidth:200 }}>
                    <InputLabel>Ambiente</InputLabel>
                    <Select value={cfgEdit.ambiente || 'dev'} label="Ambiente"
                      onChange={e=>setCfgEdit(p=>({...p, ambiente:e.target.value}))}>
                      <MenuItem value="dev">Desarrollo (sandbox)</MenuItem>
                      <MenuItem value="prod">Producción</MenuItem>
                    </Select>
                  </FormControl>
                  <Alert severity={cfgEdit.ambiente === 'prod' ? 'warning' : 'info'} sx={{ mt:2, fontSize:'0.8rem' }}>
                    {cfgEdit.ambiente === 'prod'
                      ? '⚠️ Ambiente PRODUCCIÓN — los pagos son reales'
                      : '🧪 Ambiente DESARROLLO — use tarjetas de prueba de Wompi'}
                  </Alert>
                </Paper>

                {/* Claves Wompi */}
                <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2, p:3 }}>
                  <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:2 }}>
                    <Box sx={{ width:32, height:32, borderRadius:'50%', background:'#00b1c2', display:'flex', alignItems:'center', justifyContent:'center' }}>
                      <Typography sx={{ color:'#fff', fontWeight:800, fontSize:'0.8rem' }}>W</Typography>
                    </Box>
                    <Typography variant="subtitle2" sx={{ fontWeight:700, color:'#1a4d2e' }}>Wompi</Typography>
                  </Box>
                  <Box sx={{ display:'flex', flexDirection:'column', gap:2 }}>
                    <TextField size="small" fullWidth label="Clave Pública" autoComplete="off"
                      helperText={cfgEdit._tienePublicKey && !cfgEdit.publicKey ? "✓ Ya configurada — escribe para reemplazar" : "Empieza con pub_test_ o pub_prod_"}
                      placeholder={cfgEdit._tienePublicKey ? '••••••••••••' : 'No configurada'}
                      value={cfgEdit.publicKey || ''}
                      onChange={e=>setCfgEdit(p=>({...p, publicKey:e.target.value}))}/>
                    <TextField size="small" fullWidth label="Clave Privada" autoComplete="new-password"
                      type="password" helperText={cfgEdit._tienePrivateKey && !cfgEdit.privateKey ? "✓ Ya configurada — escribe para reemplazar" : "Empieza con prv_test_ o prv_prod_"}
                      placeholder={cfgEdit._tienePrivateKey ? '••••••••••••' : 'No configurada'}
                      value={cfgEdit.privateKey || ''}
                      onChange={e=>setCfgEdit(p=>({...p, privateKey:e.target.value}))}/>
                    <TextField size="small" fullWidth label="Integrity Secret" autoComplete="new-password"
                      type="password" helperText={cfgEdit._tieneIntegritySecret && !cfgEdit.integritySecret ? "✓ Ya configurado — escribe para reemplazar" : "Secreto para firmar el widget de pago (≠ Events Secret)"}
                      placeholder={cfgEdit._tieneIntegritySecret ? '••••••••••••' : 'No configurado'}
                      value={cfgEdit.integritySecret || ''}
                      onChange={e=>setCfgEdit(p=>({...p, integritySecret:e.target.value}))}/>
                    <TextField size="small" fullWidth label="Events Secret" autoComplete="new-password"
                      type="password" helperText={cfgEdit._tieneEventsSecret && !cfgEdit.eventsSecret ? "✓ Ya configurado — escribe para reemplazar" : "Secreto para verificar webhooks entrantes"}
                      placeholder={cfgEdit._tieneEventsSecret ? '••••••••••••' : 'No configurado'}
                      value={cfgEdit.eventsSecret || ''}
                      onChange={e=>setCfgEdit(p=>({...p, eventsSecret:e.target.value}))}/>
                  </Box>
                </Paper>

                {/* Monto y Redirect */}
                <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2, p:3 }}>
                  <Typography variant="subtitle2" sx={{ fontWeight:700, color:'#1a4d2e', mb:2 }}>
                    ⚙️ Configuración adicional
                  </Typography>
                  <Box sx={{ display:'flex', flexDirection:'column', gap:2 }}>
                    <TextField size="small" fullWidth label="Monto de inscripción (COP)" type="number"
                      value={cfgEdit.montoInscripcion || '150000'}
                      onChange={e=>setCfgEdit(p=>({...p, montoInscripcion:e.target.value}))}
                      helperText="Valor en pesos colombianos. Por defecto $150.000"/>
                    <TextField size="small" fullWidth label="URL de redirección post-pago"
                      value={cfgEdit.redirectUrl || ''}
                      onChange={e=>setCfgEdit(p=>({...p, redirectUrl:e.target.value}))}
                      helperText="Ej: https://fenagro-oficial.org/afiliacion-pago-resultado"/>
                  </Box>
                </Paper>

                <Button variant="contained" size="large" startIcon={<SaveIcon/>}
                  onClick={handleGuardarPasarela} disabled={cfgGuardando}
                  sx={{ background:'linear-gradient(135deg,#1a4d2e,#2e7d32)', alignSelf:'flex-start', px:4 }}>
                  {cfgGuardando ? <CircularProgress size={20} color="inherit"/> : 'Guardar configuración'}
                </Button>
              </Box>
            )}
          </Box>
        )}
        {tab === 'cooperativas' && (
          <Box sx={{ p:3 }}>
            <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:2, flexWrap:'wrap', gap:2 }}>
              <Typography variant="h6" sx={{ fontWeight:700, color:'#1a3a1a', display:'flex', alignItems:'center', gap:1 }}>
                <BusinessIcon sx={{ color:'#2e7d32' }}/> Cooperativas de la Red
                <Chip label={coops.length} size="small" color="primary" sx={{ fontWeight:700, ml:1 }}/>
              </Typography>
              <Button variant="contained" startIcon={<AddCircleIcon/>}
                sx={{ background:'#1a4d2e' }}
                onClick={()=>setDlgCoop({ open:true, modo:'crear', data:{ estado:'ACTIVO' } })}>
                Nueva cooperativa
              </Button>
            </Box>

            {coopsLoading && <LinearProgress sx={{ mb:2 }}/>}

            <TableContainer component={Paper} elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ background:'#f8fdf8' }}>
                    {['ID','Nombre','Siglas','Email','Teléfono','Sitio Web','Estado','Acciones'].map(h=>(
                      <TableCell key={h} sx={{ fontWeight:700, fontSize:'0.72rem', color:'#2e7d32', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {coops.length === 0 && !coopsLoading && (
                    <TableRow><TableCell colSpan={8} sx={{ textAlign:'center', py:5, color:'#aaa' }}>Sin cooperativas registradas</TableCell></TableRow>
                  )}
                  {coops.map(c => (
                    <TableRow key={c.cooperativaID} hover sx={{ '&:last-child td':{ borderBottom:0 } }}>
                      <TableCell sx={{ fontFamily:'monospace', fontWeight:700, color:'#1565c0' }}>#{c.cooperativaID}</TableCell>
                      <TableCell sx={{ fontWeight:600, fontSize:'0.82rem' }}>{c.nombre}</TableCell>
                      <TableCell><Chip label={c.siglas || '—'} size="small" sx={{ fontSize:'0.65rem' }}/></TableCell>
                      <TableCell sx={{ fontSize:'0.75rem', color:'#555' }}>{c.email || '—'}</TableCell>
                      <TableCell sx={{ fontSize:'0.75rem', color:'#555' }}>{c.telefono || '—'}</TableCell>
                      <TableCell sx={{ fontSize:'0.75rem' }}>
                        {c.sitioWeb ? <a href={c.sitioWeb} target="_blank" rel="noreferrer" style={{ color:'#1565c0', fontSize:'0.72rem' }}>{c.sitioWeb}</a> : '—'}
                      </TableCell>
                      <TableCell>
                        <Chip label={c.estado} size="small"
                          sx={{ fontSize:'0.65rem', fontWeight:700,
                            background: c.estado === 'ACTIVO' ? '#e8f5e9' : '#ffebee',
                            color: c.estado === 'ACTIVO' ? '#2e7d32' : '#c62828' }}/>
                        {c.estadoDocumentos && c.estadoDocumentos !== 'COMPLETO' && (
                          <Chip label="DOCS PENDIENTES" size="small"
                            sx={{ fontSize:'0.6rem', fontWeight:700, ml: 0.5,
                              background:'#fff3e0', color:'#ed6c02', border:'1px solid #ffb74d' }}/>
                        )}
                      </TableCell>
                      <TableCell sx={{ whiteSpace:'nowrap' }}>
                        {c.estadoDocumentos && c.estadoDocumentos !== 'COMPLETO' && (
                          <Tooltip title="Subir cédula del representante y aprobar">
                            <IconButton size="small" sx={{ color:'#ed6c02' }}
                              onClick={()=>setDlgAprobarCoop({ open:true, cooperativa: c })}>
                              <CheckCircleOutlineIcon fontSize="small"/>
                            </IconButton>
                          </Tooltip>
                        )}
                        <Tooltip title="Editar">
                          <IconButton size="small" sx={{ color:'#1565c0' }}
                            onClick={()=>setDlgCoop({ open:true, modo:'editar', data:{ ...c } })}>
                            <EditIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title={c.estado === 'ACTIVO' ? 'Desactivar' : 'Activar'}>
                          <IconButton size="small"
                            sx={{ color: c.estado === 'ACTIVO' ? '#2e7d32' : '#c62828' }}
                            onClick={()=>handleToggleCoop(c.cooperativaID, c.estado === 'ACTIVO')}>
                            {c.estado === 'ACTIVO' ? <ToggleOnIcon/> : <ToggleOffIcon/>}
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Dialog crear/editar */}
            <CooperativaWizardModal
              open={dlgCoop.open}
              modo={dlgCoop.modo}
              initialData={dlgCoop.data}
              onClose={() => setDlgCoop({ open:false, modo:'crear', data:{} })}
              onSubmit={async (dto) => {
                if (dlgCoop.modo === 'crear') {
                  await crearCooperativa({ ...dto, federacionId: 1 });
                  toast('Cooperativa creada');
                } else {
                  await actualizarCooperativa(dto.cooperativaID, dto);
                  toast('Cooperativa actualizada');
                }
                cargarCoops();
              }}
              onToast={toast}
            />

            {/* Dialog: aprobar documentos pendientes (subir cédula del representante) */}
            <Dialog open={dlgAprobarCoop.open} maxWidth="md" fullWidth
              onClose={() => { setDlgAprobarCoop({ open:false, cooperativa:null }); setUrlCedulaAprobar(null); }}>
              <DialogTitle sx={{
                background:'linear-gradient(135deg,#ed6c02,#f57c00)', color:'#fff',
                display:'flex', alignItems:'center', gap:1.5,
              }}>
                <CheckCircleOutlineIcon/>
                <Box sx={{ flex:1 }}>
                  <Typography sx={{ fontWeight:700 }}>Aprobar documentos pendientes</Typography>
                  <Typography variant="caption" sx={{ opacity:0.9 }}>
                    Cooperativa: {dlgAprobarCoop.cooperativa?.nombre || '—'}
                  </Typography>
                </Box>
              </DialogTitle>
              <DialogContent sx={{ pt: 3 }}>
                <Alert severity="warning" sx={{ mb: 2 }}>
                  Esta cooperativa se creó con la cédula del representante <strong>pendiente</strong>.
                  Debes subir el documento para completar la aprobación.
                </Alert>
                <Typography variant="body2" sx={{ mb: 1, color:'#555' }}>
                  Cédula de <strong>{dlgAprobarCoop.cooperativa?.representanteLegal || '—'}</strong>
                  {' '}(CC <strong>{dlgAprobarCoop.cooperativa?.cedulaRepresentante || '—'}</strong>).
                  El OCR debe validar que los datos coinciden.
                </Typography>
                {dlgAprobarCoop.open && dlgAprobarCoop.cooperativa && (
                  <VerificadorDocumento
                    titulo=""
                    descripcion="Formato preferido: PDF con ambas caras. También se aceptan JPG y PNG. Máximo 10MB."
                    cedula={dlgAprobarCoop.cooperativa.cedulaRepresentante}
                    nombres={dlgAprobarCoop.cooperativa.representanteLegal}
                    apellidos=""
                    tipoDocumento="cedula"
                    onValido={(_file, resultado) => {
                      if (resultado?.urlDocumento) setUrlCedulaAprobar(resultado.urlDocumento);
                    }}
                    onInvalido={() => setUrlCedulaAprobar(null)}
                  />
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={() => { setDlgAprobarCoop({ open:false, cooperativa:null }); setUrlCedulaAprobar(null); }}
                  disabled={aprobandoDocs}>
                  Cancelar
                </Button>
                <Button variant="contained" color="warning"
                  disabled={!urlCedulaAprobar || aprobandoDocs}
                  startIcon={aprobandoDocs ? <CircularProgress size={16} color="inherit"/> : <CheckCircleOutlineIcon/>}
                  onClick={async () => {
                    if (!dlgAprobarCoop.cooperativa || !urlCedulaAprobar) return;
                    setAprobandoDocs(true);
                    try {
                      await aprobarDocumentosCooperativa(dlgAprobarCoop.cooperativa.cooperativaID, urlCedulaAprobar);
                      toast('Cooperativa aprobada. Documentos completos.');
                      setDlgAprobarCoop({ open:false, cooperativa:null });
                      setUrlCedulaAprobar(null);
                      cargarCoops();
                    } catch (e) {
                      toast(e?.message || 'No se pudo aprobar la cooperativa', 'error');
                    } finally {
                      setAprobandoDocs(false);
                    }
                  }}>
                  {aprobandoDocs ? 'Aprobando…' : 'Aprobar cooperativa'}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        )}
        {tab === 'accesos' && (
          <Box sx={{ p: 3 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, display:'flex', alignItems:'center', gap: 1 }}>
                <LockOutlinedIcon sx={{ color:'#2e7d32' }}/> Accesos a aplicaciones
              </Typography>
              <Typography variant="body2" sx={{ color:'#666', mt: 0.5 }}>
                Autoriza o revoca el acceso de cada usuario a las aplicaciones del ecosistema
                (Marketplace, EducaT, News, etc.). Las apps que usan verificación en tiempo real
                (vía <code style={{ background:'#f0f0f0', padding:'1px 4px', borderRadius:3 }}>verificar-acceso</code>)
                aplican la revocación de inmediato. Para las demás, el cambio surte efecto en el
                próximo login del usuario.
              </Typography>
            </Box>

            <Grid container spacing={2}>
              {/* Lista de usuarios (izq) */}
              <Grid item xs={12} md={5}>
                <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius: 2, overflow:'hidden' }}>
                  <Box sx={{ p: 1.5, borderBottom:'1px solid #eee', background:'#fafafa' }}>
                    <TextField fullWidth size="small" placeholder="Buscar por nombre, email o cédula…"
                      value={accesosSearch} onChange={e => setAccesosSearch(e.target.value)}
                      InputProps={{
                        startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" sx={{ color:'#999' }}/></InputAdornment>,
                        endAdornment: accesosUsuariosLoading
                          ? <InputAdornment position="end"><CircularProgress size={16}/></InputAdornment>
                          : null,
                      }}/>
                    <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mt: 1 }}>
                      <FormControlLabel
                        control={<Switch checked={mostrarTest} onChange={e => setMostrarTest(e.target.checked)} size="small"/>}
                        label={<Typography variant="caption">Mostrar usuarios de prueba</Typography>}
                        sx={{ m: 0 }}
                      />
                      <Typography variant="caption" sx={{ color:'#999', fontSize:'0.7rem' }}>
                        {(() => {
                          const filtrados = accesosUsuarios.filter(u => mostrarTest || !esUsuarioTest(u));
                          return `${filtrados.length}${accesosTotal > accesosUsuarios.length ? ` de ${accesosTotal}` : ''}`;
                        })()}
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ maxHeight: 520, overflowY:'auto' }}>
                    {accesosUsuariosLoading && accesosUsuarios.length === 0 ? (
                      <Box sx={{ p: 3, textAlign:'center', color:'#888' }}>
                        <CircularProgress size={22}/>
                        <Typography variant="caption" sx={{ display:'block', mt: 1 }}>Cargando usuarios…</Typography>
                      </Box>
                    ) : (() => {
                      const lista = accesosUsuarios.filter(u => mostrarTest || !esUsuarioTest(u));
                      if (lista.length === 0) {
                        return (
                          <Box sx={{ p: 3, textAlign:'center', color:'#888' }}>
                            <Typography variant="caption">
                              {accesosSearch ? 'No se encontraron usuarios.' : 'No hay usuarios para mostrar.'}
                            </Typography>
                          </Box>
                        );
                      }
                      return (
                        <List dense disablePadding>
                          {lista.map(u => {
                            const activo = accesosUsuario?.id === u.id;
                            const esTest = esUsuarioTest(u);
                            return (
                              <ListItem key={u.id} button onClick={() => setAccesosUsuario(u)}
                                sx={{
                                  borderBottom:'1px solid #f5f5f5',
                                  background: activo ? '#e8f5e9' : '#fff',
                                  '&:hover': { background: activo ? '#e8f5e9' : '#fafafa' },
                                }}>
                                <ListItemText
                                  primary={
                                    <Box sx={{ display:'flex', alignItems:'center', gap: 0.5, flexWrap:'wrap' }}>
                                      <Typography sx={{ fontSize:'0.85rem', fontWeight: activo ? 700 : 500 }}>
                                        {u.nombre} {u.apellido}
                                      </Typography>
                                      {esTest && <Chip label="TEST" size="small" color="warning"
                                        sx={{ fontSize:'0.55rem', height:14, '& .MuiChip-label':{px:0.5}}}/>}
                                    </Box>
                                  }
                                  secondary={<Typography variant="caption" sx={{ color:'#666' }}>{u.email}</Typography>}
                                />
                                <Box sx={{ display:'flex', flexDirection:'column', gap:0.2, alignItems:'flex-end' }}>
                                  {(u.roles || []).slice(0, 2).map(r => (
                                    <Chip key={r} label={r} size="small"
                                      sx={{ fontSize:'0.6rem', height: 16, background:'#f0f0f0' }}/>
                                  ))}
                                </Box>
                              </ListItem>
                            );
                          })}
                          {accesosTotal > accesosUsuarios.length && (
                            <Box sx={{ p: 1.5, textAlign:'center', color:'#888', fontSize:'0.72rem' }}>
                              Mostrando los primeros {accesosUsuarios.length} de {accesosTotal}. Refina la búsqueda para ver más.
                            </Box>
                          )}
                        </List>
                      );
                    })()}
                  </Box>
                </Paper>
              </Grid>

              {/* Panel de apps del usuario seleccionado (der) */}
              <Grid item xs={12} md={7}>
                <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius: 2, minHeight: 400 }}>
                  {!accesosUsuario ? (
                    <Box sx={{ p: 6, textAlign:'center', color:'#999' }}>
                      <LockOutlinedIcon sx={{ fontSize: 48, opacity: 0.3 }}/>
                      <Typography variant="body2" sx={{ mt: 1 }}>Selecciona un usuario para gestionar sus accesos.</Typography>
                    </Box>
                  ) : (
                    <>
                      <Box sx={{ p: 2, borderBottom:'1px solid #eee', background:'linear-gradient(135deg,#1a4d2e,#2e7d32)', color:'#fff', borderRadius:'8px 8px 0 0' }}>
                        <Typography sx={{ fontWeight: 700, fontSize:'1rem' }}>
                          {accesosUsuario.nombre} {accesosUsuario.apellido}
                        </Typography>
                        <Typography variant="caption" sx={{ opacity: 0.9 }}>{accesosUsuario.email}</Typography>
                      </Box>
                      {accesosLoading ? (
                        <Box sx={{ p: 4, textAlign:'center' }}><CircularProgress size={28}/></Box>
                      ) : (
                        <List disablePadding>
                          {accesosApps.map(app => {
                            const guardando = !!accesosGuardando[app.appCode];
                            return (
                              <ListItem key={app.appCode}
                                sx={{
                                  borderBottom:'1px solid #f5f5f5',
                                  py: 1.5,
                                  opacity: app.activa ? 1 : 0.5,
                                }}
                                secondaryAction={
                                  <Tooltip title={app.tieneAcceso ? 'Revocar acceso' : 'Otorgar acceso'}>
                                    <span>
                                      <IconButton edge="end"
                                        disabled={guardando || !app.activa}
                                        sx={{ color: app.tieneAcceso ? '#2e7d32' : '#999' }}
                                        onClick={() => toggleAcceso(app)}>
                                        {guardando ? <CircularProgress size={20}/>
                                          : app.tieneAcceso ? <ToggleOnIcon fontSize="large"/> : <ToggleOffIcon fontSize="large"/>}
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                }>
                                <ListItemText
                                  primary={
                                    <Box sx={{ display:'flex', alignItems:'center', gap: 1 }}>
                                      <Typography sx={{ fontWeight: 700, fontSize:'0.9rem' }}>{app.nombre}</Typography>
                                      <Chip label={app.appCode} size="small" sx={{ fontSize:'0.6rem', height: 18, background:'#f0f0f0' }}/>
                                      {!app.activa && <Chip label="Próximamente" size="small" sx={{ fontSize:'0.6rem', height: 18, background:'#fff8e1', color:'#bf6a00' }}/>}
                                      {app.tieneAcceso && <Chip label="AUTORIZADO" size="small" sx={{ fontSize:'0.6rem', height: 18, background:'#e8f5e9', color:'#2e7d32', fontWeight: 700 }}/>}
                                      {app.estado === 'REVOCADA' && <Chip label="REVOCADO" size="small" sx={{ fontSize:'0.6rem', height: 18, background:'#fdecea', color:'#c62828', fontWeight: 700 }}/>}
                                    </Box>
                                  }
                                  secondary={
                                    <>
                                      <Typography variant="caption" sx={{ display:'block', color:'#666' }}>{app.descripcion}</Typography>
                                      {app.fechaOtorgamiento && (
                                        <Typography variant="caption" sx={{ display:'block', color:'#999', fontSize:'0.65rem', mt: 0.3 }}>
                                          {app.tieneAcceso
                                            ? `Otorgado ${new Date(app.fechaOtorgamiento).toLocaleDateString('es-CO')}`
                                            : app.fechaRevocacion
                                              ? `Revocado ${new Date(app.fechaRevocacion).toLocaleDateString('es-CO')}`
                                              : ''}
                                        </Typography>
                                      )}
                                    </>
                                  }
                                />
                              </ListItem>
                            );
                          })}
                        </List>
                      )}
                    </>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </Box>
        )}
        {tab === 'pagos' && (
          <Box sx={{ p:3 }}>
            {/* Resumen */}
            <Box sx={{ display:'flex', gap:2, mb:3, flexWrap:'wrap' }}>
              {[
                { label:'Total pagos', value: pagosTotal, icon:<PaymentIcon/>, color:'#1565c0' },
                { label:'Recaudado', value: `$${pagosTotalMonto.toLocaleString('es-CO')} COP`, icon:<CheckCircleIcon/>, color:'#2e7d32' },
              ].map(s => (
                <Paper key={s.label} elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2, p:2, minWidth:180, display:'flex', alignItems:'center', gap:1.5 }}>
                  <Box sx={{ color:s.color }}>{s.icon}</Box>
                  <Box>
                    <Typography variant="caption" color="text.secondary">{s.label}</Typography>
                    <Typography variant="h6" fontWeight={700} sx={{ color:s.color }}>{s.value}</Typography>
                  </Box>
                </Paper>
              ))}
            </Box>

            <Typography variant="h6" sx={{ fontWeight:700, color:'#1a3a1a', mb:2, display:'flex', alignItems:'center', gap:1 }}>
              <PaymentIcon sx={{ color:'#2e7d32' }}/> Pagos de Inscripción
            </Typography>

            {/* Filtros */}
            <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2, p:2, mb:2 }}>
              <Box sx={{ display:'flex', gap:2, flexWrap:'wrap', alignItems:'center' }}>
                <FormControl size="small" sx={{ minWidth:150 }}>
                  <InputLabel>Estado</InputLabel>
                  <Select value={pagosEstado} label="Estado"
                    onChange={e=>{ setPagosEstado(e.target.value); setPagosPage(1); }}>
                    <MenuItem value="">Todos</MenuItem>
                    {['APROBADO','PENDIENTE','FALLIDO','RECHAZADO'].map(e=>(
                      <MenuItem key={e} value={e} sx={{ fontSize:'0.8rem' }}>{e}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth:200 }}>
                  <InputLabel>Cooperativa</InputLabel>
                  <Select value={filtroCoop} label="Cooperativa"
                    onChange={e=>{ setFiltroCoop(e.target.value); setPagosPage(1); }}>
                    <MenuItem value="">Todas</MenuItem>
                    {coops.map(c=>(
                      <MenuItem key={c.cooperativaID} value={c.cooperativaID} sx={{ fontSize:'0.8rem' }}>
                        {c.nombre} {c.siglas ? `(${c.siglas})` : ''}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField size="small" label="Buscar nombre, cédula, email o referencia" sx={{ minWidth:280 }}
                  value={pagosBuscar} onChange={e=>{ setPagosBuscar(e.target.value); setPagosPage(1); }}/>
                <TextField size="small" type="date" label="Desde" InputLabelProps={{ shrink:true }}
                  value={pagosFechaDesde} onChange={e=>{ setPagosFechaDesde(e.target.value); setPagosPage(1); }}/>
                <TextField size="small" type="date" label="Hasta" InputLabelProps={{ shrink:true }}
                  value={pagosFechaHasta} onChange={e=>{ setPagosFechaHasta(e.target.value); setPagosPage(1); }}/>
                <Button size="small" variant="outlined" onClick={()=>{ setPagosEstado(''); setPagosBuscar(''); setPagosFechaDesde(''); setPagosFechaHasta(''); setFiltroCoop(''); setPagosPage(1); }}>Limpiar</Button>
                <Button size="small" variant="contained" startIcon={<RefreshIcon/>} onClick={cargarPagos}
                  sx={{ background:'#2e7d32' }} disabled={pagosLoading}>
                  {pagosLoading ? <CircularProgress size={16} color="inherit"/> : 'Actualizar'}
                </Button>
              </Box>
            </Paper>

            {/* Tabla */}
            <TableContainer component={Paper} elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ background:'#f0f7f0' }}>
                    {['Fecha','Afiliado','Cédula','Email','Cooperativa','Referencia','Monto','Pasarela','Estado','Acción'].map(h=>(
                      <TableCell key={h} sx={{ fontWeight:700, fontSize:'0.72rem', color:'#2e7d32', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pagos.length === 0 && !pagosLoading && (
                    <TableRow><TableCell colSpan={9} sx={{ textAlign:'center', py:5, color:'#aaa' }}>Sin pagos registrados</TableCell></TableRow>
                  )}
                  {pagos.map(p => {
                    const ESTADO_CONFIG = {
                      APROBADO:  { color:'#2e7d32', bg:'#e8f5e9', icon:<CheckCircleIcon sx={{ fontSize:14 }}/> },
                      PENDIENTE: { color:'#e65100', bg:'#fff3e0', icon:<PendingIcon sx={{ fontSize:14 }}/> },
                      FALLIDO:   { color:'#c62828', bg:'#ffebee', icon:<ErrorIcon sx={{ fontSize:14 }}/> },
                      RECHAZADO: { color:'#c62828', bg:'#ffebee', icon:<ErrorIcon sx={{ fontSize:14 }}/> },
                    };
                    const ec = ESTADO_CONFIG[p.estado] || { color:'#888', bg:'#f5f5f5', icon:null };
                    const fecha = new Date(p.fechaCreacion).toLocaleString('es-CO', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
                    return (
                      <TableRow key={p.pagoID} hover sx={{ '&:last-child td':{ borderBottom:0 } }}>
                        <TableCell sx={{ fontSize:'0.72rem', color:'#888', whiteSpace:'nowrap' }}>{fecha}</TableCell>
                        <TableCell sx={{ fontSize:'0.78rem', fontWeight:600, whiteSpace:'nowrap' }}>{p.afiliado?.nombre || '—'}</TableCell>
                        <TableCell sx={{ fontSize:'0.75rem', fontFamily:'monospace' }}>{p.afiliado?.documento || '—'}</TableCell>
                        <TableCell sx={{ fontSize:'0.72rem', color:'#555' }}>{p.afiliado?.email || '—'}</TableCell>
                        <TableCell sx={{ fontSize:'0.72rem', color:'#1565c0' }}>
                          {p.afiliado ? (coops.find(c=>c.cooperativaID===p.afiliado.cooperativaID)?.siglas || '—') : '—'}
                        </TableCell>
                        <TableCell sx={{ fontSize:'0.72rem', fontFamily:'monospace', color:'#1565c0' }}>{p.referencia}</TableCell>
                        <TableCell sx={{ fontSize:'0.78rem', fontWeight:700 }}>${Number(p.monto).toLocaleString('es-CO')}</TableCell>
                        <TableCell>
                          <Chip label={p.pasarela} size="small" sx={{ fontSize:'0.65rem', textTransform:'capitalize' }}/>
                        </TableCell>
                        <TableCell>
                          <Chip label={p.estado} size="small" icon={ec.icon}
                            sx={{ fontSize:'0.65rem', fontWeight:700, background:ec.bg, color:ec.color, border:`1px solid ${ec.color}33` }}/>
                        </TableCell>
                        <TableCell sx={{ whiteSpace:'nowrap' }}>
                          {p.estado !== 'APROBADO' && p.afiliado && puedeAprobarRechazar() && (
                            <Tooltip title="Confirmar pago manualmente">
                              <IconButton size="small" sx={{ color:'#2e7d32' }}
                                onClick={()=>setDlgPagoManual({ open:true, id:p.afiliado.afiliadoID, nombre:p.afiliado.nombre, ref:p.referencia, monto:150000, notas:'' })}>
                                <CheckCircleIcon fontSize="small"/>
                              </IconButton>
                            </Tooltip>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Paginación */}
            {Math.ceil(pagosTotal / PAGOS_PAGE_SIZE) > 1 && (
              <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', gap:1, mt:2 }}>
                <Button size="small" disabled={pagosPage===1} onClick={()=>setPagosPage(p=>p-1)} variant="outlined">← Anterior</Button>
                <Typography variant="body2" color="text.secondary">Página {pagosPage} de {Math.ceil(pagosTotal/PAGOS_PAGE_SIZE)}</Typography>
                <Button size="small" disabled={pagosPage>=Math.ceil(pagosTotal/PAGOS_PAGE_SIZE)} onClick={()=>setPagosPage(p=>p+1)} variant="outlined">Siguiente →</Button>
              </Box>
            )}

            {/* Dialog pago manual movido fuera del bloque para usarse desde otras pestañas */}
          </Box>
        )}
        {tab === 'exclusion' && (
          <Box sx={{ p:3 }}>
            <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:2, flexWrap:'wrap', gap:2 }}>
              <Typography variant="h6" sx={{ fontWeight:700, color:'#1a3a1a', display:'flex', alignItems:'center', gap:1 }}>
                <BlockIcon sx={{ color:'#b71c1c' }}/> Lista de Exclusión
                <Chip label={exclusionTotal} size="small" color="error" sx={{ fontWeight:700, ml:1 }}/>
              </Typography>
              <Button variant="contained" startIcon={<PersonOffIcon/>}
                sx={{ background:'#b71c1c', '&:hover':{ background:'#7f0000' } }}
                onClick={()=>setDlgExclusion({ open:true, doc:'', nombres:'', apellidos:'', motivo:'' })}>
                Agregar a lista
              </Button>
            </Box>

            <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2, p:2, mb:2 }}>
              <Box sx={{ display:'flex', gap:2, alignItems:'center', flexWrap:'wrap' }}>
                <TextField size="small" label="Buscar por cédula o nombre" sx={{ minWidth:260 }}
                  value={exclusionBuscar}
                  onChange={e=>{ setExclusionBuscar(e.target.value); setExclusionPage(1); }}/>
                <Button size="small" variant="outlined" onClick={()=>{ setExclusionBuscar(''); setExclusionPage(1); }}>Limpiar</Button>
                <Button size="small" variant="contained" startIcon={<RefreshIcon/>} onClick={cargarExclusiones}
                  sx={{ background:'#b71c1c' }} disabled={exclusionLoading}>
                  {exclusionLoading ? <CircularProgress size={16} color="inherit"/> : 'Actualizar'}
                </Button>
              </Box>
            </Paper>

            <Alert severity="warning" sx={{ mb:2, fontSize:'0.8rem' }}>
              Esta lista bloquea la afiliación por cédula exacta y por similitud de nombre (≥70%). El motivo real nunca se muestra al usuario.
            </Alert>

            <TableContainer component={Paper} elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ background:'#fff5f5' }}>
                    {['Cédula','Nombres','Apellidos','Motivo interno','Agregado por','Fecha','Acción'].map(h=>(
                      <TableCell key={h} sx={{ fontWeight:700, fontSize:'0.72rem', color:'#b71c1c', textTransform:'uppercase' }}>{h}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {exclusiones.length === 0 && !exclusionLoading && (
                    <TableRow><TableCell colSpan={7} sx={{ textAlign:'center', py:5, color:'#aaa' }}>Lista vacía</TableCell></TableRow>
                  )}
                  {exclusiones.map(e => (
                    <TableRow key={e.exclusionID} hover sx={{ '&:last-child td':{ borderBottom:0 } }}>
                      <TableCell sx={{ fontFamily:'monospace', fontWeight:700, fontSize:'0.82rem' }}>{e.documento}</TableCell>
                      <TableCell sx={{ fontSize:'0.78rem' }}>{e.nombres || '—'}</TableCell>
                      <TableCell sx={{ fontSize:'0.78rem' }}>{e.apellidos || '—'}</TableCell>
                      <TableCell sx={{ fontSize:'0.75rem', color:'#888', maxWidth:220, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                        <Tooltip title={e.motivoInterno || ''}><span>{e.motivoInterno || '—'}</span></Tooltip>
                      </TableCell>
                      <TableCell sx={{ fontSize:'0.72rem', color:'#888' }}>{e.agregadoPorEmail || '—'}</TableCell>
                      <TableCell sx={{ fontSize:'0.72rem', color:'#888', whiteSpace:'nowrap' }}>
                        {new Date(e.fechaAgregado).toLocaleDateString('es-CO')}
                      </TableCell>
                      <TableCell>
                        <Tooltip title="Remover de la lista">
                          <IconButton size="small" sx={{ color:'#b71c1c' }}
                            onClick={()=>handleDesactivarExclusion(e.exclusionID, e.documento)}>
                            <BlockIcon fontSize="small"/>
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            {Math.ceil(exclusionTotal / EXCL_PAGE_SIZE) > 1 && (
              <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', gap:1, mt:2 }}>
                <Button size="small" disabled={exclusionPage===1} onClick={()=>setExclusionPage(p=>p-1)} variant="outlined">← Anterior</Button>
                <Typography variant="body2" sx={{ color:'#666' }}>Página {exclusionPage} de {Math.ceil(exclusionTotal/EXCL_PAGE_SIZE)}</Typography>
                <Button size="small" disabled={exclusionPage>=Math.ceil(exclusionTotal/EXCL_PAGE_SIZE)} onClick={()=>setExclusionPage(p=>p+1)} variant="outlined">Siguiente →</Button>
              </Box>
            )}

            {/* Dialog agregar */}
            <Dialog open={dlgExclusion.open} onClose={()=>setDlgExclusion({ open:false, doc:'', nombres:'', apellidos:'', motivo:'' })} maxWidth="xs" fullWidth>
              <DialogTitle sx={{ color:'#b71c1c', fontWeight:700, display:'flex', alignItems:'center', gap:1 }}>
                <PersonOffIcon/> Agregar a lista de exclusión
              </DialogTitle>
              <DialogContent sx={{ display:'flex', flexDirection:'column', gap:2, pt:2 }}>
                <TextField size="small" label="Número de cédula *" fullWidth
                  value={dlgExclusion.doc} onChange={e=>setDlgExclusion(p=>({...p, doc:e.target.value}))}/>
                <TextField size="small" label="Nombres (para validación secundaria)" fullWidth
                  value={dlgExclusion.nombres} onChange={e=>setDlgExclusion(p=>({...p, nombres:e.target.value}))}/>
                <TextField size="small" label="Apellidos (para validación secundaria)" fullWidth
                  value={dlgExclusion.apellidos} onChange={e=>setDlgExclusion(p=>({...p, apellidos:e.target.value}))}/>
                <TextField size="small" label="Motivo interno (no se muestra al usuario)" fullWidth multiline rows={3}
                  value={dlgExclusion.motivo} onChange={e=>setDlgExclusion(p=>({...p, motivo:e.target.value}))}/>
              </DialogContent>
              <DialogActions sx={{ px:3, pb:2 }}>
                <Button onClick={()=>setDlgExclusion({ open:false, doc:'', nombres:'', apellidos:'', motivo:'' })}>Cancelar</Button>
                <Button variant="contained" sx={{ background:'#b71c1c' }} startIcon={<PersonOffIcon/>}
                  disabled={!dlgExclusion.doc.trim()}
                  onClick={handleAgregarExclusion}>
                  Agregar
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        )}
        {tab === 'auditoria' && (
          <Box sx={{ p:3 }}>
            <Typography variant="h6" sx={{ fontWeight:700, color:'#1a3a1a', mb:2, display:'flex', alignItems:'center', gap:1 }}>
              <HistoryIcon sx={{ color:'#2e7d32' }}/> Registro de Auditoría
            </Typography>

            {/* Filtros */}
            <Paper elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2, p:2, mb:2 }}>
              <Box sx={{ display:'flex', gap:2, flexWrap:'wrap', alignItems:'center' }}>
                <Box sx={{ display:'flex', border:'1px solid #e0e0e0', borderRadius:1, overflow:'hidden' }}>
                  {['afiliados','aliados','usuarios'].map(t => (
                    <Button key={t} size="small" onClick={()=>{ setAuditTipo(t); setAuditAccion(''); setAuditPage(1); }}
                      sx={{ borderRadius:0, px:2, fontWeight: auditTipo===t ? 700 : 400,
                        background: auditTipo===t ? '#1a4d2e' : 'transparent',
                        color: auditTipo===t ? '#fff' : '#555',
                        '&:hover':{ background: auditTipo===t ? '#1a4d2e' : '#f5f5f5' } }}>
                      {t === 'afiliados' ? 'Afiliados' : t === 'aliados' ? 'Aliados' : 'Usuarios sistema'}
                    </Button>
                  ))}
                </Box>
                <FormControl size="small" sx={{ minWidth:200 }}>
                  <InputLabel>Acción</InputLabel>
                  <Select value={auditAccion} label="Acción"
                    onChange={e=>{ setAuditAccion(e.target.value); setAuditPage(1); }}>
                    <MenuItem value="">Todas</MenuItem>
                    {(auditTipo === 'usuarios' ? auditAcciones.usuario : auditAcciones.afiliado).map(a => (
                      <MenuItem key={a} value={a} sx={{ fontSize:'0.8rem' }}>{a}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField size="small" label="Realizado por (email)" sx={{ minWidth:200 }}
                  value={auditBuscar} onChange={e=>{ setAuditBuscar(e.target.value); setAuditPage(1); }}/>
                <TextField size="small" type="date" label="Desde" InputLabelProps={{ shrink:true }}
                  value={auditFechaDesde} onChange={e=>{ setAuditFechaDesde(e.target.value); setAuditPage(1); }}/>
                <TextField size="small" type="date" label="Hasta" InputLabelProps={{ shrink:true }}
                  value={auditFechaHasta} onChange={e=>{ setAuditFechaHasta(e.target.value); setAuditPage(1); }}/>
                <Button size="small" variant="outlined" onClick={()=>{ setAuditAccion(''); setAuditBuscar(''); setAuditFechaDesde(''); setAuditFechaHasta(''); setAuditPage(1); }}>
                  Limpiar
                </Button>
                <Button size="small" variant="contained" startIcon={<RefreshIcon/>} onClick={cargarAuditoria}
                  sx={{ background:'#2e7d32' }}>
                  Actualizar
                </Button>
              </Box>
            </Paper>

            {/* Totalizador */}
            <Box sx={{ mb:1.5, display:'flex', alignItems:'center', gap:1 }}>
              <Chip label={`${auditTotal} registros`} size="small" color="primary" sx={{ fontWeight:700 }}/>
              {auditLoading && <CircularProgress size={16}/>}
            </Box>

            {/* Tabla */}
            <TableContainer component={Paper} elevation={0} sx={{ border:'1px solid #e0e0e0', borderRadius:2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ background:'#f8fdf8' }}>
                    {(auditTipo === 'afiliados'
                      ? ['Fecha/Hora','Afiliado','Acción','Descripción','Realizado por']
                      : ['Fecha/Hora','Usuario afectado','Acción','Descripción','Realizado por']
                    ).map(h => (
                      <TableCell key={h} sx={{ fontWeight:700, fontSize:'0.72rem', color:'#2e7d32', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {auditLogs.length === 0 && !auditLoading && (
                    <TableRow><TableCell colSpan={5} sx={{ textAlign:'center', py:5, color:'#aaa' }}>Sin registros con los filtros aplicados</TableCell></TableRow>
                  )}
                  {auditLogs.map((log) => {
                    const ACCION_COLOR = {
                      APROBACION:'#2e7d32', RECHAZO:'#c62828', REEVALUACION:'#e65100',
                      ELIMINACION_SESION:'#6a1b9a', ELIMINACION_COMPLETA_AFILIADO:'#b71c1c',
                      SUBIDA_DOCUMENTO:'#1565c0', DOCUMENTO_APROBADO:'#2e7d32', DOCUMENTO_RECHAZADO:'#c62828',
                      SESION_AGENDADA_CALENDAR:'#1565c0', SESION_REGISTRADA_MANUAL:'#1565c0',
                      REGISTRO_SOLICITUD:'#555', NOTIFICACION_DOCS_COMPLETOS:'#555',
                      USUARIO_ACTIVADO:'#2e7d32', USUARIO_DESACTIVADO:'#c62828',
                      CAMBIO_ROL:'#e65100', CAMBIO_PASSWORD:'#e65100',
                      USUARIO_EDITADO:'#555', USUARIO_CREADO_ADMIN:'#2e7d32',
                    };
                    const color = ACCION_COLOR[log.accion] || '#555';
                    const fecha = new Date(log.fechaAccion).toLocaleString('es-CO', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
                    return (
                      <TableRow key={log.logID} hover sx={{ '&:last-child td':{ borderBottom:0 } }}>
                        <TableCell sx={{ fontSize:'0.72rem', whiteSpace:'nowrap', color:'#888' }}>{fecha}</TableCell>
                        <TableCell sx={{ fontSize:'0.75rem', fontWeight:600 }}>
                          {auditTipo === 'afiliados'
                            ? (log.nombreAfiliado || `#${log.afiliadoID}`)
                            : (log.usuarioAfectadoEmail || log.usuarioAfectadoID || '—')}
                        </TableCell>
                        <TableCell>
                          <Chip label={log.accion} size="small"
                            sx={{ fontSize:'0.62rem', fontWeight:700, height:20, background: color+'22', color }}/>
                        </TableCell>
                        <TableCell sx={{ fontSize:'0.72rem', maxWidth:350, whiteSpace:'pre-wrap', wordBreak:'break-word' }}>
                          {log.descripcion || '—'}
                        </TableCell>
                        <TableCell sx={{ fontSize:'0.72rem', color:'#555', whiteSpace:'nowrap' }}>
                          {log.realizadoPorEmail || log.realizadoPorNombre || '—'}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Paginación */}
            {Math.ceil(auditTotal / AUDIT_PAGE_SIZE) > 1 && (
              <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center', gap:1, mt:2 }}>
                <Button size="small" disabled={auditPage===1} onClick={()=>setAuditPage(p=>p-1)} variant="outlined">← Anterior</Button>
                <Typography variant="body2" sx={{ color:'#666' }}>
                  Página {auditPage} de {Math.ceil(auditTotal / AUDIT_PAGE_SIZE)} ({auditTotal} registros)
                </Typography>
                <Button size="small" disabled={auditPage >= Math.ceil(auditTotal/AUDIT_PAGE_SIZE)} onClick={()=>setAuditPage(p=>p+1)} variant="outlined">Siguiente →</Button>
              </Box>
            )}
          </Box>
        )}
      </Box>

      {/* ── Diálogo cambiar rol ── */}
      {/* ════ MODAL EDICIÓN COMPLETA DE USUARIO ════ */}
      <Dialog open={dlgEditar.open} onClose={()=>setDlgEditar({open:false,user:null,tab:'datos'})}
        maxWidth="md" fullWidth PaperProps={{ sx:{ borderRadius:2.5, overflow:'hidden' } }}>
        {/* Header */}
        <Box sx={{ background:'linear-gradient(135deg,#1a4d2e,#2e7d32)', px:3, py:2, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:2 }}>
            <Avatar sx={{ background:'rgba(255,255,255,0.2)', fontWeight:700 }}>
              {dlgEditar.user?.Nombre?.[0]}{dlgEditar.user?.Apellido?.[0]}
            </Avatar>
            <Box>
              <Typography sx={{ color:'#fff', fontWeight:700 }}>{dlgEditar.user?.Nombre} {dlgEditar.user?.Apellido}</Typography>
              <Typography sx={{ color:'rgba(255,255,255,0.6)', fontSize:'0.75rem' }}>{dlgEditar.user?.Email}</Typography>
            </Box>
          </Box>
          <IconButton size="small" onClick={()=>setDlgEditar({open:false,user:null,tab:'datos'})} sx={{ color:'rgba(255,255,255,0.7)' }}>
            <CancelIcon/>
          </IconButton>
        </Box>
        {/* Sub-tabs */}
        <Box sx={{ borderBottom:'1px solid #e0e0e0', background:'#fafafa' }}>
          <Tabs value={dlgEditar.tab} onChange={(_,v)=>setDlgEditar(p=>({...p,tab:v}))}
            TabIndicatorProps={{ style:{ background:'#2e7d32', height:3 } }}>
            <Tab value="datos"    label="Datos personales"   sx={{ textTransform:'none', fontWeight:600, minHeight:44 }}/>
            <Tab value="acceso"   label="Acceso y rol"       sx={{ textTransform:'none', fontWeight:600, minHeight:44 }}/>
            <Tab value="password" label="Contraseña"         sx={{ textTransform:'none', fontWeight:600, minHeight:44 }}/>
            {tieneCarnetHabilitado(dlgEditar.user || {}) && (
              <Tab value="carnet" label="Carnet"             sx={{ textTransform:'none', fontWeight:600, minHeight:44 }}/>
            )}
          </Tabs>
        </Box>
        <DialogContent sx={{ p:3 }}>
          {/* ─ Tab Datos personales ─ */}
          {dlgEditar.tab === 'datos' && (
            <Box>
              {/* Zona de foto */}
              <Box sx={{
                display:'flex', alignItems:'center', gap:3, mb:3, p:2.5,
                background:'#f5f7f4', borderRadius:2, border:'1px solid #e0e0e0',
              }}>
                <FotoUsuarioAdmin
                  user={dlgEditar.user}
                  onChanged={(nuevaUrl, nuevoUri) => {
                    setDlgEditar(p => ({
                      ...p,
                      user: { ...p.user, imagen: nuevoUri, fotoUrl: nuevaUrl }
                    }));
                  }}
                  onToast={toast}
                />
                <Box sx={{ flex: 1 }}>
                  <Typography sx={{ fontWeight: 700, color: '#1a4d2e', fontSize: '0.92rem', mb: 0.5 }}>
                    Foto del afiliado
                  </Typography>
                  <Typography sx={{ fontSize: '0.78rem', color: '#666' }}>
                    Esta foto aparecerá en el carnet digital del usuario.
                    Formato JPG/PNG, máximo 2 MB.{' '}
                    <Box component="span" sx={{ color: '#e65100', fontWeight: 600 }}>
                      Importante: la foto debe ser en proporción 3:4 (formato cédula),
                      con fondo blanco y rostro centrado. De lo contrario, podría verse
                      mal ajustada en el carnet.
                    </Box>
                  </Typography>
                </Box>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Nombre(s)" value={editForm.Nombre||''}
                    onChange={e=>setEditForm(p=>({...p,Nombre:e.target.value}))}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth size="small" label="Apellido(s)" value={editForm.Apellido||''}
                    onChange={e=>setEditForm(p=>({...p,Apellido:e.target.value}))}/>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField fullWidth size="small" label="Email" type="email" value={editForm.Email||''}
                    onChange={e=>setEditForm(p=>({...p,Email:e.target.value}))}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField fullWidth size="small" label="Celular" value={editForm.Celular||''}
                    onChange={e=>setEditForm(p=>({...p,Celular:e.target.value}))}
                    InputProps={{ startAdornment:<InputAdornment position="start">+57</InputAdornment> }}/>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Tipo Doc.</InputLabel>
                    <Select value={editForm.TipoDocumento||'CC'} label="Tipo Doc."
                      onChange={e=>setEditForm(p=>({...p,TipoDocumento:e.target.value}))}>
                      <MenuItem value="CC">Cédula de ciudadanía</MenuItem>
                      <MenuItem value="CE">Cédula de extranjería</MenuItem>
                      <MenuItem value="PP">Pasaporte</MenuItem>
                      <MenuItem value="NIT">NIT</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField fullWidth size="small" label="Número de documento" value={editForm.Documento||''}
                    onChange={e=>setEditForm(p=>({...p,Documento:e.target.value}))}/>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Departamento</InputLabel>
                    <Select value={editForm.departamentoId||''} label="Departamento"
                      onChange={e=>{ setEditForm(p=>({...p,departamentoId:e.target.value,municipioId:''})); getMunicipios(e.target.value).then(setEditMunis).catch(()=>{}); }}>
                      <MenuItem value=""><em>Seleccione…</em></MenuItem>
                      {editDeptos.map(d=><MenuItem key={d.DepartamentoID||d.departamentoID} value={d.DepartamentoID||d.departamentoID}>{d.Nombre||d.nombre}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth size="small" disabled={!editForm.departamentoId}>
                    <InputLabel>Ciudad / Municipio</InputLabel>
                    <Select value={editForm.municipioId||''} label="Ciudad / Municipio"
                      onChange={e=>setEditForm(p=>({...p,municipioId:e.target.value}))}>
                      <MenuItem value=""><em>Seleccione…</em></MenuItem>
                      {editMunis.map(m=><MenuItem key={m.MunicipioID||m.municipioID} value={m.MunicipioID||m.municipioID}>{m.Nombre||m.nombre}</MenuItem>)}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth size="small" label="Dirección" value={editForm.DireccionTexto||''}
                    onChange={e=>setEditForm(p=>({...p,DireccionTexto:e.target.value}))}/>
                </Grid>
              </Grid>
            </Box>
          )}
          {/* ─ Tab Acceso y rol ─ */}
          {dlgEditar.tab === 'acceso' && (
            <Box>
              <Typography variant="body2" sx={{ color:'#666', mb:0.5 }}>
                Activa o desactiva los roles del usuario. Puede tener varios roles simultáneos.
              </Typography>
              <Typography variant="caption" sx={{ color:'#e65100', display:'block', mb:2 }}>
                Los cambios se aplican al guardar.
              </Typography>

              {/* Aviso auto-vinculación a FENAGRO si tiene rol staff activo */}
              {(() => {
                const ROLES_STAFF = ['SuperAdmin','AdminConfederacion','AdminFederacion','AdminCooperativa','Auditor','Validador','Orientador'];
                const staffActivos = (editForm.roles || []).filter(r => ROLES_STAFF.includes(r));
                if (staffActivos.length === 0) return null;
                return (
                  <Alert severity="success" sx={{ mb: 2, fontSize: '0.78rem' }}>
                    Al guardar con {staffActivos.length === 1 ? 'el rol' : 'los roles'}{' '}
                    <strong>{staffActivos.join(', ')}</strong>, si el usuario aún no está vinculado a la
                    {' '}<strong>Federación Nacional Agroindustria Ambiental y Producción Limpia</strong>{' '}
                    (FENAGRO APL), se le asignará automáticamente.
                  </Alert>
                );
              })()}

              {/* Lista de roles con toggle */}
              <Box sx={{ display:'flex', flexDirection:'column', gap:0.75, mb:2 }}>
                {[
                  ['SuperAdmin',        'Acceso total al sistema',                              'error'],
                  ['AdminConfederacion','Gestión de la confederación y federaciones',            'warning'],
                  ['AdminFederacion',   'Gestión de la federación y cooperativas',               'warning'],
                  ['AdminCooperativa',  'Gestión de una cooperativa específica',                 'info'],
                  ['Auditor',           'Revisa y aprueba/rechaza documentos y solicitudes',     'error'],
                  ['Validador',         'Valida documentos y solicitudes',                       'warning'],
                  ['Orientador',        'Conduce sesiones de orientación a nuevos afiliados',    'secondary'],
                  ['Directivo',         'Directivo de comité',                                  'primary'],
                  ['Afiliado',          'Afiliado activo aprobado',                             'success'],
                  ['Capellan',          'Capellán misionero activo',                            'secondary'],
                  ['Visitante',         'Registro inicial, pendiente de aprobación',            'default'],
                ].map(([r, desc, color]) => {
                  const activo = (editForm.roles||[]).includes(r);
                  return (
                    <Box key={r}
                      onClick={() => {
                        const actuales = editForm.roles || [];
                        const nuevos   = activo
                          ? actuales.filter(x => x !== r)
                          : [...actuales, r];
                        setEditForm(p => ({ ...p, roles: nuevos }));
                      }}
                      sx={{
                        display:'flex', alignItems:'center', gap:1.5, p:1.2,
                        borderRadius:2, cursor:'pointer', border:'1.5px solid',
                        borderColor: activo ? '#2e7d32' : '#e0e0e0',
                        background:  activo ? '#f0fdf0' : '#fafafa',
                        transition: 'all 0.15s',
                        '&:hover': { borderColor:'#2e7d32', background: activo ? '#e8f5e9' : '#f5faf5' },
                      }}>
                      {/* Toggle visual */}
                      <Box sx={{
                        width:36, height:20, borderRadius:10, position:'relative',
                        background: activo ? '#2e7d32' : '#ccc',
                        transition: 'background 0.2s', flexShrink:0,
                      }}>
                        <Box sx={{
                          position:'absolute', top:2, left: activo ? 18 : 2,
                          width:16, height:16, borderRadius:'50%', background:'#fff',
                          transition: 'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.2)',
                        }}/>
                      </Box>
                      <Chip label={r} size="small" color={color}
                        sx={{ fontSize:'0.65rem', height:20, minWidth:130, fontWeight: activo ? 700 : 400 }}/>
                      <Typography variant="caption" sx={{ color: activo ? '#1a4d2e' : '#888', flex:1 }}>
                        {desc}
                      </Typography>
                    </Box>
                  );
                })}
              </Box>

              {/* Resumen roles activos */}
              <Box sx={{ background:'#f5f5f5', borderRadius:2, p:1.5 }}>
                <Typography variant="caption" sx={{ fontWeight:700, color:'#555', display:'block', mb:0.75 }}>
                  Roles activos actualmente:
                </Typography>
                <Box sx={{ display:'flex', flexWrap:'wrap', gap:0.5 }}>
                  {(editForm.roles||[]).length === 0
                    ? <Typography variant="caption" sx={{ color:'#bbb' }}>Ningún rol asignado</Typography>
                    : (editForm.roles||[]).map(r => (
                        <Chip key={r} label={r} size="small"
                          sx={{ fontSize:'0.65rem', height:20, background:'#e8f5e9', color:'#1a4d2e', fontWeight:700 }}/>
                      ))
                  }
                </Box>
              </Box>

              {/* Campo Google Calendar — solo si tiene rol Orientador */}
              {(editForm.roles||[]).includes('Orientador') && (
                <Box sx={{ mt:2, p:2, border:'1.5px solid #ce93d8', borderRadius:2, background:'#fdf6ff' }}>
                  <Typography variant="caption" fontWeight={700}
                    sx={{ color:'#6a1b9a', textTransform:'uppercase', letterSpacing:'0.06em', display:'block', mb:0.5 }}>
                    🗓 Google Calendar del Orientador
                  </Typography>
                  <Typography variant="caption" sx={{ color:'#888', display:'block', mb:1.5 }}>
                    Ingresa el email del calendario Google del orientador (generalmente su email @fenagro-oficial.org).
                    Se usa para mostrar disponibilidad al agendar sesiones.
                  </Typography>
                  <TextField fullWidth size="small"
                    label="Google Calendar ID (email del orientador)"
                    placeholder="orientador@fenagro-oficial.org"
                    value={editForm.googleCalendarId||''}
                    onChange={e => setEditForm(p => ({...p, googleCalendarId: e.target.value}))}
                    InputProps={{
                      sx: { background:'#fff' },
                      endAdornment: editForm.googleCalendarId
                        ? <Chip label="Configurado" size="small"
                            sx={{ height:18, fontSize:'0.6rem', background:'#e8f5e9', color:'#2e7d32' }}/>
                        : <Chip label="Sin configurar" size="small"
                            sx={{ height:18, fontSize:'0.6rem', background:'#fff3e0', color:'#e65100' }}/>
                    }}
                  />
                </Box>
              )}
            </Box>
          )}
          {/* ─ Tab Contraseña ─ */}
          {dlgEditar.tab === 'password' && (
            <Box>
              <Alert severity="warning" sx={{ mb:2, fontSize:'0.8rem' }}>
                Esta acción resetea la contraseña del usuario inmediatamente. Comuníquela de forma segura.
              </Alert>
              <TextField fullWidth size="small" label="Nueva contraseña" type="password"
                value={editForm.newPassword||''}
                onChange={e=>setEditForm(p=>({...p,newPassword:e.target.value}))}
                helperText="Mínimo 6 caracteres, una mayúscula, un número y un carácter especial"
                sx={{ mb:2 }}/>
              <TextField fullWidth size="small" label="Confirmar contraseña" type="password"
                error={!!(editForm.newPassword && editForm.confirmPassword && editForm.newPassword !== editForm.confirmPassword)}
                helperText={editForm.newPassword && editForm.confirmPassword && editForm.newPassword !== editForm.confirmPassword ? 'Las contraseñas no coinciden' : ' '}
                value={editForm.confirmPassword||''}
                onChange={e=>setEditForm(p=>({...p,confirmPassword:e.target.value}))}/>
            </Box>
          )}

          {/* ─ Tab Carnet ─ */}
          {dlgEditar.tab === 'carnet' && dlgEditar.user && (
            <TabCarnetAdmin
              userId={dlgEditar.user.Id || dlgEditar.user.id}
              userNombre={`${dlgEditar.user.Nombre || dlgEditar.user.nombre} ${dlgEditar.user.Apellido || dlgEditar.user.apellido}`}
              cooperativasElegibles={cooperativasElegiblesCarnet({ ...dlgEditar.user, id: dlgEditar.user.Id || dlgEditar.user.id })}
              onGenerar={(coopId) => generarCarnetDelUsuario(
                { ...dlgEditar.user, id: dlgEditar.user.Id || dlgEditar.user.id },
                coopId
              )}
              generando={generandoCarnet === (dlgEditar.user.Id || dlgEditar.user.id)}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2.5, borderTop:'1px solid #f0f0f0', gap:1 }}>
          <Button onClick={()=>setDlgEditar({open:false,user:null,tab:'datos'})} sx={{ color:'#888' }}>
            Cancelar
          </Button>
          <Button variant="contained" startIcon={editSaving ? <CircularProgress size={16} color="inherit"/> : <SaveIcon/>}
            disabled={editSaving || (dlgEditar.tab==='password' && editForm.newPassword !== editForm.confirmPassword)}
            onClick={handleGuardarEdicion}
            sx={{ background:'linear-gradient(135deg,#1a4d2e,#43a047)', px:3 }}>
            {editSaving ? 'Guardando…' : 'Guardar cambios'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog selector de cooperativa para carnet (usuarios multi-cooperativa) ── */}
      <Dialog open={dlgSelectCoopCarnet.open}
              onClose={()=>setDlgSelectCoopCarnet({ open:false, user:null, opciones:[] })}
              maxWidth="xs" fullWidth>
        <DialogTitle sx={{ fontWeight:700, display:'flex', alignItems:'center', gap:1, color:'#1a4d2e' }}>
          <BadgeIcon/> Generar carnet
        </DialogTitle>
        <DialogContent sx={{ pt:2 }}>
          <Typography sx={{ mb:2, fontSize:'0.88rem' }}>
            <strong>{dlgSelectCoopCarnet.user?.nombre} {dlgSelectCoopCarnet.user?.apellido}</strong>{' '}
            está afiliado a varias cooperativas con carnet habilitado. Elija para cuál generar el carnet:
          </Typography>
          <Box sx={{ display:'flex', flexDirection:'column', gap:1.5 }}>
            {(dlgSelectCoopCarnet.opciones || []).map(opt => (
              <Button
                key={opt.cooperativaID}
                variant="outlined" fullWidth
                size="large"
                startIcon={<BadgeIcon/>}
                onClick={() => {
                  const u = dlgSelectCoopCarnet.user;
                  setDlgSelectCoopCarnet({ open:false, user:null, opciones:[] });
                  // pequeño delay para que se cierre antes del confirm
                  setTimeout(() => generarCarnetDelUsuario(u, opt.cooperativaID), 50);
                }}
                sx={{
                  justifyContent:'flex-start', py:1.4, px:2,
                  color: opt.siglas === 'CAPELLANES' ? '#1e3a5f' : '#1a4d2e',
                  borderColor: opt.siglas === 'CAPELLANES' ? '#1e3a5f' : '#1a4d2e',
                  '&:hover':{
                    background: opt.siglas === 'CAPELLANES' ? '#eef2f7' : '#e8f5e9',
                    borderColor: opt.siglas === 'CAPELLANES' ? '#1e3a5f' : '#1a4d2e',
                  },
                }}
              >
                <Box sx={{ textAlign:'left', flex:1 }}>
                  <Typography sx={{ fontWeight:700, fontSize:'0.9rem' }}>
                    {opt.siglas}
                  </Typography>
                  <Typography sx={{ fontSize:'0.72rem', color:'#666' }}>
                    {opt.nombre}
                  </Typography>
                </Box>
              </Button>
            ))}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>setDlgSelectCoopCarnet({ open:false, user:null, opciones:[] })}>
            Cancelar
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog aceptar afiliación sin pago (global, disponible en todas las pestañas) ── */}
      <Dialog open={dlgPagoManual.open} onClose={()=>setDlgPagoManual(p=>({...p,open:false}))} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color:'#00838f', fontWeight:700, display:'flex', alignItems:'center', gap:1 }}>
          <MonetizationOnIcon/> Aceptar afiliación sin pago por pasarela
        </DialogTitle>
        <DialogContent sx={{ display:'flex', flexDirection:'column', gap:2, pt:2 }}>
          <Alert severity="warning" sx={{ fontSize:'0.85rem' }}>
            Está aprobando la afiliación de <strong>{dlgPagoManual.nombre}</strong> sin que se registre un pago por la pasarela.<br/>
            Úselo solo para personas que <strong>ya pagaron por fuera</strong> del sistema (transferencia, efectivo, pagos anteriores).
          </Alert>
          <Alert severity="error" icon={false} sx={{ fontSize:'0.8rem', background:'#fff3e0', color:'#bf360c', border:'1px solid #ffab91' }}>
            ⚠️ <strong>Esta acción quedará registrada en la auditoría imborrable</strong> con su nombre, fecha y el motivo que indique a continuación.
          </Alert>

          <TextField size="small" fullWidth required label="Motivo (obligatorio, mín. 15 caracteres)"
            multiline rows={3}
            value={dlgPagoManual.notas}
            onChange={e=>setDlgPagoManual(p=>({...p,notas:e.target.value}))}
            error={!!dlgPagoManual.notas && dlgPagoManual.notas.trim().length < 15}
            helperText={
              !dlgPagoManual.notas
                ? 'Ej: "Pagó por transferencia el 12/05/2026 antes de que existiera el sistema. Comprobante adjunto en correo."'
                : dlgPagoManual.notas.trim().length < 15
                  ? `Faltan ${15 - dlgPagoManual.notas.trim().length} caracteres`
                  : `${dlgPagoManual.notas.trim().length} caracteres`
            }
            placeholder="Explique cuándo, cómo y por qué se acepta sin pago digital..."
          />

          <Box sx={{ display:'flex', gap:2 }}>
            <TextField size="small" fullWidth label="Referencia / Comprobante (opcional)"
              value={dlgPagoManual.ref}
              onChange={e=>setDlgPagoManual(p=>({...p,ref:e.target.value}))}/>
            <TextField size="small" sx={{ minWidth:140 }} label="Monto COP" type="number"
              value={dlgPagoManual.monto}
              onChange={e=>setDlgPagoManual(p=>({...p,monto:Number(e.target.value)}))}/>
          </Box>
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>setDlgPagoManual(p=>({...p,open:false}))}>Cancelar</Button>
          <Button variant="contained"
            sx={{ background:'#00838f', '&:hover':{ background:'#006064' } }}
            startIcon={<CheckCircleIcon/>}
            disabled={!dlgPagoManual.notas || dlgPagoManual.notas.trim().length < 15}
            onClick={handleConfirmarManual}>
            Aceptar sin pago
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Diálogo cambiar contraseña ──
          Importante: usar autoComplete="new-password" + un username oculto con el
          email del USUARIO OBJETIVO para desvincular al navegador del admin logueado.
          Sin esto, Chrome autofill rellena con las credenciales guardadas del admin,
          causando confusión visual (aparece el email del admin logueado como si se
          estuviera editando su propia contraseña).
      */}
      <Dialog
        open={dlgPass.open}
        onClose={()=>{ setDlgPass({ open:false, id:null, val:'', nombre:'', email:'' }); setVerPass(false); }}
        maxWidth="xs" fullWidth
      >
        <DialogTitle sx={{ fontWeight:700, pb:0 }}>Nueva contraseña</DialogTitle>
        {(dlgPass.nombre || dlgPass.email) && (
          <Box sx={{ px:3, pt:1, pb:0 }}>
            <Typography variant="body2" sx={{ color:'#555', mb:0.3 }}>
              Para el usuario:
            </Typography>
            <Box sx={{ background:'#fff3e0', border:'1px solid #ffe0b2', borderRadius:1,
              p:1.2, display:'flex', flexDirection:'column', gap:0.2 }}>
              <Typography sx={{ fontWeight:700, fontSize:'0.9rem', color:'#1a1a1a' }}>
                {dlgPass.nombre || '(sin nombre)'}
              </Typography>
              {dlgPass.email && (
                <Typography variant="caption" sx={{ color:'#666', fontFamily:'monospace' }}>
                  {dlgPass.email}
                </Typography>
              )}
            </Box>
          </Box>
        )}
        <DialogContent sx={{ pt:2 }}>
          {/* Form envuelve los campos para que el navegador no mezcle con el admin login */}
          <form autoComplete="off" onSubmit={(e)=>{ e.preventDefault(); handleCambiarPass(); }}>
            {/* Username OCULTO con el email del usuario objetivo — truco para que
                Chrome asocie la contraseña a ESTE usuario, no al admin logueado */}
            <input
              type="text"
              name="username"
              autoComplete="username"
              value={dlgPass.email || `usuario-${dlgPass.id || 'target'}`}
              readOnly
              tabIndex={-1}
              style={{
                position:'absolute', left:'-9999px',
                height:0, width:0, border:0, opacity:0, pointerEvents:'none',
              }}
            />
            <TextField
              fullWidth size="small" label="Nueva contraseña"
              type={verPass ? 'text' : 'password'}
              name="new-password"
              autoComplete="new-password"
              inputProps={{ 'data-lpignore':'true', 'data-form-type':'other' }}
              value={dlgPass.val}
              onChange={e=>setDlgPass(p=>({ ...p, val:e.target.value }))}
              helperText="Mínimo 6 caracteres"
              autoFocus
              InputProps={{
                endAdornment: (
                  <Tooltip title={verPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}>
                    <IconButton
                      onClick={()=>setVerPass(v => !v)}
                      edge="end"
                      size="small"
                      tabIndex={-1}
                      sx={{ color:'#888' }}
                    >
                      {verPass ? <VisibilityOffIcon fontSize="small"/> : <VisibilityIcon fontSize="small"/>}
                    </IconButton>
                  </Tooltip>
                ),
              }}
            />
          </form>
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>{ setDlgPass({ open:false, id:null, val:'', nombre:'', email:'' }); setVerPass(false); }}>
            Cancelar
          </Button>
          <Button variant="contained" color="warning" onClick={handleCambiarPass}>
            Actualizar
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Diálogo agendar sesión de orientación ── */}
      {dlgDetalle.data && (() => {
        const d = dlgDetalle.data;
        return (
          <AgendarSesionDialog
            open={dlgSesion}
            onClose={() => setDlgSesion(false)}
            afiliadoId={dlgDetalle.id}
            nombreAfiliado={`${d.nombres} ${d.apellidos}`}
            emailAfiliado={d.email}
            onAgendado={async () => {
              const ses = await getSesionesAfiliado(dlgDetalle.id).catch(() => []);
              setSesionesAf(Array.isArray(ses) ? ses : []);
              setDlgSesion(false);
              toast('Sesión agendada con Google Meet');
            }}
          />
        );
      })()}

      {/* ── Diálogo rechazar afiliación ── */}
      <Dialog open={dlgRechazar.open} onClose={()=>setDlgRechazar({open:false,id:null,motivo:''})} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ color:'#c62828', fontWeight:700 }}>Rechazar solicitud</DialogTitle>
        <DialogContent>
          <TextField fullWidth multiline rows={3} size="small" label="Motivo (opcional)"
            value={dlgRechazar.motivo} onChange={e=>setDlgRechazar(p=>({...p,motivo:e.target.value}))}/>
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>setDlgRechazar({open:false,id:null,motivo:''})}>Cancelar</Button>
          <Button variant="contained" color="error" onClick={handleRechazar}>Confirmar rechazo</Button>
        </DialogActions>
      </Dialog>


      {/* ── Dialog Reasignar Cooperativa ── */}
      <Dialog open={dlgReasignarCoop.open} onClose={()=>setDlgReasignarCoop({open:false,id:null,nombre:'',cooperativaId:'',motivo:''})} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ color:'#0277bd', fontWeight:700, display:'flex', alignItems:'center', gap:1 }}>
          <SwapHorizIcon/> Reasignar cooperativa
        </DialogTitle>
        <DialogContent sx={{ display:'flex', flexDirection:'column', gap:2, '&.MuiDialogContent-root':{ paddingTop:'20px' } }}>
          <Typography variant="body2" sx={{ color:'#555' }}>
            Cambiar la cooperativa de <strong>{dlgReasignarCoop.nombre}</strong>
          </Typography>
          <FormControl size="small" fullWidth>
            <InputLabel>Cooperativa *</InputLabel>
            <Select value={dlgReasignarCoop.cooperativaId} label="Cooperativa *"
              onChange={e=>setDlgReasignarCoop(p=>({...p, cooperativaId:e.target.value}))}>
              {coops.map(c=>(
                <MenuItem key={c.cooperativaID} value={c.cooperativaID} sx={{ fontSize:'0.82rem' }}>
                  {c.nombre} {c.siglas ? `(${c.siglas})` : ''}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField size="small" fullWidth label="Motivo (obligatorio)" multiline rows={2}
            value={dlgReasignarCoop.motivo}
            onChange={e=>setDlgReasignarCoop(p=>({...p, motivo:e.target.value}))}/>
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>setDlgReasignarCoop({open:false,id:null,nombre:'',cooperativaId:'',motivo:''})}>Cancelar</Button>
          <Button variant="contained" sx={{ background:'#0277bd' }} startIcon={<SwapHorizIcon/>}
            disabled={!dlgReasignarCoop.cooperativaId || !dlgReasignarCoop.motivo.trim()}
            onClick={handleReasignarCoop}>
            Confirmar reasignación
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Reactivar ABANDONADA (SuperAdmin) ── */}
      <Dialog open={dlgReactivar.open} onClose={()=>!dlgReactivar.enviando && setDlgReactivar(DLG_REACTIVAR_INIT)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color:'#2e7d32', fontWeight:700, display:'flex', alignItems:'center', gap:1 }}>
          {dlgReactivar.modo === 'recalcular'
            ? <><CalculateIcon/> Recalcular estado de la solicitud</>
            : <><RestoreIcon/> Reactivar solicitud abandonada</>}
        </DialogTitle>
        <DialogContent>
          {dlgReactivar.loading || !dlgReactivar.info ? (
            <Box sx={{ display:'flex', justifyContent:'center', py:4 }}><CircularProgress size={28}/></Box>
          ) : (() => {
            const i = dlgReactivar.info;
            const d = i.diagnostico || {};
            const esRecalc = dlgReactivar.modo === 'recalcular';
            const destino = esRecalc ? i.estadoRecalculo : i.estadoDestino;
            const ok = (v) => v === true;
            const Item = ({ label, value, extra }) => (
              <Box sx={{ display:'flex', alignItems:'center', gap:1, py:0.4 }}>
                {ok(value)
                  ? <CheckCircleIcon sx={{ fontSize:18, color:'#2e7d32' }}/>
                  : <CancelIcon sx={{ fontSize:18, color:'#c62828' }}/>}
                <Typography sx={{ fontSize:'0.85rem' }}>{label}</Typography>
                {extra && <Typography sx={{ fontSize:'0.75rem', color:'#888' }}>{extra}</Typography>}
              </Box>
            );
            return (
              <>
                <Typography variant="body2" sx={{ color:'#444', mb:1.5 }}>
                  Solicitud <strong>#{i.afiliadoId}</strong> de <strong>{dlgReactivar.nombre}</strong> ({i.email || 'sin email'})
                </Typography>

                {esRecalc ? (
                  <Alert severity="info" sx={{ mb:2 }}>
                    Estado actual: <strong>{i.estadoActual}</strong>. Se ejecuta el mismo recálculo que al aprobar
                    documentos o finalizar la sesión (con sus notificaciones). Queda registrado en auditoría.
                  </Alert>
                ) : (
                <Alert severity="warning" sx={{ mb:2 }}>
                  <Typography sx={{ fontWeight:700, fontSize:'0.85rem', mb:0.5 }}>Causa del abandono</Typography>
                  <Typography sx={{ fontSize:'0.82rem' }}>
                    {i.causa || 'No hay registro del job para esta solicitud (pudo marcarse antes de existir la auditoría).'}
                  </Typography>
                  {i.fechaAbandono && (
                    <Typography sx={{ fontSize:'0.75rem', color:'#795548', mt:0.5 }}>
                      Marcada el {new Date(i.fechaAbandono).toLocaleString('es-CO', { dateStyle:'short', timeStyle:'short' })}
                    </Typography>
                  )}
                </Alert>
                )}

                <Typography sx={{ fontWeight:700, fontSize:'0.85rem', mb:0.5 }}>Avance actual</Typography>
                <Item label="Evaluación aprobada" value={d.evaluacionAprobada}/>
                <Item label="Correo confirmado" value={d.emailConfirmado}
                  extra={d.emailConfirmado == null ? '(sin usuario asociado)' : null}/>
                <Item label="Pago de inscripción confirmado" value={d.pagoConfirmado}/>
                <Item label="Sesión de orientación realizada" value={d.orientacionRealizada}/>
                <Item label={`Documentos aprobados (${d.docsAprobados ?? 0}/${d.docsRequeridos ?? 6})`}
                  value={(d.docsFaltantes || []).length === 0}
                  extra={(d.docsFaltantes || []).length ? `Faltan: ${d.docsFaltantes.join(', ')}` : null}/>
                <Item label="Usuario activo con rol Afiliado" value={ok(d.usuarioActivo) && ok(d.rolAfiliado)}/>

                <Alert severity={destino === 'ACTIVO' ? 'success' : 'info'} sx={{ mt:2, mb:2 }}>
                  {esRecalc && destino === i.estadoActual
                    ? <>No cambiará de estado: aún no cumple evaluación + sesión realizada + 6 documentos aprobados.</>
                    : <>{esRecalc ? 'Al recalcular' : 'Al reactivar'} quedará en estado <strong>{destino}</strong>.</>}
                  {!esRecalc && destino !== 'ACTIVO' && (d.emailConfirmado === false || !d.pagoConfirmado) && (
                    <> Si la causa no se corrige (correo o pago), el job la volverá a marcar ABANDONADA.</>
                  )}
                </Alert>

                <TextField fullWidth multiline rows={2} size="small" label={esRecalc ? 'Motivo del recálculo' : 'Motivo de la reactivación'}
                  value={dlgReactivar.motivo} onChange={e=>setDlgReactivar(p=>({...p,motivo:e.target.value}))}/>
              </>
            );
          })()}
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>setDlgReactivar(DLG_REACTIVAR_INIT)} disabled={dlgReactivar.enviando}>Cancelar</Button>
          <Button variant="contained" sx={{ background:'#2e7d32' }} startIcon={<RestoreIcon/>}
            onClick={handleReactivar}
            disabled={dlgReactivar.loading || !dlgReactivar.info || dlgReactivar.enviando
              || (dlgReactivar.modo === 'recalcular' && dlgReactivar.info?.estadoRecalculo === dlgReactivar.info?.estadoActual)}>
            {dlgReactivar.enviando ? 'Procesando…' : dlgReactivar.modo === 'recalcular' ? 'Recalcular' : 'Reactivar'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Reevaluar ── */}
      <Dialog open={dlgReevaluar.open} onClose={()=>setDlgReevaluar({open:false,id:null,nombre:'',motivo:''})} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ color:'#e65100', fontWeight:700, display:'flex', alignItems:'center', gap:1 }}>
          <ReplayIcon/> Reevaluar solicitud
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ color:'#666', mb:2 }}>
            La solicitud de <strong>{dlgReevaluar.nombre}</strong> volvera al estado <strong>EN EVALUACION</strong>. Indique el motivo (opcional).
          </Typography>
          <TextField fullWidth multiline rows={3} size="small" label="Motivo (opcional)"
            value={dlgReevaluar.motivo} onChange={e=>setDlgReevaluar(p=>({...p,motivo:e.target.value}))}/>
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>setDlgReevaluar({open:false,id:null,nombre:'',motivo:''})}>Cancelar</Button>
          <Button variant="contained" sx={{ background:'#e65100' }} startIcon={<ReplayIcon/>} onClick={handleReevaluar}>
            Confirmar reevaluacion
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Eliminar Completo ── */}
      <Dialog open={dlgEliminarCompleto.open} onClose={()=>setDlgEliminarCompleto({open:false,id:null,nombre:'',motivo:''})} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ color:'#b71c1c', fontWeight:700, display:'flex', alignItems:'center', gap:1 }}>
          <DeleteForeverIcon/> Eliminar solicitud completa
        </DialogTitle>
        <DialogContent>
          <Alert severity="error" sx={{ mb:2, fontSize:'0.82rem' }}>
            Esta acción es <strong>irreversible</strong>. Se eliminarán todos los datos del afiliado, documentos, sesiones y usuario del sistema. Solo quedará registro en auditoría.
          </Alert>
          <Typography variant="body2" sx={{ color:'#666', mb:2 }}>
            ¿Confirma eliminar completamente a <strong>{dlgEliminarCompleto.nombre}</strong>?
          </Typography>
          <TextField fullWidth multiline rows={3} size="small" label="Motivo (obligatorio)"
            value={dlgEliminarCompleto.motivo} onChange={e=>setDlgEliminarCompleto(p=>({...p,motivo:e.target.value}))}/>
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>setDlgEliminarCompleto({open:false,id:null,nombre:'',motivo:''})}>Cancelar</Button>
          <Button variant="contained" color="error" startIcon={<DeleteForeverIcon/>}
            disabled={!dlgEliminarCompleto.motivo.trim()}
            onClick={handleEliminarCompleto}>
            Eliminar permanentemente
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Activar Acceso al Portal ── */}
      <Dialog open={dlgActivarAcceso.open} onClose={()=>!activandoAcceso && setDlgActivarAcceso({open:false,id:null,nombre:'',motivo:''})} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color:'#2e7d32', fontWeight:700, display:'flex', alignItems:'center', gap:1 }}>
          <LockOpenIcon/> Activar acceso al portal
        </DialogTitle>
        <DialogContent>
          <Alert severity="info" sx={{ mb: 2 }}>
            Estás por <strong>activar el acceso</strong> de <strong>{dlgActivarAcceso.nombre}</strong> al portal.
            El afiliado ya completó el pago, la sesión de orientación y sus documentos fueron aprobados.
          </Alert>
          <Typography variant="body2" sx={{ mb: 1 }}>Al activar:</Typography>
          <Box component="ul" sx={{ pl: 3, fontSize:'0.85rem', color:'#555' }}>
            <li>Se habilitará el <strong>login del afiliado</strong>.</li>
            <li>Se auto-otorgará acceso a <strong>Marketplace (b2b)</strong>.</li>
            <li>Se enviará un correo con instrucciones para crear su contraseña.</li>
            <li>Se registrará en <strong>auditoría</strong>.</li>
          </Box>
          <TextField fullWidth multiline rows={2} sx={{ mt: 2 }}
            label="Motivo o notas (opcional)" value={dlgActivarAcceso.motivo}
            onChange={e=>setDlgActivarAcceso(s=>({...s, motivo:e.target.value}))}
            disabled={activandoAcceso}
            placeholder="Ej: Todos los requisitos verificados."/>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>setDlgActivarAcceso({open:false,id:null,nombre:'',motivo:''})} disabled={activandoAcceso}>
            Cancelar
          </Button>
          <Button variant="contained" color="success"
            startIcon={activandoAcceso ? <CircularProgress size={16} color="inherit"/> : <LockOpenIcon/>}
            disabled={activandoAcceso}
            onClick={async () => {
              setActivandoAcceso(true);
              try {
                await activarAccesoAfiliado(dlgActivarAcceso.id, dlgActivarAcceso.motivo);
                toast('Acceso activado. Se envió correo al afiliado.');
                setDlgActivarAcceso({open:false,id:null,nombre:'',motivo:''});
                cargarAfiliaciones();
              } catch (e) {
                toast(e?.message || 'No se pudo activar el acceso', 'error');
              } finally {
                setActivandoAcceso(false);
              }
            }}>
            {activandoAcceso ? 'Activando…' : 'Activar acceso'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Dialog Eliminar Sesion ── */}
      <Dialog open={dlgEliminarSesion.open} onClose={()=>setDlgEliminarSesion({open:false,id:null,nombre:'',motivo:''})} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ color:'#6a1b9a', fontWeight:700, display:'flex', alignItems:'center', gap:1 }}>
          <EventBusyIcon/> Eliminar sesion de orientacion
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ color:'#666', mb:2 }}>
            Se eliminara la sesion programada de <strong>{dlgEliminarSesion.nombre}</strong>. El afiliado podra volver a agendar. Indique el motivo (opcional).
          </Typography>
          <TextField fullWidth multiline rows={3} size="small" label="Motivo (opcional)"
            value={dlgEliminarSesion.motivo} onChange={e=>setDlgEliminarSesion(p=>({...p,motivo:e.target.value}))}/>
        </DialogContent>
        <DialogActions sx={{ px:3, pb:2 }}>
          <Button onClick={()=>setDlgEliminarSesion({open:false,id:null,nombre:'',motivo:''})}>Cancelar</Button>
          <Button variant="contained" sx={{ background:'#6a1b9a' }} startIcon={<EventBusyIcon/>} onClick={handleEliminarSesion}>
            Confirmar eliminacion
          </Button>
        </DialogActions>
      </Dialog>

      {/* ════ MODAL DETALLE COMPLETO DE SOLICITUD ════ */}
      <Dialog open={dlgDetalle.open} onClose={()=>setDlgDetalle({open:false,id:null,data:null,loading:false})}
        maxWidth="md" fullWidth PaperProps={{ sx:{ borderRadius:2.5, overflow:'hidden' } }}>
        {dlgDetalle.loading && (
          <Box sx={{ textAlign:'center', py:8 }}><CircularProgress/><Typography sx={{ mt:2, color:'#888' }}>Cargando datos…</Typography></Box>
        )}
        {!dlgDetalle.loading && dlgDetalle.data && (() => {
          const d = dlgDetalle.data;
          const ESTADO_COLOR = { ACTIVO:'success', PENDIENTE:'warning', RECHAZADO:'error', SUSPENDIDO:'default' };
          const fmtD = v => v ? new Date(v+'T00:00:00').toLocaleDateString('es-CO',{day:'2-digit',month:'long',year:'numeric'}) : '—';

          // Reconstruir objeto form-like para el PDF
          const formPdf = {
            nombre: d.nombres, apellidos: d.apellidos, cedula: d.documento,
            cedulaExpedida: d.documentoExpedidoEn||'', fechaNacimiento: d.fechaNacimiento,
            genero: d.genero||'', estadoCivil: d.estadoCivil||'', codigoAlfaNum: d.codigoAlfaNumerico||'',
            email: d.email||'', celular: d.telefono||'', celular2: d.telefono2||'',
            paisId: null, departamentoId: null, municipioId: null,
            direccion: d.direccion||'', codigoPostal: d.codigoPostal||'',
            modalidadAporte: d.modalidadAporte||'DINERO', fechaPrimeraCuota: d.fechaPrimeraCuota,
            beneficiarios: (d.beneficiarios||[]).map(b=>({ nombres:b.nombres, apellidos:b.apellidos, cedula:b.documento||'', contacto:b.contacto||'' })),
          };
          const geoPdf = { pais:'Colombia', departamento: d.departamento||'', municipio: d.municipio||'' };

          const SeccionLabel = ({children}) => (
            <Box sx={{ background:'linear-gradient(135deg,#1a4d2e,#2e7d32)', px:2, py:1, mb:1.5, borderRadius:1 }}>
              <Typography sx={{ color:'#fff', fontWeight:700, fontSize:'0.78rem', textTransform:'uppercase', letterSpacing:'0.06em' }}>{children}</Typography>
            </Box>
          );
          const Campo = ({label, value, mono=false}) => (
            <Box sx={{ mb:1.5 }}>
              <Typography variant="caption" sx={{ color:'#888', fontWeight:600, textTransform:'uppercase', fontSize:'0.65rem', letterSpacing:'0.06em' }}>{label}</Typography>
              <Typography sx={{ fontSize:'0.82rem', color:'#1a1a1a', fontFamily: mono ? 'monospace' : 'inherit', wordBreak:'break-all' }}>{value||'—'}</Typography>
            </Box>
          );

          return (
            <>
              {/* Header */}
              <Box sx={{ background:'linear-gradient(135deg,#1a4d2e,#2e7d32)', px:3, py:2, display:'flex', alignItems:'center', justifyContent:'space-between' }}>
                <Box>
                  <Typography sx={{ color:'#fff', fontWeight:700, fontSize:'1.05rem' }}>{d.nombres} {d.apellidos}</Typography>
                  <Box sx={{ display:'flex', gap:1, mt:0.5 }}>
                    <Chip label={`Afiliado #${String(d.afiliadoID).padStart(6,'0')}`} size="small" sx={{ background:'rgba(255,255,255,0.2)', color:'#fff', fontSize:'0.68rem' }}/>
                    <Chip label={d.estado} size="small" color={ESTADO_COLOR[d.estado]||'default'} sx={{ fontWeight:700, fontSize:'0.68rem' }}/>
                  </Box>
                </Box>
                <Box sx={{ display:'flex', gap:1 }}>
                  <Tooltip title="Formato FENAGRO APL">
                    <Button variant="outlined" size="small" startIcon={<PictureAsPdfIcon/>}
                      onClick={()=>{ const {descargarContratoPDF} = require('../utils/generarContratoPDF'); descargarContratoPDF(formPdf, d.afiliadoID, geoPdf, d.hashContrato); }}
                      sx={{ color:'#c8a84b', borderColor:'#c8a84b', fontSize:'0.7rem', '&:hover':{ background:'rgba(200,168,75,0.1)' } }}>
                      PDF FENAGRO
                    </Button>
                  </Tooltip>
                  {(() => {
                    const esCapellanes = !!coops.find(c => (c.siglas === 'CAPELLANES' || c.nombre?.toLowerCase().includes('capellanes')) && c.cooperativaID === d.cooperativaID);
                    return (
                      <Tooltip title={esCapellanes ? "Formato Alianza Solidaria de Capellanes" : "Solo disponible para afiliados de Capellanes"}>
                        <span>
                          <Button variant="outlined" size="small" startIcon={pdfCapLoading ? <CircularProgress size={12} color="inherit"/> : <PictureAsPdfIcon/>}
                            disabled={pdfCapLoading || !esCapellanes}
                            onClick={async ()=>{ setPdfCapLoading(true); try { await descargarContratoCapellanesPDF(formPdf,d.afiliadoID,geoPdf,d.hashContrato); } finally { setPdfCapLoading(false); } }}
                            sx={{ color: esCapellanes ? '#2e7d32' : '#bdbdbd', borderColor: esCapellanes ? '#2e7d32' : '#bdbdbd', fontSize:'0.7rem',
                              '&:hover':{ background: esCapellanes ? 'rgba(46,125,50,0.06)' : 'transparent' } }}>
                            {pdfCapLoading ? 'Generando…' : 'PDF Capellanes'}
                          </Button>
                        </span>
                      </Tooltip>
                    );
                  })()}
                  {/* Emitir código de canje — para solicitantes sin pago */}
                  <Tooltip title="Emitir código de canje para este solicitante (mecanismo alternativo al pago Wompi)">
                    <Button variant="outlined" size="small" startIcon={<RedeemIcon/>}
                      onClick={async () => {
                        if (!window.confirm(`¿Emitir un código de canje para ${d.nombres} ${d.apellidos}?\n\nEsto cambiará su rol de Visitante a Candidato y le enviará por email el código con su QR. Podrá comprar en aliados de la red hasta cumplir la política para asociarse.`)) return;
                        try {
                          const r = await emitirCodigoParaSolicitud(d.afiliadoID);
                          toast(`Código emitido: ${r.codigo}. Email enviado al candidato.`, 'success');
                        } catch (e) {
                          toast(e?.data?.mensaje || e.message || 'No se pudo emitir el código.', 'error');
                        }
                      }}
                      sx={{ color:'#c8a84b', borderColor:'#c8a84b', fontSize:'0.7rem', '&:hover':{ background:'rgba(200,168,75,0.1)' } }}>
                      Emitir código canje
                    </Button>
                  </Tooltip>
                  {/* Editar afiliado — solo SuperAdmin */}
                  {esSuperAdmin() && (
                    <Tooltip title="Editar datos del afiliado (auditado, propaga a usuario y otras afiliaciones)">
                      <Button variant="outlined" size="small" startIcon={<EditIcon/>}
                        onClick={() => setDlgEditarAfiliado({ open:true, afiliado:d })}
                        sx={{ color:'#fff', borderColor:'rgba(255,255,255,0.5)', fontSize:'0.7rem',
                          '&:hover':{ background:'rgba(255,255,255,0.1)', borderColor:'#fff' } }}>
                        Editar
                      </Button>
                    </Tooltip>
                  )}
                  <IconButton size="small" onClick={()=>setDlgDetalle({open:false,id:null,data:null,loading:false})} sx={{ color:'rgba(255,255,255,0.7)' }}>
                    <CancelIcon/>
                  </IconButton>
                </Box>
              </Box>

              <DialogContent sx={{ p:3 }}>
                <Grid container spacing={3}>
                  {/* Columna izquierda */}
                  <Grid item xs={12} md={6}>
                    <SeccionLabel>Identificación</SeccionLabel>
                    <Grid container spacing={0}>
                      <Grid item xs={6}><Campo label="Nombres" value={d.nombres}/></Grid>
                      <Grid item xs={6}><Campo label="Apellidos" value={d.apellidos}/></Grid>
                      <Grid item xs={6}><Campo label="Tipo documento" value={d.tipoDocumento||'CC'}/></Grid>
                      <Grid item xs={6}><Campo label="Documento" value={d.documento}/></Grid>
                      <Grid item xs={6}><Campo label="Expedida en" value={d.documentoExpedidoEn}/></Grid>
                      <Grid item xs={6}><Campo label="Fecha nacimiento" value={fmtD(d.fechaNacimiento)}/></Grid>
                      <Grid item xs={6}><Campo label="Género" value={({M:'Masculino',F:'Femenino',NB:'No binario',O:'Otro'})[d.genero]||d.genero}/></Grid>
                      <Grid item xs={6}><Campo label="Estado civil" value={d.estadoCivil}/></Grid>
                    </Grid>

                    <SeccionLabel>Contacto</SeccionLabel>
                    <Campo label="Email" value={d.email}/>
                    <Grid container spacing={0}>
                      <Grid item xs={6}><Campo label="Celular" value={d.telefono ? `+57 ${d.telefono}` : '—'}/></Grid>
                      <Grid item xs={6}><Campo label="Celular 2" value={d.telefono2 ? `+57 ${d.telefono2}` : '—'}/></Grid>
                    </Grid>

                    <SeccionLabel>Ubicación</SeccionLabel>
                    <Grid container spacing={0}>
                      <Grid item xs={6}><Campo label="Departamento" value={d.departamento}/></Grid>
                      <Grid item xs={6}><Campo label="Municipio" value={d.municipio}/></Grid>
                      <Grid item xs={9}><Campo label="Dirección" value={d.direccion}/></Grid>
                      <Grid item xs={3}><Campo label="Cód. postal" value={d.codigoPostal}/></Grid>
                    </Grid>
                  </Grid>

                  {/* Columna derecha */}
                  <Grid item xs={12} md={6}>
                    <SeccionLabel>Aportes y modalidad</SeccionLabel>
                    <Grid container spacing={0}>
                      <Grid item xs={12}><Campo label="Modalidad de aporte" value={({DINERO:'Dinero',TRABAJO:'Trabajo y servicios',BIENES:'Bienes en especie'})[d.modalidadAporte]||d.modalidadAporte}/></Grid>
                      <Grid item xs={4}><Campo label="Afil. cooperativa" value={'$75.000 COP'}/></Grid>
                      <Grid item xs={4}><Campo label="Afil. consumo colab." value={'$75.000 COP'}/></Grid>
                      <Grid item xs={4}><Campo label="Aporte mensual" value={'$400.000 COP'}/></Grid>
                      {d.fechaPrimeraCuota && <Grid item xs={12}><Campo label="Primera cuota estimada" value={fmtD(d.fechaPrimeraCuota)}/></Grid>}
                    </Grid>

                    <SeccionLabel>Beneficiarios designados</SeccionLabel>
                    {(d.beneficiarios||[]).length === 0
                      ? <Typography variant="caption" sx={{ color:'#aaa', display:'block', mb:2 }}>No se designaron beneficiarios.</Typography>
                      : (d.beneficiarios||[]).map((b,i)=>(
                        <Box key={b.beneficiarioID} sx={{ display:'flex', gap:2, py:1, borderBottom:'1px solid #f5f5f5' }}>
                          <Typography variant="caption" sx={{ color:'#bbb', minWidth:16 }}>{i+1}</Typography>
                          <Box sx={{ flexGrow:1 }}>
                            <Typography sx={{ fontWeight:600, fontSize:'0.8rem' }}>{b.nombres} {b.apellidos}</Typography>
                            <Typography variant="caption" sx={{ color:'#888' }}>{b.documento||'—'} · {b.contacto||'—'}</Typography>
                          </Box>
                        </Box>
                      ))
                    }

                    <SeccionLabel>Trazabilidad e integridad</SeccionLabel>
                    <Campo label="Estado de la solicitud" value={d.estado}/>
                    <Campo label="Fecha de solicitud" value={new Date(d.fechaCreacion).toLocaleString('es-CO',{day:'2-digit',month:'2-digit',year:'numeric',hour:'2-digit',minute:'2-digit'})}/>
                    <Campo label="IP de origen" value={d.ipOrigen}/>
                    {/* ── Documentos subidos ── */}
                    {d.urlDocIdentidad && (
                      <Box sx={{ mb:2 }}>
                        <SeccionLabel>Documento de Identidad</SeccionLabel>
                        <Box sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.5, border:'1px solid #e0e0e0', borderRadius:1.5, background:'#fafafa' }}>
                          <Box sx={{ fontSize:28 }}>🪪</Box>
                          <Box sx={{ flexGrow:1 }}>
                            <Typography sx={{ fontSize:'0.8rem', fontWeight:600, color:'#1a1a1a' }}>
                              Cédula de ciudadanía
                            </Typography>
                            <Typography variant="caption" sx={{ color:'#888', fontFamily:'monospace', fontSize:'0.65rem' }}>
                              {d.urlDocIdentidad}
                            </Typography>
                          </Box>
                          <Button
                            size="small" variant="contained"
                            disabled={docUrlLoading}
                            startIcon={docUrlLoading ? <CircularProgress size={12} color="inherit"/> : <VisibilityIcon fontSize="small"/>}
                            onClick={async () => {
                              setDocUrlLoading(true);
                              try {
                                const resp = await getUrlFirmadaDocumento(d.urlDocIdentidad);
                                setVisorDoc({
                                  open: true,
                                  url: resp.url,
                                  titulo: `Documento de identidad — ${d.tipoDocumento || 'Cédula'}`,
                                  nombre: `${d.nombres} ${d.apellidos}`,
                                });
                              } catch (e) {
                                alert('No se pudo generar el enlace: ' + (e?.data?.mensaje || e.message));
                              } finally { setDocUrlLoading(false); }
                            }}
                            sx={{ background:'linear-gradient(135deg,#1a4d2e,#2e7d32)', fontSize:'0.72rem', whiteSpace:'nowrap', '&:hover':{ background:'#143d22' } }}>
                            Ver documento
                          </Button>
                        </Box>
                      </Box>
                    )}

                    <Campo label="Hash SHA-256 del contrato" value={d.hashContrato} mono={true}/>
                    {d.hashContrato && (
                      <Box sx={{ background:'#e8f5e9', border:'1px solid #c8e6c9', borderRadius:1.5, p:1.5, mt:0.5 }}>
                        <Box sx={{ display:'flex', gap:1, alignItems:'center' }}>
                          <FingerprintIcon sx={{ fontSize:18, color:'#2e7d32' }}/>
                          <Typography variant="caption" sx={{ color:'#2e7d32', fontWeight:600 }}>
                            Contrato con huella digital — cualquier alteración posterior cambia este hash
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Grid>
                </Grid>

                {/* ── Documentos de vinculación ── */}
                {docsAfiliado && (
                  <Box sx={{ px:3, pb:2, mt:1 }}>
                    <SeccionLabel>Documentos de Vinculación ({docsAfiliado.docs?.length || 0}/6)</SeccionLabel>
                    {docsAfiliado.tiposFaltantes?.length > 0 && (
                      <Alert severity="warning" sx={{ mb:1.5, fontSize:'0.75rem' }}>
                        Faltan: {docsAfiliado.tiposFaltantes.map(t => t.replace(/_/g,' ')).join(', ')}
                      </Alert>
                    )}
                    {(docsAfiliado.docs || []).map(doc => {
                      const TIPO_LABEL = { cedula:'Cédula', rut:'RUT', antecedentes_procuraduria:'Procuraduría',
                        antecedentes_contraloria:'Contraloría', antecedentes_policia:'Policía', bancario:'Bancario' };
                      const estadoColor = { APROBADO:'#2e7d32', RECHAZADO:'#c62828', PENDIENTE:'#e65100' };
                      return (
                        <Box key={doc.documentoID} sx={{ display:'flex', alignItems:'center', gap:1.5, p:1.2,
                          mb:0.8, border:'1px solid #e0e0e0', borderRadius:1.5,
                          borderLeft:`4px solid ${estadoColor[doc.estado]||'#e0e0e0'}`,
                          background: doc.estado === 'APROBADO' ? '#f0fdf0' : doc.estado === 'RECHAZADO' ? '#fff5f5' : '#fffbf0' }}>
                          <Box sx={{ flexGrow:1 }}>
                            <Box sx={{ display:'flex', gap:1, alignItems:'center' }}>
                              <Typography sx={{ fontWeight:700, fontSize:'0.78rem' }}>
                                {TIPO_LABEL[doc.tipoDocumento] || doc.tipoDocumento}
                              </Typography>
                              <Chip label={doc.estado} size="small"
                                sx={{ height:17, fontSize:'0.6rem', fontWeight:700,
                                  background: estadoColor[doc.estado]+'22', color: estadoColor[doc.estado] }}/>
                              {doc.confianzaOcr && (
                                <Chip label={`${doc.confianzaOcr}% OCR`} size="small"
                                  sx={{ height:17, fontSize:'0.6rem', background:'#e3f2fd', color:'#1565c0' }}/>
                              )}
                            </Box>
                            <Typography variant="caption" sx={{ color:'#888' }}>{doc.nombreArchivo}</Typography>
                            {doc.notasAdmin && <Typography variant="caption" sx={{ color:'#c62828', display:'block' }}>Nota: {doc.notasAdmin}</Typography>}
                            {doc.tipoDocumento === 'antecedentes_contraloria' && doc.estado === 'PENDIENTE' && (
                              <Button size="small" variant="text"
                                onClick={() => window.open('https://www.contraloria.gov.co/web/guest/consulta-certificado', '_blank')}
                                sx={{ p:0, fontSize:'0.68rem', color:'#1565c0' }}>
                                🔗 Verificar en portal Contraloría →
                              </Button>
                            )}
                          </Box>
                          <Box sx={{ display:'flex', gap:0.5 }}>
                            <Tooltip title="Ver documento">
                              <IconButton size="small" sx={{ color:'#1565c0' }}
                                onClick={async () => {
                                  try {
                                    const r = await getUrlFirmadaDocumento(doc.urlStorage);
                                    const TIPO_LABEL_V = { cedula:'Cédula', rut:'RUT', antecedentes_procuraduria:'Procuraduría',
                                      antecedentes_contraloria:'Contraloría', antecedentes_policia:'Policía', bancario:'Certificado bancario' };
                                    setVisorDoc({
                                      open: true,
                                      url: r.url,
                                      titulo: TIPO_LABEL_V[doc.tipoDocumento] || doc.tipoDocumento,
                                      nombre: `${d.nombres} ${d.apellidos}`,
                                    });
                                  } catch { alert('No se pudo abrir el documento'); }
                                }}>
                                <VisibilityIcon fontSize="small"/>
                              </IconButton>
                            </Tooltip>
                            {doc.estado !== 'APROBADO' && puedeAprobarRechazar() && (
                              <Tooltip title="Aprobar">
                                <IconButton size="small" sx={{ color:'#2e7d32' }}
                                  disabled={revisandoDoc === doc.documentoID}
                                  onClick={async () => {
                                    setRevisandoDoc(doc.documentoID);
                                    await revisarDocumento(doc.documentoID, { aprobar:true, adminId: user?.id });
                                    const r = await getDocumentosAfiliado(d.afiliadoID);
                                    setDocsAfiliado(r);
                                    setRevisandoDoc(null);
                                    toast('Documento aprobado');
                                  }}>
                                  <CheckCircleIcon fontSize="small"/>
                                </IconButton>
                              </Tooltip>
                            )}
                            {doc.estado !== 'RECHAZADO' && puedeAprobarRechazar() && (
                              <Tooltip title="Rechazar">
                                <IconButton size="small" sx={{ color:'#c62828' }}
                                  disabled={revisandoDoc === doc.documentoID}
                                  onClick={async () => {
                                    const nota = window.prompt('Motivo del rechazo (opcional):');
                                    setRevisandoDoc(doc.documentoID);
                                    await revisarDocumento(doc.documentoID, { aprobar:false, notas:nota, adminId: user?.id });
                                    const r = await getDocumentosAfiliado(d.afiliadoID);
                                    setDocsAfiliado(r);
                                    setRevisandoDoc(null);
                                    toast('Documento rechazado');
                                  }}>
                                  <CancelIcon fontSize="small"/>
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </Box>
                      );
                    })}
                    {docsAfiliado.todosAprobados && (
                      <Alert severity="success" sx={{ mt:1, fontSize:'0.75rem' }}>
                        ✅ Todos los documentos aprobados — el afiliado puede completar la vinculación
                      </Alert>
                    )}
                  </Box>
                )}

                {/* ── Sesión de orientación ── */}
                <Box sx={{ px:3, pb:2 }}>
                  <Box sx={{ display:'flex', alignItems:'center', justifyContent:'space-between', mb:1 }}>
                    <SeccionLabel>Sesión de Orientación (Paso 3)</SeccionLabel>
                    <Button size="small" variant="outlined" sx={{ color:'#1a4d2e', borderColor:'#1a4d2e', fontSize:'0.7rem' }}
                      onClick={() => setDlgSesion(true)}>
                      {sesionesAf.length > 0 ? 'Reagendar sesión' : 'Agendar sesión'}
                    </Button>
                  </Box>
                  {sesionesAf.length === 0 ? (
                    <Typography variant="caption" sx={{ color:'#bbb' }}>Sin sesión registrada aún</Typography>
                  ) : sesionesAf.map(s => (
                    <Box key={s.sesionID} sx={{ p:1.5, border:'1px solid #e0e0e0', borderRadius:1.5,
                      borderLeft:`4px solid ${s.estado==='REALIZADA'?'#2e7d32':'#e65100'}` }}>
                      <Box sx={{ display:'flex', gap:1, mb:0.5 }}>
                        <Chip label={s.estado} size="small"
                          sx={{ height:18, fontSize:'0.62rem', fontWeight:700,
                            background: s.estado==='REALIZADA'?'#e8f5e9':'#fff3e0',
                            color: s.estado==='REALIZADA'?'#2e7d32':'#e65100' }}/>
                        {s.medioSesion && <Chip label={s.medioSesion} size="small" sx={{ height:18, fontSize:'0.62rem', background:'#e3f2fd', color:'#1565c0' }}/>}
                        {s.duracionMin && <Typography variant="caption" sx={{ color:'#888' }}>{s.duracionMin} min</Typography>}
                      </Box>
                      {s.fechaSesion && <Typography variant="caption" sx={{ color:'#555', display:'block' }}>Fecha: {new Date(s.fechaSesion).toLocaleDateString('es-CO')}</Typography>}
                      {s.urlGrabacion && (
                        <Button size="small" variant="text" sx={{ fontSize:'0.7rem', color:'#1565c0', p:0, mt:0.5 }}
                          onClick={() => window.open(s.urlGrabacion, '_blank')}>
                          🎥 Ver grabación
                        </Button>
                      )}
                      {s.notasAdmin && <Typography variant="caption" sx={{ color:'#555', display:'block', mt:0.3 }}>Notas: {s.notasAdmin}</Typography>}
                      {s.estado !== 'REALIZADA' && (
                        <Button size="small" variant="contained"
                          sx={{ mt:1, fontSize:'0.7rem', background:'#2e7d32', '&:hover':{ background:'#1b5e20' } }}
                          onClick={async () => {
                            try {
                              await gestionarSesion(s.sesionID, { accion: 'FINALIZAR', notas: 'Marcada como realizada desde panel admin' });
                              setSesionesAf(prev => prev.map(x => x.sesionID === s.sesionID ? { ...x, estado: 'REALIZADA' } : x));
                            } catch(e) { alert('Error al marcar sesión como realizada'); }
                          }}>
                          ✓ Marcar como realizada
                        </Button>
                      )}
                    </Box>
                  ))}
                </Box>

              </DialogContent>

              <DialogActions sx={{ px:3, py:2, borderTop:'1px solid #f0f0f0', justifyContent:'space-between' }}>
                <Box sx={{ display:'flex', gap:1 }}>
                  {d.estado === 'PENDIENTE' && puedeAprobarRechazar() && (<>
                    <Button variant="contained" color="success" startIcon={<CheckCircleIcon/>}
                      onClick={()=>{ handleAprobar(d.afiliadoID,`${d.nombres} ${d.apellidos}`); setDlgDetalle({open:false,id:null,data:null,loading:false}); }}>
                      Aprobar
                    </Button>
                    <Button color="error" startIcon={<CancelIcon/>}
                      onClick={()=>{ setDlgDetalle({open:false,id:null,data:null,loading:false}); setDlgRechazar({open:true,id:d.afiliadoID,motivo:''}); }}>
                      Rechazar
                    </Button>
                  </>)}
                </Box>
                <Button onClick={()=>setDlgDetalle({open:false,id:null,data:null,loading:false})}>Cerrar</Button>
              </DialogActions>
            </>
          );
        })()}
      </Dialog>

      <VisorDocumentoSeguro
        open={visorDoc.open}
        onClose={() => setVisorDoc(p => ({ ...p, open: false }))}
        urlDocumento={visorDoc.url}
        titulo={visorDoc.titulo}
        nombreAfiliado={visorDoc.nombre}
        permitirDescarga={false}
      />

      <CrearUsuarioDialog
        open={dlgCrearUser}
        onClose={() => setDlgCrearUser(false)}
        onCreado={(res) => {
          toast(`✅ Usuario ${res.email} creado con roles: ${res.roles.join(', ')}`);
          cargarUsuarios();
        }}
      />

      <DialogCarnet
        open={dlgCarnet.open}
        onClose={() => setDlgCarnet({ open:false, carnet:null, fotoUrl:null })}
        carnet={dlgCarnet.carnet}
        fotoUrl={dlgCarnet.fotoUrl}
      />

      {/* Edición administrativa del afiliado (solo SuperAdmin) */}
      <EditarAfiliadoDialog
        open={dlgEditarAfiliado.open}
        afiliado={dlgEditarAfiliado.afiliado}
        onClose={() => setDlgEditarAfiliado({ open:false, afiliado:null })}
        onToast={toast}
        onGuardado={async () => {
          // Refrescar los datos del modal padre con los cambios recién guardados
          if (dlgDetalle.id) {
            try {
              setDlgDetalle(p => ({ ...p, loading:true }));
              const data = await getDetalleAfiliado(dlgDetalle.id);
              setDlgDetalle({ open:true, id:dlgDetalle.id, data, loading:false });
            } catch { setDlgDetalle(p => ({ ...p, loading:false })); }
          }
          // Refrescar la lista para que el nuevo valor aparezca en la tabla
          cargarAfiliaciones?.();
        }}
      />

      <Snackbar open={snack.open} autoHideDuration={4000} onClose={()=>setSnack(p=>({...p,open:false}))}
        anchorOrigin={{ vertical:'bottom', horizontal:'center' }}>
        <Alert severity={snack.sev} onClose={()=>setSnack(p=>({...p,open:false}))} sx={{ fontWeight:600 }}>
          {snack.msg}
        </Alert>
      </Snackbar>
    </Box>
  );
}

// ─────────────────────────────────────────────────────────────────────
// FotoUsuarioAdmin — Avatar + botones subir/eliminar foto en dialog edit
// ─────────────────────────────────────────────────────────────────────
function FotoUsuarioAdmin({ user, onChanged, onToast }) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  if (!user?.Id && !user?.id) return null;
  const userId = user.Id || user.id;
  const initials = ((user.Nombre?.[0] || user.nombre?.[0] || '') +
                    (user.Apellido?.[0] || user.apellido?.[0] || '')).toUpperCase();
  const fotoUrl = user.fotoUrl;

  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (f.size > 2 * 1024 * 1024) { onToast('La foto no puede superar los 2 MB', 'error'); return; }
    if (!['image/jpeg','image/png'].includes(f.type)) { onToast('Solo JPG o PNG', 'error'); return; }

    setBusy(true);
    try {
      const r = await subirFotoUsuario(userId, f);
      onChanged(r.fotoUrl, r.fotoUri);
      onToast('Foto actualizada');
    } catch (err) {
      onToast(err?.data?.mensaje || 'Error subiendo foto', 'error');
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  const eliminar = async () => {
    if (!window.confirm('¿Eliminar la foto del usuario?')) return;
    setBusy(true);
    try {
      await eliminarFotoUsuario(userId);
      onChanged(null, null);
      onToast('Foto eliminada');
    } catch (err) {
      onToast(err?.data?.mensaje || 'Error', 'error');
    } finally { setBusy(false); }
  };

  return (
    <Box sx={{ display:'flex', flexDirection:'column', alignItems:'center', gap:1 }}>
      <Avatar
        src={fotoUrl || undefined}
        sx={{
          width:90, height:110, borderRadius:1.5,
          background:'linear-gradient(135deg,#1a4d2e,#43a047)',
          color:'#fff', fontWeight:700, fontSize:'1.8rem',
          border:'2px solid #fff',
          boxShadow:'0 2px 8px rgba(0,0,0,0.12)',
        }}
        variant="rounded"
      >
        {initials}
      </Avatar>
      <input ref={fileRef} type="file" accept="image/jpeg,image/png"
        onChange={onFile} style={{ display:'none' }}/>
      <Box sx={{ display:'flex', gap:0.5 }}>
        <Tooltip title={fotoUrl ? 'Cambiar foto' : 'Subir foto'}>
          <span>
            <IconButton size="small" disabled={busy} onClick={() => fileRef.current?.click()}
              sx={{ color:'#2e7d32' }}>
              {busy ? <CircularProgress size={16}/> : <PhotoCameraIcon fontSize="small"/>}
            </IconButton>
          </span>
        </Tooltip>
        {fotoUrl && (
          <Tooltip title="Eliminar foto">
            <span>
              <IconButton size="small" disabled={busy} onClick={eliminar}
                sx={{ color:'#b71c1c' }}>
                <DeleteOutlineIcon fontSize="small"/>
              </IconButton>
            </span>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
}

// ─────────────────────────────────────────────────────────────────────
// TabCarnetAdmin — pestaña Carnet dentro del dialog de editar usuario
// Muestra el carnet inline si existe, o un aviso + botón generar si no.
// ─────────────────────────────────────────────────────────────────────
function TabCarnetAdmin({ userId, userNombre, cooperativasElegibles = [], onGenerar, generando }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  // Cooperativa seleccionada para visualizar carnet. Por defecto: principal o la primera.
  const [coopSeleccionada, setCoopSeleccionada] = useState(
    cooperativasElegibles.find(c => c.esPrincipal)?.cooperativaID
    || cooperativasElegibles[0]?.cooperativaID
    || null
  );
  const cardRef = useRef(null);

  const recargar = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const d = await getCarnetActivoUsuario(userId, coopSeleccionada);
      setData(d);
    } catch (err) {
      setData({ tieneCarnet: false, mensaje: err?.data?.mensaje || 'Error consultando carnet' });
    } finally { setLoading(false); }
  }, [userId, coopSeleccionada]);

  useEffect(() => { recargar(); }, [recargar]);

  // Re-cargar después de generar
  useEffect(() => {
    if (!generando && userId) {
      const t = setTimeout(() => recargar(), 300);
      return () => clearTimeout(t);
    }
  }, [generando, userId, recargar]);

  const hayMultiples = cooperativasElegibles.length > 1;

  return (
    <Box>
      {/* Selector de cooperativa cuando hay varias */}
      {hayMultiples && (
        <Box sx={{ mb:2.5 }}>
          <Typography sx={{ fontSize:'0.8rem', fontWeight:600, color:'#555', mb:1 }}>
            Carnet por cooperativa
          </Typography>
          <Box sx={{ display:'flex', gap:1, flexWrap:'wrap' }}>
            {cooperativasElegibles.map(c => (
              <Chip
                key={c.cooperativaID}
                label={c.siglas}
                clickable
                onClick={()=>setCoopSeleccionada(c.cooperativaID)}
                color={coopSeleccionada === c.cooperativaID ? 'primary' : 'default'}
                variant={coopSeleccionada === c.cooperativaID ? 'filled' : 'outlined'}
                sx={{ fontWeight:600 }}
              />
            ))}
          </Box>
        </Box>
      )}

      {loading ? (
        <Box sx={{ textAlign:'center', py:4 }}><CircularProgress size={28} sx={{ color:'#2e7d32' }}/></Box>
      ) : !data?.tieneCarnet ? (
        <Box>
          <Alert severity="info" sx={{ mb:3, fontSize:'0.88rem' }}>
            <strong>{userNombre} aún no tiene carnet generado{hayMultiples ? ' para esta cooperativa' : ''}.</strong>
            <br/>
            {data?.mensaje || 'Puede generar el carnet ahora. Tendrá vigencia de 12 meses.'}
          </Alert>
          <Box sx={{ textAlign:'center' }}>
            <Button
              variant="contained"
              size="large"
              startIcon={generando ? <CircularProgress size={18} color="inherit"/> : <BadgeIcon/>}
              onClick={()=>onGenerar(coopSeleccionada)}
              disabled={generando || !coopSeleccionada}
              sx={{
                background:'linear-gradient(135deg, #2e7d32, #43a047)',
                fontWeight:700, px:4, py:1.4,
              }}
            >
              {generando ? 'Generando…' : 'Generar carnet'}
            </Button>
          </Box>
        </Box>
      ) : (
        <Box>
          <Alert severity="success" sx={{ mb:3 }}>
            Carnet vigente, estado <strong>{data.carnet.estado}</strong>. Vigencia hasta el{' '}
            {new Date(data.carnet.fechaVigencia).toLocaleDateString('es-CO', { day:'2-digit', month:'long', year:'numeric' })}.
          </Alert>

          <Box sx={{ display:'flex', justifyContent:'center', mb:3 }}>
            <CarnetCardConSelector
              carnet={data.carnet}
              onCardRef={(el) => { cardRef.current = el; }}
            />
          </Box>

          <Box sx={{ display:'flex', justifyContent:'center', gap:1.5, flexWrap:'wrap' }}>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon/>}
              onClick={() => descargarCarnetPng(cardRef.current, data.carnet.codigo)}
              sx={{ color:'#2e7d32', borderColor:'#2e7d32', fontWeight:600 }}
            >
              Descargar PNG
            </Button>
            <Button
              variant="outlined"
              startIcon={<PrintIcon/>}
              onClick={() => imprimirCarnet(cardRef.current, data.carnet.codigo)}
              sx={{ color:'#2e7d32', borderColor:'#2e7d32', fontWeight:600 }}
            >
              Imprimir
            </Button>
            <Button
              variant="contained"
              startIcon={generando ? <CircularProgress size={16} color="inherit"/> : <BadgeIcon/>}
              onClick={()=>onGenerar(coopSeleccionada)}
              disabled={generando}
              sx={{ background:'linear-gradient(135deg, #1a4d2e, #2e7d32)', fontWeight:700 }}
            >
              {generando ? 'Regenerando…' : 'Regenerar carnet'}
            </Button>
          </Box>
        </Box>
      )}
    </Box>
  );
}
